export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
}

export type AusAnalysisData = {
  __typename?: 'AUSAnalysisData'
  ausReportId?: Maybe<Scalars['Int']['output']>
  automationPilotEnabled?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  d1cValidatedAssets?: Maybe<Scalars['String']['output']>
  d1cValidatedEmployment?: Maybe<Scalars['String']['output']>
  d1cValidatedIncome?: Maybe<Scalars['String']['output']>
  errorAnalysis?: Maybe<Scalars['JSON']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  extractData?: Maybe<Scalars['JSON']['output']>
  hybridAppraisalEligible?: Maybe<Scalars['Boolean']['output']>
  hybridAppraisalMessage?: Maybe<Scalars['String']['output']>
  isDuPlus?: Maybe<Scalars['Boolean']['output']>
  isSelected?: Maybe<Scalars['Boolean']['output']>
  lpaGuidance?: Maybe<LpaGuidance>
  piwEligible?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  vapdAppraisalMessage?: Maybe<Scalars['String']['output']>
  vapdContactSubmitted?: Maybe<Scalars['Boolean']['output']>
  vapdEligible?: Maybe<Scalars['Boolean']['output']>
}

export type AusAnalysisDataResponse = {
  __typename?: 'AUSAnalysisDataResponse'
  du?: Maybe<AusAnalysisData>
  duea?: Maybe<AusAnalysisData>
  lpa?: Maybe<AusAnalysisData>
}

export type AvmPropertyDetailsInput = {
  assessmentYear?: InputMaybe<Scalars['Int']['input']>
  confidenceScore?: InputMaybe<Scalars['Int']['input']>
  estimatedValue?: InputMaybe<Scalars['Int']['input']>
  firstMortgageAmount?: InputMaybe<Scalars['Float']['input']>
  firstMortgageType?: InputMaybe<Scalars['String']['input']>
  highValue?: InputMaybe<Scalars['Int']['input']>
  landUse?: InputMaybe<Scalars['String']['input']>
  lowValue?: InputMaybe<Scalars['Int']['input']>
  manualOverride?: InputMaybe<Scalars['Boolean']['input']>
  ownerName1?: InputMaybe<Scalars['String']['input']>
  ownerName2?: InputMaybe<Scalars['String']['input']>
  ownerOccupiedIndicator?: InputMaybe<Scalars['String']['input']>
  processedDate?: InputMaybe<Scalars['String']['input']>
  propertyTax?: InputMaybe<Scalars['Float']['input']>
  residentialUnits?: InputMaybe<Scalars['Int']['input']>
  saleDate?: InputMaybe<Scalars['String']['input']>
  salePrice?: InputMaybe<Scalars['Float']['input']>
  totalAssessedValue?: InputMaybe<Scalars['Float']['input']>
  yearBuilt?: InputMaybe<Scalars['Int']['input']>
  yearPurchased?: InputMaybe<Scalars['Int']['input']>
}

export type AvmPropertyDetailsSchema = {
  __typename?: 'AVMPropertyDetailsSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  assessmentYear?: Maybe<Scalars['Int']['output']>
  confidenceScore?: Maybe<Scalars['Int']['output']>
  coreLogicPropertyId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  estimatedValue?: Maybe<Scalars['Int']['output']>
  firstMortgageAmount?: Maybe<Scalars['Float']['output']>
  firstMortgageType?: Maybe<Scalars['String']['output']>
  highValue?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['Int']['output']>
  landUse?: Maybe<Scalars['String']['output']>
  lowValue?: Maybe<Scalars['Int']['output']>
  manualOverride?: Maybe<Scalars['Boolean']['output']>
  ownerName1?: Maybe<Scalars['String']['output']>
  ownerName2?: Maybe<Scalars['String']['output']>
  ownerOccupiedIndicator?: Maybe<Scalars['String']['output']>
  processedDate?: Maybe<Scalars['String']['output']>
  propertyTax?: Maybe<Scalars['Float']['output']>
  residentialUnits?: Maybe<Scalars['Int']['output']>
  saleDate?: Maybe<Scalars['String']['output']>
  salePrice?: Maybe<Scalars['Float']['output']>
  totalAssessedValue?: Maybe<Scalars['Float']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  yearBuilt?: Maybe<Scalars['Int']['output']>
  yearPurchased?: Maybe<Scalars['Int']['output']>
}

export type AccountLastFourDigits = {
  __typename?: 'AccountLastFourDigits'
  lastFourDigits?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type AddConditionInput = {
  category?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  documentRequests?: InputMaybe<Array<InputMaybe<DocumentRequestInput>>>
  expirationDate?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type: ConditionType
  uuid?: InputMaybe<Scalars['String']['input']>
}

export type AddressOutput = {
  __typename?: 'AddressOutput'
  apt?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  isAttached?: Maybe<Scalars['Boolean']['output']>
  moveInDate?: Maybe<Scalars['String']['output']>
  moveOutDate?: Maybe<Scalars['String']['output']>
  numberOfStories?: Maybe<Scalars['Int']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  type?: Maybe<AddressType>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type AddressRevisionSchema = {
  __typename?: 'AddressRevisionSchema'
  apt?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  county?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  isAttached?: Maybe<Scalars['Boolean']['output']>
  isMailingAddress?: Maybe<Scalars['Boolean']['output']>
  moveInDate?: Maybe<Scalars['String']['output']>
  moveOutDate?: Maybe<Scalars['String']['output']>
  numberOfStories?: Maybe<Scalars['Int']['output']>
  occupancyType?: Maybe<OccupancyType>
  rentAmount?: Maybe<Scalars['Float']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export enum AddressType {
  Current = 'current',
  Previous = 'previous',
}

export type AddressValidationInputSchema = {
  city?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type AddressValidationResponse = {
  __typename?: 'AddressValidationResponse'
  city?: Maybe<GoogleAddressComponent>
  county?: Maybe<Scalars['String']['output']>
  fipsCode?: Maybe<Scalars['String']['output']>
  isValid?: Maybe<Scalars['Boolean']['output']>
  state?: Maybe<GoogleAddressComponent>
  street?: Maybe<GoogleAddressComponent>
  streetNumber?: Maybe<GoogleAddressComponent>
  streetTwo?: Maybe<GoogleAddressComponent>
  unconfirmedComponents?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  zip?: Maybe<GoogleAddressComponent>
}

export type Adjustment = {
  __typename?: 'Adjustment'
  adjustmentSourceType?: Maybe<AdjustmentSourceType>
  adjustmentType?: Maybe<AdjustmentType>
  amount?: Maybe<Scalars['Float']['output']>
  filter?: Maybe<Scalars['String']['output']>
  isCompAdjustment?: Maybe<Scalars['Boolean']['output']>
  isHidden?: Maybe<Scalars['Boolean']['output']>
  isStop?: Maybe<Scalars['Boolean']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type AdjustmentInput = {
  adjustmentSourceType?: InputMaybe<AdjustmentSourceType>
  adjustmentType?: InputMaybe<AdjustmentType>
  amount?: InputMaybe<Scalars['Float']['input']>
  filter?: InputMaybe<Scalars['String']['input']>
  isCompAdjustment?: InputMaybe<Scalars['Boolean']['input']>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  isStop?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export enum AdjustmentSourceType {
  BusinessRule = 'BusinessRule',
  PricingRule = 'PricingRule',
  RateSheet = 'RateSheet',
}

export enum AdjustmentType {
  Cap = 'Cap',
  Margin = 'Margin',
  MaxRebate = 'MaxRebate',
  NotSpecified = 'NotSpecified',
  PostCap = 'PostCap',
  PostMaxRebate = 'PostMaxRebate',
  PreCap = 'PreCap',
  Rate = 'Rate',
  Stop = 'Stop',
}

export type AdminLead = {
  __typename?: 'AdminLead'
  address?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  applicationCreatedAt?: Maybe<Scalars['String']['output']>
  applicationDeletedAt?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  applicationRevisionCreatedAt?: Maybe<Scalars['String']['output']>
  applicationRevisionDeletedAt?: Maybe<Scalars['String']['output']>
  applicationRevisionId?: Maybe<Scalars['Int']['output']>
  applicationRevisionUpdatedAt?: Maybe<Scalars['String']['output']>
  applicationUpdatedAt?: Maybe<Scalars['String']['output']>
  bankrateLeadId?: Maybe<Scalars['String']['output']>
  besmarteeLoanId?: Maybe<Scalars['String']['output']>
  cashOut?: Maybe<Scalars['Int']['output']>
  city?: Maybe<Scalars['String']['output']>
  creditReportIdentifier?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  debtToIncome?: Maybe<Scalars['Float']['output']>
  declarationAlimony?: Maybe<Scalars['Boolean']['output']>
  declarationBankruptcy?: Maybe<Scalars['Boolean']['output']>
  declarationBorrowedDown?: Maybe<Scalars['Boolean']['output']>
  declarationBorrowedDownFundsAmount?: Maybe<Scalars['Int']['output']>
  declarationCitizen?: Maybe<Scalars['Boolean']['output']>
  declarationDependents?: Maybe<Scalars['Int']['output']>
  declarationEthnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationFHALoan?: Maybe<Scalars['Boolean']['output']>
  declarationForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationGender?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationHomeOwnership?: Maybe<Scalars['Boolean']['output']>
  declarationJudgements?: Maybe<Scalars['Boolean']['output']>
  declarationLawsuits?: Maybe<Scalars['Boolean']['output']>
  declarationLoanDefaults?: Maybe<Scalars['Boolean']['output']>
  declarationLoanForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationMilitary?: Maybe<Scalars['Boolean']['output']>
  declarationNoteEndorser?: Maybe<Scalars['Boolean']['output']>
  declarationPrimaryResidence?: Maybe<Scalars['Boolean']['output']>
  declarationPropertyTitle?: Maybe<Scalars['String']['output']>
  declarationPropertyType?: Maybe<Scalars['String']['output']>
  declarationRace?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationResident?: Maybe<Scalars['Boolean']['output']>
  declarationSchooling?: Maybe<Scalars['String']['output']>
  declarationVALoan?: Maybe<Scalars['Boolean']['output']>
  email?: Maybe<Scalars['String']['output']>
  expenseFirstMortgage?: Maybe<Scalars['Float']['output']>
  expenseHomeInsurance?: Maybe<Scalars['Float']['output']>
  expenseMortgageInsurance?: Maybe<Scalars['Float']['output']>
  expensePropertyTaxes?: Maybe<Scalars['Float']['output']>
  expenseRent?: Maybe<Scalars['Float']['output']>
  expenseSecondMortgage?: Maybe<Scalars['Float']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  iceBox?: Maybe<Scalars['Boolean']['output']>
  lastContactedAt?: Maybe<Scalars['String']['output']>
  lastContactedType?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  lastRingcentralContactedAt?: Maybe<Scalars['String']['output']>
  lastRingcentralContactedType?: Maybe<Scalars['String']['output']>
  leadId?: Maybe<Scalars['Int']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanOfficerId?: Maybe<Scalars['Int']['output']>
  loanOfficerName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<LoanPurpose>
  loanToValue?: Maybe<Scalars['Float']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  propertyDownPayment?: Maybe<Scalars['Float']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Float']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyUse?: Maybe<Scalars['String']['output']>
  propertyValue?: Maybe<Scalars['Int']['output']>
  propertyYearBuilt?: Maybe<Scalars['Int']['output']>
  propertyYearPurchased?: Maybe<Scalars['Int']['output']>
  proxyPhone?: Maybe<Scalars['String']['output']>
  remainingBalance?: Maybe<Scalars['Float']['output']>
  source?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  tridDaysLeft?: Maybe<Scalars['Int']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type AdminLeadInformation = {
  apt?: InputMaybe<Scalars['String']['input']>
  cashOut?: InputMaybe<Scalars['Float']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  currentAddressZipCode?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  estimatedValue?: InputMaybe<Scalars['Float']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  isCurrentAddress?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  leadSource: Scalars['String']['input']
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
  loanPurpose?: InputMaybe<LoanPurpose>
  phone: Scalars['String']['input']
  propertyDownPayment?: InputMaybe<Scalars['Float']['input']>
  propertyPurchasePrice?: InputMaybe<Scalars['Float']['input']>
  propertyType?: InputMaybe<PropertyType>
  propertyUse?: InputMaybe<PropertyUse>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  sourceLeadId: Scalars['String']['input']
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type AdminLoanOfficer = {
  __typename?: 'AdminLoanOfficer'
  NMLS?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  encompassId?: Maybe<Scalars['String']['output']>
  headshot?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  isLoanCoordinator?: Maybe<Scalars['Boolean']['output']>
  isManager?: Maybe<Scalars['Boolean']['output']>
  loanCoordinatorId?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  slackUserId?: Maybe<Scalars['String']['output']>
  slackUsername?: Maybe<Scalars['String']['output']>
  workdayId?: Maybe<Scalars['String']['output']>
}

export type ApplicationAnswers = {
  abadDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  addDependentAges?: InputMaybe<Array<InputMaybe<DependentAge>>>
  affiliatedBusinessArrangementDisclosure?: InputMaybe<
    Scalars['Boolean']['input']
  >
  agentCompany?: InputMaybe<Scalars['String']['input']>
  agentEmail?: InputMaybe<Scalars['String']['input']>
  agentFirstName?: InputMaybe<Scalars['String']['input']>
  agentLastName?: InputMaybe<Scalars['String']['input']>
  agentPhone?: InputMaybe<Scalars['String']['input']>
  applicationId?: InputMaybe<Scalars['Int']['input']>
  apt?: InputMaybe<Scalars['String']['input']>
  autoCompleteAddressFields?: InputMaybe<Scalars['String']['input']>
  buyBeforeYouSellAmount?: InputMaybe<Scalars['Float']['input']>
  buyBeforeYouSellApproved?: InputMaybe<Scalars['Boolean']['input']>
  cashOut?: InputMaybe<Scalars['Float']['input']>
  cashOutOptions?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  closingDate?: InputMaybe<Scalars['String']['input']>
  coBorrowerAddresses?: InputMaybe<Array<InputMaybe<CoBorrowerAddress>>>
  coBorrowerAffiliatedBusinessArrangementDisclosure?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerAuthorizationConsent?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerAuthorizationWithoutCreditConsent?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerCreditScore?: InputMaybe<Scalars['Int']['input']>
  coBorrowerDeclarationAlimony?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationBankrupt?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationBankruptcyType?: InputMaybe<BankruptcyTypes>
  coBorrowerDeclarationCitizen?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationConveyedTitle?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationDependents?: InputMaybe<Scalars['Int']['input']>
  coBorrowerDeclarationDownPaymentBorrowed?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerDeclarationDownPaymentBorrowedAmount?: InputMaybe<
    Scalars['Int']['input']
  >
  coBorrowerDeclarationEndorserNote?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationFHALoan?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationFederalDebt?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationForeclosed?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationForeclosedDirect?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerDeclarationLawsuit?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationMilitary?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationNewCredit?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationOutstandingJudgements?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerDeclarationOwnership?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationPrimaryResidence?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerDeclarationPropertyTitle?: InputMaybe<Scalars['String']['input']>
  coBorrowerDeclarationPropertyType?: InputMaybe<Scalars['String']['input']>
  coBorrowerDeclarationRelationWithSeller?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerDeclarationResident?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationSchoolingYears?: InputMaybe<Scalars['String']['input']>
  coBorrowerDeclarationSubjectToLien?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDeclarationVALoan?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerDemographics?: InputMaybe<DemographicsAnswers>
  coBorrowerEthnicity?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  coBorrowerGender?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  coBorrowerGlbaDisclosureConsent?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerGrossAnnualIncome?: InputMaybe<Scalars['Float']['input']>
  coBorrowerIncomeSources?: InputMaybe<Array<InputMaybe<IncomeSource>>>
  coBorrowerMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerMonthlyDebtPayments?: InputMaybe<Scalars['Float']['input']>
  coBorrowerMoveInDate?: InputMaybe<Scalars['String']['input']>
  coBorrowerNonTcpaContactConsent?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerOtherAnnualIncomeAmount?: InputMaybe<Scalars['Float']['input']>
  coBorrowerOtherLiabilities?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerOtherLiabilitiesGroup?: InputMaybe<
    Array<InputMaybe<LiabilityAnswers>>
  >
  coBorrowerPersonalInfo?: InputMaybe<Array<InputMaybe<CoBorrowerPersonalInfo>>>
  coBorrowerRace?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  coBorrowerSoftCreditConsent?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerSubmissionAuthorization?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerTcpaDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerTcpaDisclosureSmsOptIn?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerTcpaTransactionalConsent?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerTermsAndCreditDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerTermsOfUsePrivacyPolicyAndElectronicConsentAgreement?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerTotalAssets?: InputMaybe<Scalars['Float']['input']>
  coBorrowerTransUnionSoftCreditConsentDisclosure?: InputMaybe<
    Scalars['Boolean']['input']
  >
  coBorrowerTwoYearsResidence?: InputMaybe<Scalars['Boolean']['input']>
  coBorrowerUndisclosedBorrowedFundsAmount?: InputMaybe<
    Scalars['Float']['input']
  >
  coBorrowerUndisclosedBorrowedFundsIndicator?: InputMaybe<
    Scalars['Boolean']['input']
  >
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  declarationAlimony?: InputMaybe<Scalars['Boolean']['input']>
  declarationBankrupt?: InputMaybe<Scalars['Boolean']['input']>
  declarationBankruptcyType?: InputMaybe<BankruptcyTypes>
  declarationCitizen?: InputMaybe<Scalars['Boolean']['input']>
  declarationCitizenStatus?: InputMaybe<Scalars['String']['input']>
  declarationConveyedTitle?: InputMaybe<Scalars['Boolean']['input']>
  declarationDependents?: InputMaybe<Scalars['Int']['input']>
  declarationDownPaymentBorrowed?: InputMaybe<Scalars['Boolean']['input']>
  declarationDownPaymentBorrowedAmount?: InputMaybe<Scalars['Int']['input']>
  declarationEndorserNote?: InputMaybe<Scalars['Boolean']['input']>
  declarationFHALoan?: InputMaybe<Scalars['Boolean']['input']>
  declarationFederalDebt?: InputMaybe<Scalars['Boolean']['input']>
  declarationForeclosed?: InputMaybe<Scalars['Boolean']['input']>
  declarationForeclosedDirect?: InputMaybe<Scalars['Boolean']['input']>
  declarationLawsuit?: InputMaybe<Scalars['Boolean']['input']>
  declarationMilitary?: InputMaybe<Scalars['Boolean']['input']>
  declarationNewCredit?: InputMaybe<Scalars['Boolean']['input']>
  declarationOutstandingJudgements?: InputMaybe<Scalars['Boolean']['input']>
  declarationOwnership?: InputMaybe<Scalars['Boolean']['input']>
  declarationPrimaryResidence?: InputMaybe<Scalars['Boolean']['input']>
  declarationPropertyTitle?: InputMaybe<Scalars['String']['input']>
  declarationPropertyType?: InputMaybe<Scalars['String']['input']>
  declarationRelationWithSeller?: InputMaybe<Scalars['Boolean']['input']>
  declarationResident?: InputMaybe<Scalars['Boolean']['input']>
  declarationSchoolingYears?: InputMaybe<Scalars['String']['input']>
  declarationSubjectToLien?: InputMaybe<Scalars['Boolean']['input']>
  declarationVALoan?: InputMaybe<Scalars['Boolean']['input']>
  demographics?: InputMaybe<DemographicsAnswers>
  desiredRateType?: InputMaybe<Scalars['String']['input']>
  doesCoBorrowerHaveSameAddress?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  escrow?: InputMaybe<Scalars['Boolean']['input']>
  escrowRollIn?: InputMaybe<Scalars['Boolean']['input']>
  estimatedValue?: InputMaybe<Scalars['Float']['input']>
  ethnicity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  expenseFirstMortgage?: InputMaybe<Scalars['Float']['input']>
  expenseHOAdues?: InputMaybe<Scalars['Float']['input']>
  expenseHomeownerInsurance?: InputMaybe<Scalars['Float']['input']>
  expenseMortgageInsurance?: InputMaybe<Scalars['Float']['input']>
  expensePropertyTax?: InputMaybe<Scalars['Float']['input']>
  expenseRent?: InputMaybe<Scalars['Float']['input']>
  expenseSecondMortgage?: InputMaybe<Scalars['Float']['input']>
  firstMortgageRate?: InputMaybe<Scalars['Float']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  firstTimeHomeBuyer?: InputMaybe<Scalars['Boolean']['input']>
  forbearance?: InputMaybe<Scalars['Boolean']['input']>
  gender?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  grossAnnualIncome?: InputMaybe<Scalars['Float']['input']>
  hasCoBorrower?: InputMaybe<Scalars['Boolean']['input']>
  hasResidedTwoYears?: InputMaybe<Scalars['Boolean']['input']>
  haveDependents?: InputMaybe<Scalars['Boolean']['input']>
  homeBusiness?: InputMaybe<Scalars['Boolean']['input']>
  incomeSources?: InputMaybe<Array<InputMaybe<IncomeSource>>>
  isCurrentAddress?: InputMaybe<Scalars['Boolean']['input']>
  isCurrentPropertyListed?: InputMaybe<Scalars['Boolean']['input']>
  isTakingCashOut?: InputMaybe<Scalars['Boolean']['input']>
  isUnderContract?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  loanPurpose?: InputMaybe<Scalars['String']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  militaryDetails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  militaryServiceMember?: InputMaybe<Scalars['String']['input']>
  militaryServiceTourDate?: InputMaybe<Scalars['String']['input']>
  monthlyDebtPayments?: InputMaybe<Scalars['Float']['input']>
  moreThanOneCoBorrower?: InputMaybe<Scalars['Boolean']['input']>
  nonSpousePropertyRights?: InputMaybe<Scalars['Boolean']['input']>
  nonSpousePropertyRightsState?: InputMaybe<Scalars['String']['input']>
  nonSpousePropertyRightsType?: InputMaybe<Scalars['String']['input']>
  originalCost?: InputMaybe<Scalars['Int']['input']>
  otherAnnualIncomeAmount?: InputMaybe<Scalars['Float']['input']>
  personalInfoDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  phonePin?: InputMaybe<Scalars['String']['input']>
  propertyAttachment?: InputMaybe<Scalars['String']['input']>
  propertyCondoDesignType?: InputMaybe<Scalars['String']['input']>
  propertyDownPayment?: InputMaybe<Scalars['Float']['input']>
  propertyNumberOfStories?: InputMaybe<Scalars['String']['input']>
  propertyPurchasePrice?: InputMaybe<Scalars['Float']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyUse?: InputMaybe<Scalars['String']['input']>
  purchaseKnownAddress?: InputMaybe<Scalars['Boolean']['input']>
  purchaseStage?: InputMaybe<Scalars['String']['input']>
  race?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  realEstateOwned?: InputMaybe<RealEstateOwnedAnswer>
  realEstateOwnedIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  refiReason?: InputMaybe<Scalars['String']['input']>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  rollInFees?: InputMaybe<Scalars['Boolean']['input']>
  schooling?: InputMaybe<Scalars['String']['input']>
  simpleEligible?: InputMaybe<Scalars['Boolean']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  submissionAuthorization?: InputMaybe<Scalars['Boolean']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
  tcpaDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  tcpaDisclosureSmsOptIn?: InputMaybe<Scalars['Boolean']['input']>
  tcpaMarketingAndCustomerCareConsent?: InputMaybe<Scalars['Boolean']['input']>
  tcpaTransactionalConsent?: InputMaybe<Scalars['Boolean']['input']>
  termsAndCreditDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  termsOfUsePrivacyPolicyAndElectronicConsentAgreement?: InputMaybe<
    Scalars['Boolean']['input']
  >
  timeInHome?: InputMaybe<Scalars['String']['input']>
  titleHolderLegalNames?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  totalAssets?: InputMaybe<Scalars['Float']['input']>
  totalMonthlyExpenses?: InputMaybe<Scalars['Float']['input']>
  typeProperty?: InputMaybe<Scalars['String']['input']>
  undisclosedBorrowedFundsAmount?: InputMaybe<Scalars['Float']['input']>
  undisclosedBorrowedFundsIndicator?: InputMaybe<Scalars['Boolean']['input']>
  workingWithRealEstateAgent?: InputMaybe<Scalars['Boolean']['input']>
  yearBuilt?: InputMaybe<Scalars['Int']['input']>
  yearPurchased?: InputMaybe<Scalars['Int']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type ApplicationAnswersOutput = {
  __typename?: 'ApplicationAnswersOutput'
  addDependentAges?: Maybe<Array<Maybe<DependentAgeOutput>>>
  additionalIncome?: Maybe<Scalars['String']['output']>
  addresses?: Maybe<Array<Maybe<AddressOutput>>>
  affiliatedBusinessArrangementDisclosure?: Maybe<Scalars['Boolean']['output']>
  agentCompany?: Maybe<Scalars['String']['output']>
  agentEmail?: Maybe<Scalars['String']['output']>
  agentFirstName?: Maybe<Scalars['String']['output']>
  agentLastName?: Maybe<Scalars['String']['output']>
  agentPhone?: Maybe<Scalars['String']['output']>
  annualGrossIncome?: Maybe<Scalars['Int']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  apt?: Maybe<Scalars['String']['output']>
  auth0Id?: Maybe<Scalars['String']['output']>
  autoCompleteAddressFields?: Maybe<Scalars['String']['output']>
  cashOut?: Maybe<Scalars['Float']['output']>
  cashOutOptions?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  closingDate?: Maybe<Scalars['String']['output']>
  coBorrowerAdditionalIncome?: Maybe<Scalars['String']['output']>
  coBorrowerAddresses?: Maybe<Array<Maybe<CoBorrowerAddressOutput>>>
  coBorrowerAffiliatedBusinessArrangementDisclosure?: Maybe<
    Scalars['Boolean']['output']
  >
  coBorrowerCountryOfCitizenship?: Maybe<Scalars['String']['output']>
  coBorrowerCreditScore?: Maybe<Scalars['Int']['output']>
  coBorrowerDeclarationAlimony?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationBankrupt?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationBankruptcyType?: Maybe<BankruptcyTypes>
  coBorrowerDeclarationCitizen?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationConveyedTitle?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationDependents?: Maybe<Scalars['Int']['output']>
  coBorrowerDeclarationDownPaymentBorrowed?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationDownPaymentBorrowedAmount?: Maybe<
    Scalars['Int']['output']
  >
  coBorrowerDeclarationEndorserNote?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationFHALoan?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationFederalDebt?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationForeclosed?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationForeclosedDirect?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationLawsuit?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationMilitary?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationNewCredit?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationOutstandingJudgements?: Maybe<
    Scalars['String']['output']
  >
  coBorrowerDeclarationOwnership?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationPrimaryResidence?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationPropertyTitle?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationPropertyType?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationResident?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationSchoolingYears?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationSubjectToLien?: Maybe<Scalars['String']['output']>
  coBorrowerDeclarationVALoan?: Maybe<Scalars['String']['output']>
  coBorrowerDemographics?: Maybe<Array<Maybe<DemographicsOutput>>>
  coBorrowerEthnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  coBorrowerGender?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  coBorrowerId?: Maybe<Scalars['Int']['output']>
  coBorrowerIncomeSources?: Maybe<Array<Maybe<IncomeSourceOutput>>>
  coBorrowerMoveInDate?: Maybe<Scalars['String']['output']>
  coBorrowerOtherIncomes?: Maybe<Array<Maybe<IncomeSourceOutput>>>
  coBorrowerOtherLiabilities?: Maybe<Scalars['String']['output']>
  coBorrowerOtherLiabilitiesGroup?: Maybe<Array<Maybe<LiabilityOutput>>>
  coBorrowerPersonalInfo?: Maybe<Array<Maybe<CoBorrowerPersonalInfoOutput>>>
  coBorrowerRace?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  coBorrowerTcpaDisclosure?: Maybe<Scalars['Boolean']['output']>
  coBorrowerTcpaDisclosureSmsOptIn?: Maybe<Scalars['Boolean']['output']>
  coBorrowerTcpaMarketingAndCustomerCareConsent?: Maybe<
    Scalars['Boolean']['output']
  >
  coBorrowerTcpaTransactionalConsent?: Maybe<Scalars['Boolean']['output']>
  coBorrowerTermsAndCreditAuthorization?: Maybe<Scalars['Boolean']['output']>
  coBorrowerTermsOfUsePrivacyPolicyAndElectronicConsentAgreement?: Maybe<
    Scalars['Boolean']['output']
  >
  coBorrowerTwoYearsResidence?: Maybe<Scalars['String']['output']>
  coBorrowerUndisclosedBorrowedFundsAmount?: Maybe<Scalars['Float']['output']>
  coBorrowerUndisclosedBorrowedFundsIndicator?: Maybe<
    Scalars['String']['output']
  >
  countryOfCitizenship?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  dateOfBirth?: Maybe<Scalars['String']['output']>
  declarationAlimony?: Maybe<Scalars['String']['output']>
  declarationBankrupt?: Maybe<Scalars['String']['output']>
  declarationBankruptcyType?: Maybe<BankruptcyTypes>
  declarationCitizen?: Maybe<Scalars['String']['output']>
  declarationCitizenStatus?: Maybe<Scalars['String']['output']>
  declarationConveyedTitle?: Maybe<Scalars['String']['output']>
  declarationDependents?: Maybe<Scalars['Int']['output']>
  declarationDownPaymentBorrowed?: Maybe<Scalars['String']['output']>
  declarationDownPaymentBorrowedAmount?: Maybe<Scalars['Int']['output']>
  declarationEndorserNote?: Maybe<Scalars['String']['output']>
  declarationFHALoan?: Maybe<Scalars['String']['output']>
  declarationFederalDebt?: Maybe<Scalars['String']['output']>
  declarationForeclosed?: Maybe<Scalars['String']['output']>
  declarationForeclosedDirect?: Maybe<Scalars['String']['output']>
  declarationLawsuit?: Maybe<Scalars['String']['output']>
  declarationMilitary?: Maybe<Scalars['String']['output']>
  declarationNewCredit?: Maybe<Scalars['String']['output']>
  declarationOutstandingJudgements?: Maybe<Scalars['String']['output']>
  declarationOwnership?: Maybe<Scalars['String']['output']>
  declarationPrimaryResidence?: Maybe<Scalars['String']['output']>
  declarationPropertyTitle?: Maybe<Scalars['String']['output']>
  declarationPropertyType?: Maybe<Scalars['String']['output']>
  declarationResident?: Maybe<Scalars['String']['output']>
  declarationSchoolingYears?: Maybe<Scalars['String']['output']>
  declarationSubjectToLien?: Maybe<Scalars['String']['output']>
  declarationVALoan?: Maybe<Scalars['String']['output']>
  demographics?: Maybe<Array<Maybe<DemographicsOutput>>>
  doesCoBorrowerHaveSameAddress?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  escrow?: Maybe<Scalars['String']['output']>
  estimatedValue?: Maybe<Scalars['Float']['output']>
  ethnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  expenseFirstMortgage?: Maybe<Scalars['Float']['output']>
  expenseHOAdues?: Maybe<Scalars['Float']['output']>
  expenseHomeownerInsurance?: Maybe<Scalars['Float']['output']>
  expenseMortgageInsurance?: Maybe<Scalars['Float']['output']>
  expensePropertyTax?: Maybe<Scalars['Float']['output']>
  expenseRent?: Maybe<Scalars['Float']['output']>
  expenseSecondMortgage?: Maybe<Scalars['Float']['output']>
  firstMortgageRate?: Maybe<Scalars['Float']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  forbearance?: Maybe<Scalars['String']['output']>
  gender?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  hasCoBorrower?: Maybe<Scalars['String']['output']>
  hasResidedTwoYears?: Maybe<Scalars['String']['output']>
  hasSavedCoBorrowerSSN?: Maybe<Scalars['Boolean']['output']>
  hasSavedSSN?: Maybe<Scalars['Boolean']['output']>
  haveDependents?: Maybe<Scalars['String']['output']>
  homeBusiness?: Maybe<Scalars['String']['output']>
  incomeSources?: Maybe<Array<Maybe<IncomeSourceOutput>>>
  isCurrentAddress?: Maybe<Scalars['String']['output']>
  isTakingCashOut?: Maybe<Scalars['String']['output']>
  isUnderContract?: Maybe<Scalars['String']['output']>
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  lastName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  militaryDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  militaryServiceMember?: Maybe<Scalars['String']['output']>
  militaryServiceTourDate?: Maybe<Scalars['String']['output']>
  monthlyDebts?: Maybe<Scalars['Int']['output']>
  moveInDate?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRights?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRightsState?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRightsType?: Maybe<Scalars['String']['output']>
  otherIncomes?: Maybe<Array<Maybe<IncomeSourceOutput>>>
  otherLiabilities?: Maybe<Scalars['String']['output']>
  otherLiabilitiesGroup?: Maybe<Array<Maybe<LiabilityOutput>>>
  phone?: Maybe<Scalars['String']['output']>
  propertyAttachment?: Maybe<Scalars['String']['output']>
  propertyCity?: Maybe<Scalars['String']['output']>
  propertyDownPayment?: Maybe<Scalars['Float']['output']>
  propertyNumberOfStories?: Maybe<Scalars['String']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Float']['output']>
  propertyState?: Maybe<Scalars['String']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyUse?: Maybe<Scalars['String']['output']>
  propertyZip?: Maybe<Scalars['String']['output']>
  purchaseKnownAddress?: Maybe<Scalars['String']['output']>
  purchaseStage?: Maybe<Scalars['String']['output']>
  race?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  realEstateOwned?: Maybe<Array<Maybe<RealEstateOwnedOutput>>>
  realEstateOwnedIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  refiReason?: Maybe<Scalars['String']['output']>
  remainingBalance?: Maybe<Scalars['Float']['output']>
  rollInFees?: Maybe<Scalars['String']['output']>
  simpleEligible?: Maybe<Scalars['Boolean']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  submissionAuthorization?: Maybe<Scalars['Boolean']['output']>
  tcpaDisclosure?: Maybe<Scalars['Boolean']['output']>
  tcpaDisclosureSmsOptIn?: Maybe<Scalars['Boolean']['output']>
  tcpaMarketingAndCustomerCareConsent?: Maybe<Scalars['Boolean']['output']>
  tcpaTransactionalConsent?: Maybe<Scalars['Boolean']['output']>
  termsAndCreditAuthorization?: Maybe<Scalars['Boolean']['output']>
  termsOfUsePrivacyPolicyAndElectronicConsentAgreement?: Maybe<
    Scalars['Boolean']['output']
  >
  timeInHome?: Maybe<Scalars['String']['output']>
  titleHolderLegalNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  totalAssets?: Maybe<Scalars['Int']['output']>
  undisclosedBorrowedFundsAmount?: Maybe<Scalars['Float']['output']>
  undisclosedBorrowedFundsIndicator?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['Int']['output']>
  workingWithRealEstateAgent?: Maybe<Scalars['Boolean']['output']>
  yearBuilt?: Maybe<Scalars['Int']['output']>
  yearPurchased?: Maybe<Scalars['Int']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type ApplicationBasicInfo = {
  __typename?: 'ApplicationBasicInfo'
  exists: Scalars['Boolean']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
}

export type ApplicationContact = {
  __typename?: 'ApplicationContact'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  id: Scalars['Int']['output']
  lastName: Scalars['String']['output']
  phone: Scalars['String']['output']
  type: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
}

export type ApplicationContactInput = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  lastName: Scalars['String']['input']
  phone: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type ApplicationDemographics = {
  __typename?: 'ApplicationDemographics'
  americanIndianTribeDesc?: Maybe<Scalars['String']['output']>
  asianOtherSubtypeDesc?: Maybe<Scalars['String']['output']>
  asianSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type ApplicationDetailsSchema = {
  __typename?: 'ApplicationDetailsSchema'
  addresses?: Maybe<Array<Maybe<AddressRevisionSchema>>>
  agreedToAgentConsent?: Maybe<Scalars['Boolean']['output']>
  alfieRate?: Maybe<RateSelectionSchema>
  assets?: Maybe<Array<Maybe<AssetRevisionSchema>>>
  assignedLoanOfficer?: Maybe<LoanOfficerAdminInfo>
  assignedProcessor?: Maybe<ProcessorInfo>
  ausDocuments?: Maybe<Array<Maybe<AusReportSchema>>>
  avmPropertyDetails?: Maybe<AvmPropertyDetailsSchema>
  beSmarteeLoanId?: Maybe<Scalars['String']['output']>
  borrowerPortalRate?: Maybe<BorrowerPortalRateSelectionSchema>
  borrowerPortalStatus?: Maybe<Scalars['String']['output']>
  coBorrowerApplication?: Maybe<CoBorrowerApplicationDetailsSchema>
  coborrowerCreditData?: Maybe<CreditDataSchema>
  conditionallyApprovedOn?: Maybe<Scalars['String']['output']>
  conditions?: Maybe<Array<Maybe<ConditionSchema>>>
  contactStatus?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditAuthorized?: Maybe<Scalars['Boolean']['output']>
  creditData?: Maybe<CreditDataSchema>
  creditReportHistory?: Maybe<Array<Maybe<CreditReportDetailsSchema>>>
  creditReportIdentifier?: Maybe<Scalars['String']['output']>
  currentServicers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  demographics?: Maybe<DemographicsRevisionSchema>
  /** Legacy DocuSign-based tracking. No longer populated; kept for historical loans. */
  disclosureTracking?: Maybe<Array<Maybe<DisclosureTrackingSchema>>>
  documents?: Maybe<Array<Maybe<DocumentRequestSchema>>>
  /** Docutech disclosure distributions for this application's Encompass loan. Includes soft-deleted rows for redistribution history. */
  docutechDistributions?: Maybe<
    Array<Maybe<DocutechDocumentDistributionSchema>>
  >
  elloStatus?: Maybe<Scalars['String']['output']>
  encompassLoanReference?: Maybe<ApplicationExternalReferenceSchema>
  externalRateSeen?: Maybe<ExternalRateSeenSchema>
  externalRefFigureId?: Maybe<Scalars['String']['output']>
  figureNextInquiryStep?: Maybe<Scalars['String']['output']>
  fullLiabilities?: Maybe<LiabilitySchema>
  fullStoryLink?: Maybe<Scalars['String']['output']>
  hasFanniePlaidPortfolio?: Maybe<Scalars['Boolean']['output']>
  hasImportedServicerData?: Maybe<Scalars['Boolean']['output']>
  hasReachedShippingMilestone?: Maybe<Scalars['Boolean']['output']>
  hasSoftTriMergeConsent?: Maybe<Scalars['Boolean']['output']>
  hasTUConsent?: Maybe<Scalars['Boolean']['output']>
  homeEquityDetails?: Maybe<HomeEquityDetailsSchema>
  id: Scalars['Int']['output']
  incomes?: Maybe<Array<Maybe<IncomeRevisionSchema>>>
  isExternallyManagedLead?: Maybe<Scalars['Boolean']['output']>
  isFannieSimpleApplication?: Maybe<Scalars['Boolean']['output']>
  isIceBox?: Maybe<Scalars['Boolean']['output']>
  isPhoenixManagedApplication?: Maybe<Scalars['Boolean']['output']>
  isProtected?: Maybe<Scalars['Boolean']['output']>
  isVepaExpired?: Maybe<Scalars['Boolean']['output']>
  lastBorrowerContacted?: Maybe<ContactInfo>
  lastRingCentralContacted?: Maybe<ContactInfo>
  leadDetails?: Maybe<BankrateLead>
  leadType?: Maybe<Scalars['String']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  liabilities?: Maybe<Array<Maybe<LiabilityRevisionSchema>>>
  loan?: Maybe<EncompassLoanImportSchema>
  loanOfficerAssignedAt?: Maybe<Scalars['String']['output']>
  loanOriginationFee?: Maybe<Scalars['Float']['output']>
  lockedRate?: Maybe<LockedRateSchema>
  messageThreads?: Maybe<Array<Maybe<MessageThreadSchema>>>
  nonBorrowingSpouse?: Maybe<NonBorrowingSpouseSchema>
  nonTcpaContactConsent?: Maybe<Scalars['Boolean']['output']>
  notes?: Maybe<Array<Maybe<ApplicationNotesSchema>>>
  ntlDisqualifiedReason?: Maybe<Scalars['String']['output']>
  prelockedRate?: Maybe<LockedRateSchema>
  prequalCreditReportIdentifier?: Maybe<Scalars['String']['output']>
  prequalRevision?: Maybe<PrequalRevisionSchema>
  pricingAdjustment?: Maybe<PricingAdjustmentSchema>
  pricingException?: Maybe<PricingExceptionSchema>
  pricingScenario?: Maybe<ApplicationPricing>
  realEstateAgent?: Maybe<SageContactSchema>
  relatedApps?: Maybe<Array<Maybe<UserApplicationSchema>>>
  reminder?: Maybe<ApplicationReminderSchema>
  reo?: Maybe<Array<Maybe<RealEstateOwnedSchema>>>
  reportingInfo?: Maybe<Array<Maybe<ApplicationReportingSchema>>>
  revision?: Maybe<ApplicationRevisionDetailsSchema>
  source?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  statusCreatedAt?: Maybe<Scalars['String']['output']>
  submittedToUnderwritingOn?: Maybe<Scalars['String']['output']>
  tasks?: Maybe<Array<Maybe<ApplicationTask>>>
  tcpaMarketingAndCustomerCareConsent?: Maybe<Scalars['Boolean']['output']>
  tcpaTransactionalConsent?: Maybe<Scalars['Boolean']['output']>
  tridDueDate?: Maybe<Scalars['String']['output']>
  tridMetadata?: Maybe<TridMetadataSchema>
  user?: Maybe<User>
  userId?: Maybe<Scalars['Int']['output']>
  uuid: Scalars['String']['output']
  withdrawRequestedAt?: Maybe<Scalars['String']['output']>
}

export type ApplicationDetailsStatusSchema = {
  __typename?: 'ApplicationDetailsStatusSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  applicationRevisionId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  status?: Maybe<Scalars['String']['output']>
  statusSource?: Maybe<Scalars['String']['output']>
}

export type ApplicationExternalEventSchema = {
  __typename?: 'ApplicationExternalEventSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  decryptedError?: Maybe<Scalars['JSON']['output']>
  errorKey?: Maybe<Scalars['String']['output']>
  externalServiceName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  jobId?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type ApplicationExternalReferenceSchema = {
  __typename?: 'ApplicationExternalReferenceSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  externalFieldName?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  externalServiceName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  lockReason?: Maybe<Scalars['String']['output']>
  syncLocked?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type ApplicationInfoByGuid = {
  __typename?: 'ApplicationInfoByGuid'
  applicationId?: Maybe<Scalars['Int']['output']>
  applicationLeadSource?: Maybe<Scalars['String']['output']>
  isPhoenixManagedApplication?: Maybe<Scalars['Boolean']['output']>
}

export type ApplicationLiabilitiesSchema = {
  __typename?: 'ApplicationLiabilitiesSchema'
  accountNumber?: Maybe<Scalars['String']['output']>
  apt?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  creditLine?: Maybe<Scalars['Float']['output']>
  creditor?: Maybe<Scalars['String']['output']>
  liabilityType?: Maybe<Scalars['String']['output']>
  monthlyExpense?: Maybe<Scalars['Float']['output']>
  mortgageType?: Maybe<Scalars['String']['output']>
  otherDescription?: Maybe<Scalars['String']['output']>
  ownershipType?: Maybe<Scalars['String']['output']>
  remainingTermMonths?: Maybe<Scalars['Int']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  toBePaidOff?: Maybe<Scalars['Boolean']['output']>
  unpaidBalance?: Maybe<Scalars['Float']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type ApplicationLoAssignmentSchema = {
  __typename?: 'ApplicationLoAssignmentSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  loanOfficerId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type ApplicationLoanOfficerActionRevisionRequest = {
  applicationId: Scalars['Int']['input']
}

export type ApplicationLoanOfficerActionRevisionResponse = {
  __typename?: 'ApplicationLoanOfficerActionRevisionResponse'
  actionStatus?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  contactStatus?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  createdBy?: Maybe<Scalars['Int']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  nextRevision?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type ApplicationNoteSaveRequest = {
  applicationId: Scalars['Int']['input']
  applicationRevisionId?: InputMaybe<Scalars['Int']['input']>
  authorFullName?: InputMaybe<Scalars['String']['input']>
  note: Scalars['String']['input']
  retoolId?: InputMaybe<Scalars['Int']['input']>
}

export type ApplicationNotesSchema = {
  __typename?: 'ApplicationNotesSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  applicationRevisionId?: Maybe<Scalars['Int']['output']>
  authorName?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  retoolId?: Maybe<Scalars['Int']['output']>
}

export type ApplicationPricing = {
  __typename?: 'ApplicationPricing'
  address?: Maybe<Scalars['String']['output']>
  allLenders?: Maybe<Scalars['Boolean']['output']>
  applicationId: Scalars['Int']['output']
  appraisalDownPayment?: Maybe<Scalars['Float']['output']>
  appraisalDownPaymentPercent?: Maybe<Scalars['Float']['output']>
  appraisalValue?: Maybe<Scalars['Float']['output']>
  cashOut?: Maybe<Scalars['Int']['output']>
  city?: Maybe<Scalars['String']['output']>
  closingFeeClient?: Maybe<Scalars['String']['output']>
  coBorrowerName?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  costOfLoanYears?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  debtToIncome?: Maybe<Scalars['Float']['output']>
  defaultLockPeriod?: Maybe<Scalars['Int']['output']>
  defaultQuotingChannel?: Maybe<Scalars['String']['output']>
  escrowOptions?: Maybe<EscrowOptions>
  feesInControlledByLockDesk?: Maybe<Scalars['Boolean']['output']>
  firstTimeHomeBuyer?: Maybe<Scalars['Boolean']['output']>
  firstTimeUsingVaLoan?: Maybe<Scalars['Boolean']['output']>
  forceCurrentPricing?: Maybe<Scalars['Boolean']['output']>
  hasHardCreditPull?: Maybe<Scalars['Boolean']['output']>
  homeownersInsuranceMonths?: Maybe<Scalars['Int']['output']>
  incomeType?: Maybe<Scalars['String']['output']>
  initialAppraisalDownPayment?: Maybe<Scalars['Float']['output']>
  initialAppraisalDownPaymentPercent?: Maybe<Scalars['Float']['output']>
  leadSource?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanOfficerId?: Maybe<Scalars['Int']['output']>
  loanPurpose?: Maybe<LoanPurpose>
  loanTerm?: Maybe<ProductTerm>
  loanTerms?: Maybe<Array<Maybe<ProductTerm>>>
  loanToValue?: Maybe<Scalars['Float']['output']>
  lockFormRequestType?: Maybe<LockRequestType>
  lockId?: Maybe<Scalars['String']['output']>
  lockPeriod?: Maybe<Scalars['Int']['output']>
  monthlyInsurance?: Maybe<Scalars['Float']['output']>
  msrOwner?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  points?: Maybe<PointEnum>
  product?: Maybe<Scalars['String']['output']>
  productClass?: Maybe<Scalars['String']['output']>
  productFamilies?: Maybe<Array<Maybe<ProductFamily>>>
  productFamily?: Maybe<ProductFamily>
  propertyDownPayment?: Maybe<Scalars['Float']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Float']['output']>
  propertyTax?: Maybe<Scalars['Float']['output']>
  propertyTaxMonths?: Maybe<Scalars['Int']['output']>
  propertyType?: Maybe<PropertyType>
  propertyUse?: Maybe<PropertyUse>
  propertyValue?: Maybe<Scalars['Int']['output']>
  quotingChannel?: Maybe<QuotingChannel>
  remainingBalance?: Maybe<Scalars['Float']['output']>
  rollInEscrow?: Maybe<Scalars['Float']['output']>
  rollInFee?: Maybe<Scalars['Int']['output']>
  selfEmployed?: Maybe<Scalars['Boolean']['output']>
  state?: Maybe<StateAbbreviation>
  subordinateLien?: Maybe<Scalars['Int']['output']>
  subordinateLienCreditLimit?: Maybe<Scalars['Float']['output']>
  useFeesInChannel?: Maybe<Scalars['Boolean']['output']>
  veteranDisabled?: Maybe<Scalars['Boolean']['output']>
  veteranType?: Maybe<VeteranType>
  waiveEscrow?: Maybe<Scalars['Boolean']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type ApplicationReminderSaveRequest = {
  applicationId: Scalars['Int']['input']
  reminderDate: Scalars['String']['input']
  reminderType: Scalars['String']['input']
}

export type ApplicationReminderSchema = {
  __typename?: 'ApplicationReminderSchema'
  applicationId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  reminderDate: Scalars['String']['output']
  reminderType: Scalars['String']['output']
}

export type ApplicationReportingSchema = {
  __typename?: 'ApplicationReportingSchema'
  actionDate?: Maybe<Scalars['String']['output']>
  actionTaken?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  ausRunDate?: Maybe<Scalars['String']['output']>
  clearToCloseOn?: Maybe<Scalars['String']['output']>
  closingLoanOfficerId?: Maybe<Scalars['Int']['output']>
  conditionallyApprovedOn?: Maybe<Scalars['String']['output']>
  contractContingencyDate?: Maybe<Scalars['String']['output']>
  contractSigned?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditReportFee?: Maybe<Scalars['Int']['output']>
  creditedUnderwriter?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  deniedOn?: Maybe<Scalars['String']['output']>
  disbursementDate?: Maybe<Scalars['String']['output']>
  dti?: Maybe<Scalars['Float']['output']>
  edisclosureSignedOn?: Maybe<Scalars['String']['output']>
  estClosingDate?: Maybe<Scalars['String']['output']>
  extendedOn?: Maybe<Scalars['String']['output']>
  extensionAmount?: Maybe<Scalars['Int']['output']>
  extensionCount?: Maybe<Scalars['Int']['output']>
  fundedOn?: Maybe<Scalars['String']['output']>
  gainLossPercentage?: Maybe<Scalars['Float']['output']>
  gainLossTotal?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  isEmployeeLoan?: Maybe<Scalars['Boolean']['output']>
  isFloat?: Maybe<Scalars['Boolean']['output']>
  lenderAddress?: Maybe<Scalars['String']['output']>
  lenderEmail?: Maybe<Scalars['String']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  lenderPhone?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Int']['output']>
  loanProduct?: Maybe<Scalars['String']['output']>
  lockExpirationDate?: Maybe<Scalars['String']['output']>
  lockPeriod?: Maybe<Scalars['String']['output']>
  lockedOn?: Maybe<Scalars['String']['output']>
  ltv?: Maybe<Scalars['Float']['output']>
  openingLoanOfficerId?: Maybe<Scalars['Int']['output']>
  originalLockPeriod?: Maybe<Scalars['Int']['output']>
  partnerCompensationFinal?: Maybe<Scalars['Int']['output']>
  partnerCompensationInitial?: Maybe<Scalars['Int']['output']>
  preapprovalCreditOnly?: Maybe<Scalars['String']['output']>
  preapprovalDate?: Maybe<Scalars['String']['output']>
  preapprovalPortfolioLoan?: Maybe<Scalars['String']['output']>
  preapprovalUwOnly?: Maybe<Scalars['String']['output']>
  pricingExceptionAmount?: Maybe<Scalars['Int']['output']>
  processorId?: Maybe<Scalars['Int']['output']>
  propertyInspectionWaiverEligible?: Maybe<Scalars['Boolean']['output']>
  relocked?: Maybe<Scalars['Boolean']['output']>
  revenueAtLock?: Maybe<Scalars['Int']['output']>
  sageExtensionCost?: Maybe<Scalars['Int']['output']>
  salesContractDate?: Maybe<Scalars['String']['output']>
  submittedToUnderwritingOn?: Maybe<Scalars['String']['output']>
  toleranceCures?: Maybe<Scalars['Int']['output']>
  totalExtensionCost?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  updatedBy?: Maybe<Scalars['String']['output']>
  withdrawnOn?: Maybe<Scalars['String']['output']>
}

export type ApplicationRevisionDetailsSchema = {
  __typename?: 'ApplicationRevisionDetailsSchema'
  abadDisclosure?: Maybe<Scalars['Boolean']['output']>
  address?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  amortizationType?: Maybe<Scalars['String']['output']>
  annualHouseholdIncome?: Maybe<Scalars['Float']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  appraisalFee?: Maybe<Scalars['Float']['output']>
  cashOut?: Maybe<Scalars['Float']['output']>
  city?: Maybe<Scalars['String']['output']>
  closingDate?: Maybe<Scalars['String']['output']>
  closingDisclosureReceivedDate?: Maybe<Scalars['String']['output']>
  closingDisclosureSentDate?: Maybe<Scalars['String']['output']>
  contractMustCloseBy?: Maybe<Scalars['String']['output']>
  countryOfCitizenship?: Maybe<Scalars['String']['output']>
  county?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  creditScoreSource?: Maybe<Scalars['String']['output']>
  currentTotalMonthlyPayment?: Maybe<Scalars['Float']['output']>
  dateOfBirth?: Maybe<Scalars['String']['output']>
  debtToIncome?: Maybe<Scalars['Float']['output']>
  declarationAlimony?: Maybe<Scalars['Boolean']['output']>
  declarationBankrupcy?: Maybe<Scalars['Boolean']['output']>
  declarationBankruptcyType?: Maybe<Scalars['String']['output']>
  declarationBorrowedDown?: Maybe<Scalars['Boolean']['output']>
  declarationBorrowedDownFundsAmount?: Maybe<Scalars['Float']['output']>
  declarationCitizen?: Maybe<Scalars['Boolean']['output']>
  declarationCitizenStatus?: Maybe<Scalars['String']['output']>
  declarationConveyedTitle?: Maybe<Scalars['Boolean']['output']>
  declarationEthnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationFhaLoan?: Maybe<Scalars['Boolean']['output']>
  declarationForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationGender?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationHomeOwnership?: Maybe<Scalars['Boolean']['output']>
  declarationJudgements?: Maybe<Scalars['Boolean']['output']>
  declarationLawsuits?: Maybe<Scalars['Boolean']['output']>
  declarationLoanDefaults?: Maybe<Scalars['Boolean']['output']>
  declarationLoanForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationMilitary?: Maybe<Scalars['Boolean']['output']>
  declarationNoteEndorser?: Maybe<Scalars['Boolean']['output']>
  declarationPrimaryResidence?: Maybe<Scalars['Boolean']['output']>
  declarationPropertyTitle?: Maybe<Scalars['String']['output']>
  declarationPropertyType?: Maybe<Scalars['String']['output']>
  declarationRace?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationRelationWithSeller?: Maybe<Scalars['Boolean']['output']>
  declarationResident?: Maybe<Scalars['Boolean']['output']>
  declarationSchooling?: Maybe<Scalars['String']['output']>
  declarationSubjectToLien?: Maybe<Scalars['Boolean']['output']>
  declarationUndisclosedCreditApplicationIndicator?: Maybe<
    Scalars['Boolean']['output']
  >
  declarationVaLoan?: Maybe<Scalars['Boolean']['output']>
  dependentsAges?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  desiredRateType?: Maybe<Scalars['String']['output']>
  dueDiligence?: Maybe<Scalars['Float']['output']>
  earnestMoney?: Maybe<Scalars['Float']['output']>
  email?: Maybe<Scalars['String']['output']>
  escrow?: Maybe<Scalars['Boolean']['output']>
  existingLoanType?: Maybe<Scalars['String']['output']>
  expectedRentalIncome?: Maybe<Scalars['Float']['output']>
  expenseFirstMortgage?: Maybe<Scalars['Float']['output']>
  expenseHoaDues?: Maybe<Scalars['Float']['output']>
  expenseHomeInsurance?: Maybe<Scalars['Float']['output']>
  expenseMortgageInsurance?: Maybe<Scalars['Float']['output']>
  expensePropertyTax?: Maybe<Scalars['Float']['output']>
  expenseRent?: Maybe<Scalars['Float']['output']>
  expenseSecondMortgage?: Maybe<Scalars['Float']['output']>
  fipsCode?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  firstTimeHomeBuyer?: Maybe<Scalars['Boolean']['output']>
  forbearance?: Maybe<Scalars['Boolean']['output']>
  frozenCreditCheck?: Maybe<Scalars['Boolean']['output']>
  goalRate?: Maybe<Scalars['Float']['output']>
  hasCoBorrower?: Maybe<Scalars['Boolean']['output']>
  hasCompletedDisclosures?: Maybe<Scalars['Boolean']['output']>
  hasRefinancedBefore?: Maybe<Scalars['Boolean']['output']>
  homeBusiness?: Maybe<Scalars['Boolean']['output']>
  iceBox?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['Int']['output']
  interestRate?: Maybe<Scalars['Float']['output']>
  isCurrentAddress?: Maybe<Scalars['Boolean']['output']>
  isCurrentPropertyListed?: Maybe<Scalars['Boolean']['output']>
  isRollInEscrow?: Maybe<Scalars['Boolean']['output']>
  jointApplicantIntention?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  latestLoanAmount?: Maybe<Scalars['Float']['output']>
  latestLoanDate?: Maybe<Scalars['String']['output']>
  latestLoanYear?: Maybe<Scalars['Int']['output']>
  leadGoal?: Maybe<Scalars['String']['output']>
  loDisclosureAcknowledgedBy?: Maybe<Scalars['String']['output']>
  loDisclosureAcknowledgedDate?: Maybe<Scalars['String']['output']>
  loPriorityLevel?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  loanToValue?: Maybe<Scalars['Float']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  middleName?: Maybe<Scalars['String']['output']>
  militaryDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  militaryServiceMember?: Maybe<Scalars['String']['output']>
  militaryServiceTourDate?: Maybe<Scalars['String']['output']>
  monthlyDebtPayments?: Maybe<Scalars['Float']['output']>
  monthlyPaymentSavingsGoal?: Maybe<Scalars['Float']['output']>
  moveExplanation?: Maybe<Scalars['String']['output']>
  nameAliases?: Maybe<Array<Maybe<NameAlias>>>
  needToSellBeforePurchase?: Maybe<Scalars['Boolean']['output']>
  nextRevision?: Maybe<Scalars['Int']['output']>
  nonSpousePropertyRights?: Maybe<Scalars['Boolean']['output']>
  nonSpousePropertyRightsState?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRightsType?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  originalLoanTerm?: Maybe<Scalars['Float']['output']>
  phone?: Maybe<Scalars['String']['output']>
  preapprovedWithOtherLender?: Maybe<Scalars['Boolean']['output']>
  previousCashOut?: Maybe<Scalars['Boolean']['output']>
  previousRefinance?: Maybe<Scalars['Boolean']['output']>
  previousRefinanceCloseDate?: Maybe<Scalars['String']['output']>
  promotionMentioned?: Maybe<Scalars['Boolean']['output']>
  propertyAttachment?: Maybe<Scalars['String']['output']>
  propertyCondoDesignType?: Maybe<Scalars['String']['output']>
  propertyDownPayment?: Maybe<Scalars['Float']['output']>
  propertyInspectionWaiver?: Maybe<Scalars['Boolean']['output']>
  propertyNumberOfStories?: Maybe<Scalars['String']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Float']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyUse?: Maybe<Scalars['String']['output']>
  propertyValue?: Maybe<Scalars['Float']['output']>
  propertyYearBuilt?: Maybe<Scalars['Int']['output']>
  propertyYearPurchased?: Maybe<Scalars['Int']['output']>
  proposedExpenseFirstMortgage?: Maybe<Scalars['Float']['output']>
  proposedExpenseHoaDues?: Maybe<Scalars['Float']['output']>
  proposedExpenseHomeInsurance?: Maybe<Scalars['Float']['output']>
  proposedExpenseMortgageInsurance?: Maybe<Scalars['Float']['output']>
  proposedExpensePropertyTax?: Maybe<Scalars['Float']['output']>
  proposedExpenseSecondMortgage?: Maybe<Scalars['Float']['output']>
  purchaseStage?: Maybe<Scalars['String']['output']>
  refiReason?: Maybe<Scalars['String']['output']>
  refinanceExplanation?: Maybe<Scalars['String']['output']>
  refinancePrimaryPurpose?: Maybe<Scalars['String']['output']>
  remainingBalance?: Maybe<Scalars['Float']['output']>
  remainingMonths?: Maybe<Scalars['Int']['output']>
  revisionType?: Maybe<Scalars['String']['output']>
  rollInFees?: Maybe<Scalars['Boolean']['output']>
  secondPhone?: Maybe<Scalars['String']['output']>
  sellerCredit?: Maybe<Scalars['Float']['output']>
  ssnAlias?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  submissionAuthorization?: Maybe<Scalars['Boolean']['output']>
  suffix?: Maybe<Scalars['String']['output']>
  tcpaDisclosure?: Maybe<Scalars['Boolean']['output']>
  termsAndCreditAuthorization?: Maybe<Scalars['Boolean']['output']>
  termsOfUseDisclosure?: Maybe<Scalars['Boolean']['output']>
  tilIntlDisclosureProvidedDate?: Maybe<Scalars['String']['output']>
  timeInHome?: Maybe<Scalars['String']['output']>
  titleHolderLegalNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  titleMannerHeld?: Maybe<Scalars['String']['output']>
  totalAssets?: Maybe<Scalars['Float']['output']>
  undisclosedBorrowedFundsAmount?: Maybe<Scalars['Float']['output']>
  undisclosedBorrowedFundsIndicator?: Maybe<Scalars['Boolean']['output']>
  vaFeesExemptStatus?: Maybe<Scalars['Boolean']['output']>
  vaHas6Payments?: Maybe<Scalars['Boolean']['output']>
  vaHas210Days?: Maybe<Scalars['Boolean']['output']>
  vaLoanPurpose?: Maybe<Scalars['String']['output']>
  vaNewRate?: Maybe<Scalars['Float']['output']>
  vaNewTerm?: Maybe<Scalars['String']['output']>
  vaOccupancyCertType?: Maybe<Scalars['String']['output']>
  vaOccupancyCertification?: Maybe<Scalars['Boolean']['output']>
  vaPrevAmortType?: Maybe<Scalars['String']['output']>
  vaPrevBalance?: Maybe<Scalars['Float']['output']>
  vaPrevFirstPaymentDate?: Maybe<Scalars['String']['output']>
  vaPrevPI?: Maybe<Scalars['Float']['output']>
  vaPrevRate?: Maybe<Scalars['Float']['output']>
  vaRecoupEstClosingCosts?: Maybe<Scalars['Float']['output']>
  vaSeasoningCertified?: Maybe<Scalars['Boolean']['output']>
  vaVeteranFirstUse?: Maybe<Scalars['Boolean']['output']>
  vaVeteranStatus?: Maybe<Scalars['Boolean']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type ApplicationRevisionSchema = {
  __typename?: 'ApplicationRevisionSchema'
  address?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  cashOut?: Maybe<Scalars['Int']['output']>
  city?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  dateOfBirth?: Maybe<Scalars['String']['output']>
  debtToIncome?: Maybe<Scalars['Int']['output']>
  declarationAlimony?: Maybe<Scalars['Boolean']['output']>
  declarationBankrupcy?: Maybe<Scalars['Boolean']['output']>
  declarationBorrowedDown?: Maybe<Scalars['Boolean']['output']>
  declarationBorrowedDownFundsAmount?: Maybe<Scalars['Int']['output']>
  declarationCitizen?: Maybe<Scalars['Boolean']['output']>
  declarationDependents?: Maybe<Scalars['Int']['output']>
  declarationEthnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationFhaLoan?: Maybe<Scalars['Boolean']['output']>
  declarationForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationGender?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationHomeOwnership?: Maybe<Scalars['Boolean']['output']>
  declarationJudgements?: Maybe<Scalars['Boolean']['output']>
  declarationLawsuits?: Maybe<Scalars['Boolean']['output']>
  declarationLoanDefaults?: Maybe<Scalars['Boolean']['output']>
  declarationLoanForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationMilitary?: Maybe<Scalars['Boolean']['output']>
  declarationNoteEndorser?: Maybe<Scalars['Boolean']['output']>
  declarationPrimaryResidence?: Maybe<Scalars['Boolean']['output']>
  declarationPropertyTitle?: Maybe<Scalars['String']['output']>
  declarationPropertyType?: Maybe<Scalars['String']['output']>
  declarationRace?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationResident?: Maybe<Scalars['Boolean']['output']>
  declarationSchooling?: Maybe<Scalars['String']['output']>
  declarationVaLoan?: Maybe<Scalars['Boolean']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  escrow?: Maybe<Scalars['Boolean']['output']>
  expenseFirstMortgage?: Maybe<Scalars['Int']['output']>
  expenseHoaDues?: Maybe<Scalars['Int']['output']>
  expenseHomeInsurance?: Maybe<Scalars['Int']['output']>
  expenseMortgageInsurance?: Maybe<Scalars['Int']['output']>
  expensePropertyTaxes?: Maybe<Scalars['Int']['output']>
  expenseRent?: Maybe<Scalars['Int']['output']>
  expenseSecondMortgage?: Maybe<Scalars['Int']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  forbearance?: Maybe<Scalars['Boolean']['output']>
  iceBox?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['Int']['output']
  isCurrentAddress?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Int']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  loanToValue?: Maybe<Scalars['Int']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  militaryDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  militaryServiceMember?: Maybe<Scalars['String']['output']>
  militaryServiceTourDate?: Maybe<Scalars['String']['output']>
  nextRevision?: Maybe<Scalars['Int']['output']>
  notes?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  propertyAttachment?: Maybe<Scalars['String']['output']>
  propertyDownPayment?: Maybe<Scalars['Int']['output']>
  propertyNumberOfStories?: Maybe<Scalars['String']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Int']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyUse?: Maybe<Scalars['String']['output']>
  propertyValue?: Maybe<Scalars['Int']['output']>
  propertyYearBuilt?: Maybe<Scalars['Int']['output']>
  propertyYearPurchased?: Maybe<Scalars['Int']['output']>
  refiReason?: Maybe<Scalars['String']['output']>
  remainingBalance?: Maybe<Scalars['Int']['output']>
  revisionType?: Maybe<Scalars['String']['output']>
  rollInFees?: Maybe<Scalars['Boolean']['output']>
  ssnAlias?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  timeInHome?: Maybe<Scalars['String']['output']>
  titleHolderLegalNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  updatedAt?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type ApplicationSchema = {
  __typename?: 'ApplicationSchema'
  bankrateLeadId?: Maybe<Scalars['String']['output']>
  besmarteeLoanId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditReportIdentifier?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  experienceType?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  leadId?: Maybe<Scalars['Int']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  ntlDisqualifiedReason?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['Int']['output']>
}

export type ApplicationStatusSchema = {
  __typename?: 'ApplicationStatusSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  applicationRevisionId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  status?: Maybe<Scalars['String']['output']>
  statusSource?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type ApplicationTask = {
  __typename?: 'ApplicationTask'
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  status?: Maybe<Scalars['String']['output']>
  task?: Maybe<Task>
  taskId?: Maybe<Scalars['Int']['output']>
  userId?: Maybe<Scalars['Int']['output']>
}

export type ArmDetails = {
  __typename?: 'ArmDetails'
  index?: Maybe<Scalars['Float']['output']>
  indexType?: Maybe<Scalars['String']['output']>
  initialCap?: Maybe<Scalars['Float']['output']>
  lifetimeCap?: Maybe<Scalars['Float']['output']>
  margin?: Maybe<Scalars['Float']['output']>
  periodicCap?: Maybe<Scalars['Float']['output']>
  rateAdjustmentTerm?: Maybe<Scalars['Int']['output']>
  rateFixedTerm?: Maybe<Scalars['Int']['output']>
}

export type ArmDetailsInput = {
  index?: InputMaybe<Scalars['Float']['input']>
  indexType?: InputMaybe<Scalars['String']['input']>
  initialCap?: InputMaybe<Scalars['Float']['input']>
  lifetimeCap?: InputMaybe<Scalars['Float']['input']>
  margin?: InputMaybe<Scalars['Float']['input']>
  periodicCap?: InputMaybe<Scalars['Float']['input']>
  rateAdjustmentTerm?: InputMaybe<Scalars['Int']['input']>
  rateFixedTerm?: InputMaybe<Scalars['Int']['input']>
}

export type AssetInput = {
  accountName?: InputMaybe<Scalars['String']['input']>
  accountNumber?: InputMaybe<Scalars['String']['input']>
  bankName?: InputMaybe<Scalars['String']['input']>
  currentBalance?: InputMaybe<Scalars['Float']['input']>
  deposited?: InputMaybe<Scalars['Boolean']['input']>
  gifterRelationship?: InputMaybe<GifterRelationship>
  id?: InputMaybe<Scalars['Int']['input']>
  marketValue?: InputMaybe<Scalars['Float']['input']>
  numberOfShares?: InputMaybe<Scalars['Int']['input']>
  ownershipClassification?: InputMaybe<OwnershipClassification>
  totalValue?: InputMaybe<Scalars['Float']['input']>
  type?: InputMaybe<AssetType>
}

export type AssetRevisionSchema = {
  __typename?: 'AssetRevisionSchema'
  accountName?: Maybe<Scalars['String']['output']>
  accountNumber?: Maybe<Scalars['String']['output']>
  aiVepaValidationResultId?: Maybe<Scalars['Int']['output']>
  bankName?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  currentBalance?: Maybe<Scalars['Float']['output']>
  deposited?: Maybe<Scalars['Boolean']['output']>
  gifterRelationship?: Maybe<GifterRelationship>
  id?: Maybe<Scalars['Int']['output']>
  marketValue?: Maybe<Scalars['Float']['output']>
  numberOfShares?: Maybe<Scalars['Int']['output']>
  ownershipClassification?: Maybe<OwnershipClassification>
  source?: Maybe<Scalars['String']['output']>
  totalValue?: Maybe<Scalars['Float']['output']>
  type?: Maybe<AssetType>
}

export enum AssetType {
  Bonds = 'Bonds',
  BorrowerPaidOutsideClosing = 'BorrowerPaidOutsideClosing',
  BridgeLoanProceeds = 'BridgeLoanProceeds',
  CashOnHand = 'CashOnHand',
  CashValueOfLifeInsurance = 'CashValueOfLifeInsurance',
  CertificateOfDepositTimeDeposit = 'CertificateOfDepositTimeDeposit',
  Checking = 'Checking',
  EarnestMoneyCashDepositTowardPurchase = 'EarnestMoneyCashDepositTowardPurchase',
  EmployerAssistance = 'EmployerAssistance',
  Gift = 'Gift',
  GiftOfCash = 'GiftOfCash',
  GiftOfPropertyEquity = 'GiftOfPropertyEquity',
  Grant = 'Grant',
  IndividualDevelopmentAccount = 'IndividualDevelopmentAccount',
  LeasePurchaseFund = 'LeasePurchaseFund',
  LotEquity = 'LotEquity',
  MoneyMarket = 'MoneyMarket',
  MutualFund = 'MutualFund',
  OtherLiquidAssets = 'OtherLiquidAssets',
  OtherNonLiquidAssets = 'OtherNonLiquidAssets',
  OtherPurchaseCredit = 'OtherPurchaseCredit',
  ProceedsFromRealEstateProperty = 'ProceedsFromRealEstateProperty',
  ProceedsFromSale = 'ProceedsFromSale',
  RelocationFunds = 'RelocationFunds',
  RentCredit = 'RentCredit',
  Retirement = 'Retirement',
  Savings = 'Savings',
  SecuredBorrowedFundsNotDeposited = 'SecuredBorrowedFundsNotDeposited',
  StockOptions = 'StockOptions',
  Stocks = 'Stocks',
  SweatEquity = 'SweatEquity',
  TradeEquity = 'TradeEquity',
  TrustAccount = 'TrustAccount',
  UnsecuredBorrowedFunds = 'UnsecuredBorrowedFunds',
}

export type AttachLenderLoanIdRequest = {
  applicationId: Scalars['Int']['input']
  lenderLoanId: Scalars['String']['input']
  lenderName: Scalars['String']['input']
  loanOfficerId: Scalars['Int']['input']
  processorId: Scalars['Int']['input']
  requestType: LockRequestType
}

export type AttachmentSchema = {
  __typename?: 'AttachmentSchema'
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  derivedDocumentName?: Maybe<Scalars['String']['output']>
  documentRequestId?: Maybe<Scalars['Int']['output']>
  documentValidations?: Maybe<Array<DocumentValidationRunSchema>>
  encompassId?: Maybe<Scalars['String']['output']>
  excludeFromVepaValidations?: Maybe<Scalars['Boolean']['output']>
  fileName?: Maybe<Scalars['String']['output']>
  ignoreReason?: Maybe<Scalars['String']['output']>
  isAccepted?: Maybe<Scalars['Boolean']['output']>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  uuid?: Maybe<Scalars['String']['output']>
}

export type AttachmentStatusChangeEvent = {
  __typename?: 'AttachmentStatusChangeEvent'
  actorId?: Maybe<Scalars['String']['output']>
  actorType: Scalars['String']['output']
  applicationId: Scalars['Int']['output']
  createdAt: Scalars['String']['output']
  entityId: Scalars['String']['output']
  entityType: Scalars['String']['output']
  eventType: Scalars['String']['output']
  id: Scalars['Int']['output']
  notes?: Maybe<Scalars['String']['output']>
  payload: AttachmentStatusChangePayload
}

export type AttachmentStatusChangePayload = {
  __typename?: 'AttachmentStatusChangePayload'
  attachmentId: Scalars['Int']['output']
  attachmentUuid: Scalars['String']['output']
  conditionId?: Maybe<Scalars['Int']['output']>
  conditionTitle?: Maybe<Scalars['String']['output']>
  confidence?: Maybe<Scalars['Float']['output']>
  documentRequestId?: Maybe<Scalars['Int']['output']>
  documentRequestUuid?: Maybe<Scalars['String']['output']>
  encompassAttachmentId?: Maybe<Scalars['String']['output']>
  encompassLoanId?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  fileName: Scalars['String']['output']
  fileType?: Maybe<Scalars['String']['output']>
  newStatus?: Maybe<Scalars['String']['output']>
  previousStatus?: Maybe<Scalars['String']['output']>
  reasonCode?: Maybe<Scalars['String']['output']>
  sourceAttachmentId?: Maybe<Scalars['Int']['output']>
  sourceAttachmentUuid?: Maybe<Scalars['String']['output']>
  sourceConditionId?: Maybe<Scalars['Int']['output']>
  sourceConditionTitle?: Maybe<Scalars['String']['output']>
  sourceDocumentRequestId?: Maybe<Scalars['Int']['output']>
  sourceDocumentRequestUuid?: Maybe<Scalars['String']['output']>
  syncOutcome?: Maybe<Scalars['String']['output']>
  uploadSource?: Maybe<Scalars['String']['output']>
}

export type AusReportSchema = {
  __typename?: 'AusReportSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  reportDocumentUuid?: Maybe<Scalars['String']['output']>
  reportFileType?: Maybe<Scalars['String']['output']>
  reportSource?: Maybe<Scalars['String']['output']>
  reportType?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type Auth0AccountCreationResponse = {
  __typename?: 'Auth0AccountCreationResponse'
  auth0Id: Scalars['String']['output']
  successful: Scalars['Boolean']['output']
  token?: Maybe<Auth0Token>
}

export type Auth0Token = {
  __typename?: 'Auth0Token'
  access_token?: Maybe<Scalars['String']['output']>
  expires_in?: Maybe<Scalars['Int']['output']>
  token_type?: Maybe<Scalars['String']['output']>
}

export type AuthorSchema = {
  __typename?: 'AuthorSchema'
  id?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  participantId?: Maybe<Scalars['Int']['output']>
}

export type AutoZeroInput = {
  maxCashToClose?: InputMaybe<Scalars['Int']['input']>
  maxLoanToValue?: InputMaybe<Scalars['Float']['input']>
  maxThreshold?: InputMaybe<Scalars['Float']['input']>
  minCashToClose?: InputMaybe<Scalars['Int']['input']>
  rateRequest: RatesRequest
  selectedLoanTerm: ProductTerm
  selectedRate: Scalars['Float']['input']
}

export type AutoZeroResponse = {
  __typename?: 'AutoZeroResponse'
  amountAdded: Scalars['Float']['output']
  cashToClose: Scalars['Float']['output']
  loanToValue: Scalars['Float']['output']
  successfulMatch: Scalars['Boolean']['output']
  totalRollInFees: Scalars['Float']['output']
}

export type AvmPropertyDataRequest = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  apt?: InputMaybe<Scalars['String']['input']>
  city: Scalars['String']['input']
  state: Scalars['String']['input']
  street: Scalars['String']['input']
  zipCode: Scalars['String']['input']
}

export type AvmPropertyDataResult = {
  __typename?: 'AvmPropertyDataResult'
  avmMonthlyPropertyTax?: Maybe<Scalars['Float']['output']>
  avmPropertyType?: Maybe<Scalars['String']['output']>
  avmPropertyValue?: Maybe<Scalars['Int']['output']>
  avmSaleDate?: Maybe<Scalars['String']['output']>
}

export type BankrateAnswers = {
  __typename?: 'BankrateAnswers'
  cashOut?: Maybe<Scalars['Int']['output']>
  city?: Maybe<Scalars['String']['output']>
  currentMortgageBalance?: Maybe<Scalars['Int']['output']>
  currentMortgageRate?: Maybe<Scalars['Float']['output']>
  declarationMilitary?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  estimatedValue?: Maybe<Scalars['Int']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  grossAnnualIncome?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  isTakingCashOut?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  monthlyDebtsAmount?: Maybe<Scalars['Int']['output']>
  phone?: Maybe<Scalars['String']['output']>
  previouslySelectedRate?: Maybe<BankrateSelectedRateAnswer>
  propertyCity?: Maybe<Scalars['String']['output']>
  propertyDownPayment?: Maybe<Scalars['Float']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Float']['output']>
  propertyState?: Maybe<Scalars['String']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyUse?: Maybe<Scalars['String']['output']>
  propertyZip?: Maybe<Scalars['String']['output']>
  remainingBalance?: Maybe<Scalars['Int']['output']>
  state?: Maybe<StateAbbreviation>
  street?: Maybe<Scalars['String']['output']>
  totalAssets?: Maybe<Scalars['Int']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type BankrateCompareLeadInformation = {
  apt?: InputMaybe<Scalars['String']['input']>
  cashOut?: InputMaybe<Scalars['Float']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  declarationFHALoan?: InputMaybe<Scalars['Boolean']['input']>
  declarationMilitary?: InputMaybe<Scalars['Boolean']['input']>
  declarationVALoan?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedValue?: InputMaybe<Scalars['Float']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  leadSource: Scalars['String']['input']
  leadType?: InputMaybe<LeadTypes>
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
  loanPurpose?: InputMaybe<LoanPurposes>
  phone?: InputMaybe<Scalars['String']['input']>
  propertyDownPayment?: InputMaybe<Scalars['Float']['input']>
  propertyPurchasePrice?: InputMaybe<Scalars['Float']['input']>
  propertyType?: InputMaybe<PropertyTypes>
  propertyUse?: InputMaybe<PropertyUses>
  rate?: InputMaybe<CompareRateInput>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  sourceLeadId: Scalars['String']['input']
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type BankrateLead = {
  __typename?: 'BankrateLead'
  agentCompany?: Maybe<Scalars['String']['output']>
  agentEmail?: Maybe<Scalars['String']['output']>
  agentFirstName?: Maybe<Scalars['String']['output']>
  agentLastName?: Maybe<Scalars['String']['output']>
  agentPhone?: Maybe<Scalars['String']['output']>
  annualGrossIncome?: Maybe<Scalars['Int']['output']>
  assetsAmount?: Maybe<Scalars['Int']['output']>
  averageMonthlyExpense?: Maybe<Scalars['Int']['output']>
  averageMonthlyIncome?: Maybe<Scalars['Int']['output']>
  bankrateAprSelection?: Maybe<Scalars['Float']['output']>
  bankrateLeadId: Scalars['String']['output']
  bankrateProductSelection?: Maybe<Scalars['String']['output']>
  bankrateRateSelection?: Maybe<Scalars['Float']['output']>
  cashOutAmount?: Maybe<Scalars['Int']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  currentAddress?: Maybe<Scalars['String']['output']>
  currentCity?: Maybe<Scalars['String']['output']>
  currentState?: Maybe<Scalars['String']['output']>
  debtToIncome?: Maybe<Scalars['Int']['output']>
  deviceType?: Maybe<Scalars['String']['output']>
  downPaymentPercent?: Maybe<Scalars['Float']['output']>
  email?: Maybe<Scalars['String']['output']>
  employmentStatus?: Maybe<Scalars['String']['output']>
  estimatedPropertyValue?: Maybe<Scalars['Int']['output']>
  existingRateType?: Maybe<Scalars['Float']['output']>
  externalChannel?: Maybe<Scalars['String']['output']>
  feesAmount?: Maybe<Scalars['Float']['output']>
  firstMortgageBalance?: Maybe<Scalars['Float']['output']>
  firstMortgageRate?: Maybe<Scalars['Float']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  hasFHALoan?: Maybe<Scalars['Boolean']['output']>
  hasFiledBankruptcy?: Maybe<Scalars['Boolean']['output']>
  hasLatePayment?: Maybe<Scalars['Boolean']['output']>
  hasProofOfIncome?: Maybe<Scalars['Boolean']['output']>
  hasSecondMortgage?: Maybe<Scalars['Boolean']['output']>
  housePurchaseYear?: Maybe<Scalars['Int']['output']>
  isPrimaryLead?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  leadSource?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanOfficerNmls?: Maybe<Scalars['String']['output']>
  loanType?: Maybe<Scalars['String']['output']>
  military?: Maybe<Scalars['Boolean']['output']>
  monthlyDebtsAmount?: Maybe<Scalars['Int']['output']>
  offerTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  otherIncomeSource?: Maybe<Scalars['Float']['output']>
  phone?: Maybe<Scalars['String']['output']>
  propertyAddress?: Maybe<Scalars['String']['output']>
  propertyCity?: Maybe<Scalars['String']['output']>
  propertyStateAbr?: Maybe<StateAbbreviation>
  propertyType?: Maybe<PropertyType>
  propertyUse?: Maybe<PropertyUse>
  propertyZip?: Maybe<Scalars['String']['output']>
  purchasePrice?: Maybe<Scalars['Int']['output']>
  purchaseStep?: Maybe<Scalars['String']['output']>
  refUrl?: Maybe<Scalars['String']['output']>
  userAgent?: Maybe<Scalars['String']['output']>
  verified?: Maybe<Scalars['Boolean']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type BankrateLeadRequest = {
  agentCompany?: InputMaybe<Scalars['String']['input']>
  agentEmail?: InputMaybe<Scalars['String']['input']>
  agentFirstName?: InputMaybe<Scalars['String']['input']>
  agentLastName?: InputMaybe<Scalars['String']['input']>
  agentPhone?: InputMaybe<Scalars['String']['input']>
  annualGrossIncome?: InputMaybe<Scalars['Int']['input']>
  assetsAmount?: InputMaybe<Scalars['Int']['input']>
  averageMonthlyExpense?: InputMaybe<Scalars['Int']['input']>
  averageMonthlyIncome?: InputMaybe<Scalars['Int']['input']>
  bankrateAprSelection?: InputMaybe<Scalars['Float']['input']>
  bankrateLeadId: Scalars['String']['input']
  bankrateProductSelection?: InputMaybe<Scalars['String']['input']>
  bankrateRateSelection?: InputMaybe<Scalars['Float']['input']>
  /** Cash out only specified for Refinance loanTypes */
  cashOutAmount?: InputMaybe<Scalars['Int']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  currentAddress?: InputMaybe<Scalars['String']['input']>
  currentCity?: InputMaybe<Scalars['String']['input']>
  currentState?: InputMaybe<Scalars['String']['input']>
  debtToIncome?: InputMaybe<Scalars['Int']['input']>
  deviceType?: InputMaybe<Scalars['String']['input']>
  /** Down payment only specified for Purchase loanTypes */
  downPaymentPercent?: InputMaybe<Scalars['Float']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  employmentStatus?: InputMaybe<EmploymentStatus>
  /** Estimated property value only specified for Refinance loanTypes */
  estimatedPropertyValue?: InputMaybe<Scalars['Int']['input']>
  /** Existing rate type only specified for Refinance loanTypes */
  existingRateType?: InputMaybe<ExistingRateType>
  externalChannel?: InputMaybe<Scalars['String']['input']>
  feesAmount?: InputMaybe<Scalars['Float']['input']>
  /** First mortgage balance only specified for Refinance loanTypes */
  firstMortgageBalance?: InputMaybe<Scalars['Float']['input']>
  /** First mortgage rate only specified for Refinance loanTypes */
  firstMortgageRate?: InputMaybe<Scalars['Float']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  hasFHALoan?: InputMaybe<Scalars['Boolean']['input']>
  hasFiledBankruptcy?: InputMaybe<Scalars['Boolean']['input']>
  hasLatePayment?: InputMaybe<Scalars['Boolean']['input']>
  hasProofOfIncome?: InputMaybe<Scalars['Boolean']['input']>
  hasSecondMortgage?: InputMaybe<Scalars['Boolean']['input']>
  housePurchaseYear?: InputMaybe<Scalars['Int']['input']>
  isPrimaryLead?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  leadSource?: InputMaybe<Scalars['String']['input']>
  loanAmount?: InputMaybe<Scalars['Float']['input']>
  /** Bankrate Pro specific fields */
  loanOfficerNmls?: InputMaybe<Scalars['String']['input']>
  loanType?: InputMaybe<LoanType>
  military?: InputMaybe<Scalars['Boolean']['input']>
  monthlyDebtsAmount?: InputMaybe<Scalars['Int']['input']>
  offerTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  otherIncomeSource?: InputMaybe<Scalars['Float']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  phoneTcpaId?: InputMaybe<Scalars['String']['input']>
  phoneTcpaProvider?: InputMaybe<Scalars['String']['input']>
  propertyAddress?: InputMaybe<Scalars['String']['input']>
  propertyCity?: InputMaybe<Scalars['String']['input']>
  propertyStateAbr?: InputMaybe<StateAbbreviation>
  propertyType?: InputMaybe<PropertyType>
  propertyUse?: InputMaybe<PropertyUse>
  propertyZip?: InputMaybe<Scalars['String']['input']>
  /** Purchase price only specified for Purchase loanTypes */
  purchasePrice?: InputMaybe<Scalars['Int']['input']>
  purchaseStep?: InputMaybe<Scalars['String']['input']>
  refUrl?: InputMaybe<Scalars['String']['input']>
  textTcpaId?: InputMaybe<Scalars['String']['input']>
  textTcpaProvider?: InputMaybe<Scalars['String']['input']>
  userAgent?: InputMaybe<Scalars['String']['input']>
  verified?: InputMaybe<Scalars['Boolean']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type BankrateSelectedRateAnswer = {
  __typename?: 'BankrateSelectedRateAnswer'
  loanAmount: Scalars['Int']['output']
  rate: Scalars['Float']['output']
  termInMonths: Scalars['Int']['output']
}

export enum BankruptcyTypes {
  ChapterEleven = 'ChapterEleven',
  ChapterSeven = 'ChapterSeven',
  ChapterThirteen = 'ChapterThirteen',
  ChapterTwelve = 'ChapterTwelve',
}

export type BorrowerInfoSchema = {
  __typename?: 'BorrowerInfoSchema'
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
}

export type BorrowerPortalRateSelectionSchema = {
  __typename?: 'BorrowerPortalRateSelectionSchema'
  createdAt?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  productTerm?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Scalars['Float']['output']>
}

export type BulkReassignResponse = {
  __typename?: 'BulkReassignResponse'
  errorCount: Scalars['Int']['output']
  responseMessage?: Maybe<Scalars['String']['output']>
  successCount: Scalars['Int']['output']
}

export type CallFrom = {
  __typename?: 'CallFrom'
  extensionNumber?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
}

export type CallLog = {
  __typename?: 'CallLog'
  action?: Maybe<Scalars['String']['output']>
  direction?: Maybe<Scalars['String']['output']>
  duration?: Maybe<Scalars['Float']['output']>
  from?: Maybe<CallFrom>
  id?: Maybe<Scalars['String']['output']>
  recording?: Maybe<CallRecording>
  result?: Maybe<Scalars['String']['output']>
  sessionId?: Maybe<Scalars['String']['output']>
  startTime?: Maybe<Scalars['String']['output']>
  telephonySessionId?: Maybe<Scalars['String']['output']>
  to?: Maybe<CallTo>
  type?: Maybe<Scalars['String']['output']>
}

/**
 * Substantive recoverable-miss assessment for a voice call. Only populated for
 * users holding the action:view-call-opportunities permission. shouldEscalate
 * distinguishes a high-confidence recoverable opportunity from a lower-confidence
 * review.
 */
export type CallOpportunity = {
  __typename?: 'CallOpportunity'
  borrowerGoal?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  confidence?: Maybe<Scalars['Float']['output']>
  evidence?: Maybe<Array<Maybe<CallOpportunityEvidence>>>
  feedbackAt?: Maybe<Scalars['String']['output']>
  feedbackByName?: Maybe<Scalars['String']['output']>
  feedbackComment?: Maybe<Scalars['String']['output']>
  feedbackScore?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['Int']['output']>
  identifiedConflict?: Maybe<Scalars['String']['output']>
  isSubstantive?: Maybe<Scalars['Boolean']['output']>
  langfuseTraceId?: Maybe<Scalars['String']['output']>
  nonEscalationReason?: Maybe<Scalars['String']['output']>
  proposedRecoveryAction?: Maybe<Scalars['String']['output']>
  shouldEscalate?: Maybe<Scalars['Boolean']['output']>
}

export type CallOpportunityEvidence = {
  __typename?: 'CallOpportunityEvidence'
  paraphrase?: Maybe<Scalars['String']['output']>
  speaker?: Maybe<Scalars['String']['output']>
}

export type CallRecording = {
  __typename?: 'CallRecording'
  contentUri?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  uri?: Maybe<Scalars['String']['output']>
}

export type CallTo = {
  __typename?: 'CallTo'
  extensionNumber?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
}

export type ChecklistTask = {
  __typename?: 'ChecklistTask'
  applicationId?: Maybe<Scalars['Int']['output']>
  field?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  lastUpdated?: Maybe<Scalars['String']['output']>
  result?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type ClosingFeeAnswer = {
  answer: Scalars['String']['input']
  questionName: Scalars['String']['input']
}

export type CoBorrowerAddress = {
  apt?: InputMaybe<Scalars['String']['input']>
  autoCompleteAddressFields?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  moveInDate?: InputMaybe<Scalars['String']['input']>
  moveOutDate?: InputMaybe<Scalars['String']['input']>
  occupancyType?: InputMaybe<OccupancyType>
  rentAmount?: InputMaybe<Scalars['Float']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<AddressType>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type CoBorrowerAddressOutput = {
  __typename?: 'CoBorrowerAddressOutput'
  apt?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  moveInDate?: Maybe<Scalars['String']['output']>
  moveOutDate?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  type?: Maybe<AddressType>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type CoBorrowerApplicationDetailsSchema = {
  __typename?: 'CoBorrowerApplicationDetailsSchema'
  addresses?: Maybe<Array<Maybe<AddressRevisionSchema>>>
  assets?: Maybe<Array<Maybe<AssetRevisionSchema>>>
  creditAuthorized?: Maybe<Scalars['Boolean']['output']>
  demographics?: Maybe<DemographicsRevisionSchema>
  fullLiabilities?: Maybe<LiabilitySchema>
  hasSoftTriMergeConsent?: Maybe<Scalars['Boolean']['output']>
  hasTUConsent?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['Int']['output']>
  incomes?: Maybe<Array<Maybe<IncomeRevisionSchema>>>
  liabilities?: Maybe<Array<Maybe<LiabilityRevisionSchema>>>
  nonTcpaContactConsent?: Maybe<Scalars['Boolean']['output']>
  revision?: Maybe<CoBorrowerApplicationRevisionDetailsSchema>
  tcpaMarketingAndCustomerCareConsent?: Maybe<Scalars['Boolean']['output']>
  tcpaTransactionalConsent?: Maybe<Scalars['Boolean']['output']>
  user?: Maybe<User>
  userId?: Maybe<Scalars['Int']['output']>
  uuid?: Maybe<Scalars['String']['output']>
}

export type CoBorrowerApplicationRevisionDetailsSchema = {
  __typename?: 'CoBorrowerApplicationRevisionDetailsSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  coBorrowerId?: Maybe<Scalars['Int']['output']>
  coBorrowerTermsAndCreditAuthorization?: Maybe<Scalars['Boolean']['output']>
  countryOfCitizenship?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  dateOfBirth?: Maybe<Scalars['String']['output']>
  declarationAlimony?: Maybe<Scalars['Boolean']['output']>
  declarationBankrupcy?: Maybe<Scalars['Boolean']['output']>
  declarationBankruptcyType?: Maybe<Scalars['String']['output']>
  declarationBorrowedDown?: Maybe<Scalars['Boolean']['output']>
  declarationBorrowedDownFundsAmount?: Maybe<Scalars['Float']['output']>
  declarationCitizen?: Maybe<Scalars['Boolean']['output']>
  declarationCitizenStatus?: Maybe<Scalars['String']['output']>
  declarationConveyedTitle?: Maybe<Scalars['Boolean']['output']>
  declarationEthnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationFhaLoan?: Maybe<Scalars['Boolean']['output']>
  declarationForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationGender?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationHomeOwnership?: Maybe<Scalars['Boolean']['output']>
  declarationJudgements?: Maybe<Scalars['Boolean']['output']>
  declarationLawsuits?: Maybe<Scalars['Boolean']['output']>
  declarationLoanDefaults?: Maybe<Scalars['Boolean']['output']>
  declarationLoanForeclosures?: Maybe<Scalars['Boolean']['output']>
  declarationMilitary?: Maybe<Scalars['Boolean']['output']>
  declarationNoteEndorser?: Maybe<Scalars['Boolean']['output']>
  declarationPrimaryResidence?: Maybe<Scalars['Boolean']['output']>
  declarationPropertyTitle?: Maybe<Scalars['String']['output']>
  declarationPropertyType?: Maybe<Scalars['String']['output']>
  declarationRace?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  declarationRelationWithSeller?: Maybe<Scalars['Boolean']['output']>
  declarationResident?: Maybe<Scalars['Boolean']['output']>
  declarationSchooling?: Maybe<Scalars['String']['output']>
  declarationSubjectToLien?: Maybe<Scalars['Boolean']['output']>
  declarationUndisclosedCreditApplicationIndicator?: Maybe<
    Scalars['Boolean']['output']
  >
  declarationVaLoan?: Maybe<Scalars['Boolean']['output']>
  email?: Maybe<Scalars['String']['output']>
  financesUsedToQualify?: Maybe<Scalars['Boolean']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  firstTimeHomeBuyer?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  marriedToPrimary?: Maybe<Scalars['Boolean']['output']>
  middleName?: Maybe<Scalars['String']['output']>
  militaryDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  militaryServiceTourDate?: Maybe<Scalars['String']['output']>
  nameAliases?: Maybe<Array<Maybe<NameAlias>>>
  nextRevision?: Maybe<Scalars['Int']['output']>
  nonSpousePropertyRights?: Maybe<Scalars['Boolean']['output']>
  nonSpousePropertyRightsState?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRightsType?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  revisionType?: Maybe<Scalars['String']['output']>
  sameAddressAsPrimary?: Maybe<Scalars['Boolean']['output']>
  ssnAlias?: Maybe<Scalars['String']['output']>
  suffix?: Maybe<Scalars['String']['output']>
  undisclosedBorrowedFundsAmount?: Maybe<Scalars['Float']['output']>
  undisclosedBorrowedFundsIndicator?: Maybe<Scalars['Boolean']['output']>
}

export type CoBorrowerPersonalInfo = {
  addDependentAges?: InputMaybe<Array<InputMaybe<DependentAge>>>
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  declarationCitizenStatus?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  haveDependents?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  marriedToPrimary?: InputMaybe<Scalars['Boolean']['input']>
  nonSpousePropertyRights?: InputMaybe<Scalars['Boolean']['input']>
  nonSpousePropertyRightsState?: InputMaybe<Scalars['String']['input']>
  nonSpousePropertyRightsType?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
  tcpaDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  tcpaDisclosureSmsOptIn?: InputMaybe<Scalars['Boolean']['input']>
  tcpaMarketingAndCustomerCareConsent?: InputMaybe<Scalars['Boolean']['input']>
  tcpaTransactionalConsent?: InputMaybe<Scalars['Boolean']['input']>
}

export type CoBorrowerPersonalInfoOutput = {
  __typename?: 'CoBorrowerPersonalInfoOutput'
  addDependentAges?: Maybe<Array<Maybe<DependentAgeOutput>>>
  dateOfBirth?: Maybe<Scalars['String']['output']>
  declarationCitizenStatus?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  marriedToPrimary?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRights?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRightsState?: Maybe<Scalars['String']['output']>
  nonSpousePropertyRightsType?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  tcpaDisclosure?: Maybe<Scalars['Boolean']['output']>
}

export type CommunicationLog = {
  __typename?: 'CommunicationLog'
  email?: Maybe<Scalars['String']['output']>
  messages?: Maybe<Array<Maybe<CommunicationLogMessage>>>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type CommunicationLogMessage = {
  __typename?: 'CommunicationLogMessage'
  automatedNote?: Maybe<Scalars['String']['output']>
  callOpportunity?: Maybe<CallOpportunity>
  createdAt?: Maybe<Scalars['String']['output']>
  emailSource?: Maybe<EmailSource>
  emailStatus?: Maybe<EmailStatus>
  link?: Maybe<Scalars['String']['output']>
  logType?: Maybe<CommunicationLogType>
  sender?: Maybe<Sender>
  subject?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type CommunicationLogResponse = {
  __typename?: 'CommunicationLogResponse'
  borrower?: Maybe<CommunicationLog>
  coBorrower?: Maybe<CommunicationLog>
}

export enum CommunicationLogType {
  Email = 'email',
  Fax = 'fax',
  Phone = 'phone',
  Sms = 'sms',
  Status = 'status',
}

export type CompareCreditScoresResponse = {
  __typename?: 'CompareCreditScoresResponse'
  isEqual?: Maybe<Scalars['Boolean']['output']>
}

export type CompareRateInput = {
  adjustments?: InputMaybe<Array<InputMaybe<AdjustmentInput>>>
  adjustmentsTotal?: InputMaybe<Scalars['Float']['input']>
  apr?: InputMaybe<Scalars['Float']['input']>
  borrowerName?: InputMaybe<Scalars['String']['input']>
  cashOut?: InputMaybe<Scalars['Int']['input']>
  combinedLoanToValue?: InputMaybe<Scalars['Float']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  discountOrCreditAmount?: InputMaybe<Scalars['Float']['input']>
  discountPoints?: InputMaybe<Scalars['Float']['input']>
  discountPointsAsDollarAmount?: InputMaybe<Scalars['Float']['input']>
  escrowFees?: InputMaybe<Scalars['Float']['input']>
  family?: InputMaybe<Scalars['String']['input']>
  fees?: InputMaybe<Array<InputMaybe<FeesInput>>>
  fewerUpfrontCosts?: InputMaybe<Scalars['Float']['input']>
  finalPrice?: InputMaybe<Scalars['Float']['input']>
  isRollInEscrow?: InputMaybe<Scalars['Boolean']['input']>
  lenderName?: InputMaybe<Scalars['String']['input']>
  loanAmount?: InputMaybe<Scalars['Float']['input']>
  loanEstimateSections?: InputMaybe<LoanEstimateSectionsInput>
  loanOfficer?: InputMaybe<LoanOfficerDisplayInfoInput>
  loanPurpose?: InputMaybe<Scalars['String']['input']>
  loanTerm?: InputMaybe<Scalars['Int']['input']>
  loanToValue?: InputMaybe<Scalars['Float']['input']>
  lockId?: InputMaybe<Scalars['String']['input']>
  lockPeriod?: InputMaybe<Scalars['Int']['input']>
  monthlyEscrowFees?: InputMaybe<Scalars['Float']['input']>
  monthlyInsurance?: InputMaybe<Scalars['Float']['input']>
  monthlyPayment?: InputMaybe<Scalars['Float']['input']>
  monthlyPropertyTax?: InputMaybe<Scalars['Float']['input']>
  mortgageInsurancePremium?: InputMaybe<MortgageInsurancePremiumInput>
  originationPoints?: InputMaybe<Scalars['Float']['input']>
  points?: InputMaybe<Scalars['Int']['input']>
  principleAndInterestPayment?: InputMaybe<Scalars['Float']['input']>
  productClass?: InputMaybe<ProductClass>
  propertyValue?: InputMaybe<Scalars['Float']['input']>
  quoteType?: InputMaybe<Scalars['String']['input']>
  rate?: InputMaybe<Scalars['Float']['input']>
  rollInFees?: InputMaybe<Scalars['Int']['input']>
  silkFees?: InputMaybe<Array<InputMaybe<FeesInput>>>
  subordinateLienAmount?: InputMaybe<Scalars['Int']['input']>
  term?: InputMaybe<Scalars['String']['input']>
  totalLenderFees?: InputMaybe<Scalars['Float']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type ConditionCheck = {
  __typename?: 'ConditionCheck'
  details?: Maybe<ConditionCheckDetails>
  pass?: Maybe<Scalars['Boolean']['output']>
}

export type ConditionCheckDetails = {
  __typename?: 'ConditionCheckDetails'
  assetRevisionAccountLastFourDigits?: Maybe<
    Array<Maybe<AccountLastFourDigits>>
  >
  assetRevisionAccountNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  incomeRevisionEmployerNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  ocrAccountLastFourDigits?: Maybe<Array<Maybe<AccountLastFourDigits>>>
  ocrAccountNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  ocrEmployerNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type ConditionInput = {
  description?: InputMaybe<Scalars['String']['input']>
  documentRequests?: InputMaybe<Array<InputMaybe<DocumentRequestInput>>>
  expirationDate?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<ConditionType>
  uuid?: InputMaybe<Scalars['String']['input']>
}

export type ConditionSchema = {
  __typename?: 'ConditionSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  coBorrowerApplicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  documentRequests?: Maybe<Array<Maybe<DocumentRequestSchema>>>
  expirationDate?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  source?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<ConditionType>
  uuid?: Maybe<Scalars['String']['output']>
}

export type ConditionTimelineEvent = {
  __typename?: 'ConditionTimelineEvent'
  actorId?: Maybe<Scalars['String']['output']>
  actorType: Scalars['String']['output']
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['String']['output']
  entityId: Scalars['String']['output']
  entityType: Scalars['String']['output']
  eventType: Scalars['String']['output']
  id: Scalars['Int']['output']
  notes?: Maybe<Scalars['String']['output']>
  payload: TimelineEventPayload
}

export enum ConditionType {
  PostClosing = 'PostClosing',
  Preliminary = 'Preliminary',
  Underwriting = 'Underwriting',
}

export type ConfigurationFieldInput = {
  hasAutoTextMessagesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isAnnalyLoanCareEligible?: InputMaybe<Scalars['Boolean']['input']>
  isBestMoneyEligible?: InputMaybe<Scalars['Boolean']['input']>
  isEmployeeLoansEligible?: InputMaybe<Scalars['Boolean']['input']>
  isHomeEquityEligible?: InputMaybe<Scalars['Boolean']['input']>
  isPhoenixEligible?: InputMaybe<Scalars['Boolean']['input']>
  isPurchaseEligible?: InputMaybe<Scalars['Boolean']['input']>
  isRefinanceEligible?: InputMaybe<Scalars['Boolean']['input']>
  isRobinhoodConciergeEligible?: InputMaybe<Scalars['Boolean']['input']>
  isRobinhoodEligible?: InputMaybe<Scalars['Boolean']['input']>
}

export type ConfigurationFields = {
  __typename?: 'ConfigurationFields'
  hasAutoTextMessagesEnabled?: Maybe<Scalars['Boolean']['output']>
  isAnnalyLoanCareEligible?: Maybe<Scalars['Boolean']['output']>
  isBestMoneyEligible?: Maybe<Scalars['Boolean']['output']>
  isEmployeeLoansEligible?: Maybe<Scalars['Boolean']['output']>
  isHomeEquityEligible?: Maybe<Scalars['Boolean']['output']>
  isPhoenixEligible?: Maybe<Scalars['Boolean']['output']>
  isPurchaseEligible?: Maybe<Scalars['Boolean']['output']>
  isRefinanceEligible?: Maybe<Scalars['Boolean']['output']>
  isRobinhoodConciergeEligible?: Maybe<Scalars['Boolean']['output']>
  isRobinhoodEligible?: Maybe<Scalars['Boolean']['output']>
}

export type ContactInfo = {
  __typename?: 'ContactInfo'
  at?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type ContactTemplate = {
  __typename?: 'ContactTemplate'
  id?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  retoolId?: Maybe<Scalars['Int']['output']>
  retoolUserType?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type CreateLoanOfficerInput = {
  NMLS?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  encompassId?: InputMaybe<Scalars['String']['input']>
  headshot?: InputMaybe<Scalars['String']['input']>
  isLoanCoordinator?: InputMaybe<Scalars['Boolean']['input']>
  isManager?: InputMaybe<Scalars['Boolean']['input']>
  loanCoordinatorId?: InputMaybe<Scalars['Int']['input']>
  managerId?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  slackUserId?: InputMaybe<Scalars['String']['input']>
  slackUsername?: InputMaybe<Scalars['String']['input']>
}

export type CreditData = {
  __typename?: 'CreditData'
  applicationFicoScore?: Maybe<Scalars['Int']['output']>
  borrowersCreditReports?: Maybe<Array<Maybe<CreditReportSchema>>>
}

export type CreditDataSchema = {
  __typename?: 'CreditDataSchema'
  creditReportErrors?: Maybe<Array<Maybe<CreditReportErrorSchema>>>
  creditReports?: Maybe<Array<Maybe<CreditReportDetailsSchema>>>
  ficoCreditScore?: Maybe<Scalars['Int']['output']>
  ficoCreditScoreTimestamp?: Maybe<Scalars['String']['output']>
  hardPullScore?: Maybe<Scalars['Int']['output']>
  hasErrors?: Maybe<Scalars['Boolean']['output']>
  hasTransUnionSoftPullErrors?: Maybe<Scalars['Boolean']['output']>
  isFicoCreditScoreHard?: Maybe<Scalars['Boolean']['output']>
  softCreditScore?: Maybe<Scalars['Int']['output']>
  softTriMergeScore?: Maybe<Scalars['Int']['output']>
  transUnionSoftCreditScore?: Maybe<Scalars['Int']['output']>
}

export type CreditReportDetailsSchema = {
  __typename?: 'CreditReportDetailsSchema'
  borrowerClassification?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  identifier?: Maybe<Scalars['Float']['output']>
  prequalEquifax?: Maybe<Scalars['Int']['output']>
  prequalExperian?: Maybe<Scalars['Int']['output']>
  prequalIdentifier?: Maybe<Scalars['Float']['output']>
  prequalTransunion?: Maybe<Scalars['Int']['output']>
  provider?: Maybe<Scalars['String']['output']>
  requestType?: Maybe<Scalars['String']['output']>
  score?: Maybe<Scalars['Int']['output']>
  scoreEquifax?: Maybe<Scalars['Int']['output']>
  scoreExperian?: Maybe<Scalars['Int']['output']>
  scoreTransunion?: Maybe<Scalars['Int']['output']>
}

export type CreditReportErrorSchema = {
  __typename?: 'CreditReportErrorSchema'
  code?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  sourceType?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type CreditReportSchema = {
  __typename?: 'CreditReportSchema'
  borrowerClassification?: Maybe<Scalars['String']['output']>
  scoreEquifax?: Maybe<Scalars['Int']['output']>
  scoreExperian?: Maybe<Scalars['Int']['output']>
  scoreSoft?: Maybe<Scalars['Int']['output']>
  scoreTransunion?: Maybe<Scalars['Int']['output']>
}

export type CurrentLoanDetails = {
  __typename?: 'CurrentLoanDetails'
  currentMonthlyPayment?: Maybe<Scalars['Float']['output']>
  currentRate?: Maybe<Scalars['Float']['output']>
  remainingBalance?: Maybe<Scalars['Float']['output']>
  remainingMonths?: Maybe<Scalars['Int']['output']>
}

export type CycleTimes = {
  __typename?: 'CycleTimes'
  closing?: Maybe<Scalars['String']['output']>
  ctcDate?: Maybe<Scalars['String']['output']>
  disclosure?: Maybe<Scalars['String']['output']>
}

export type DtiCalculationsSchema = {
  __typename?: 'DTICalculationsSchema'
  allLiabilityExpenses?: Maybe<Scalars['Float']['output']>
  includedLiabilityIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  linkedLiabilityExpenses?: Maybe<Scalars['Float']['output']>
  netDTIRentalIncome?: Maybe<Scalars['Float']['output']>
}

export type DateRange = {
  from?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
}

export type DateRangeInput = {
  from?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
}

export type DebtToIncomeBreakdown = {
  __typename?: 'DebtToIncomeBreakdown'
  debtToIncome?: Maybe<Scalars['Float']['output']>
  expensesBreakdown?: Maybe<Array<Maybe<ExpenseBreakdownItem>>>
  incomeBreakdown?: Maybe<Array<Maybe<IncomeBreakdownItem>>>
  totalMonthlyDebts?: Maybe<Scalars['Float']['output']>
  totalMonthlyIncome?: Maybe<Scalars['Float']['output']>
}

export type DemographicsAnswers = {
  americanIndianTribeDesc?: InputMaybe<Scalars['String']['input']>
  asianOtherSubtypeDesc?: InputMaybe<Scalars['String']['input']>
  asianSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  ethnicity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  hispanicOtherSubtypeDesc?: InputMaybe<Scalars['String']['input']>
  hispanicSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Scalars['Int']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  languageOtherDesc?: InputMaybe<Scalars['String']['input']>
  pacificIslanderOtherSubtypeDesc?: InputMaybe<Scalars['String']['input']>
  pacificIslanderSubtype?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  race?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sex?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type DemographicsOutput = {
  __typename?: 'DemographicsOutput'
  americanIndianTribeDesc?: Maybe<Scalars['String']['output']>
  asianOtherSubtypeDesc?: Maybe<Scalars['String']['output']>
  asianSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  ethnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  hispanicOtherSubtypeDesc?: Maybe<Scalars['String']['output']>
  hispanicSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  id?: Maybe<Scalars['Int']['output']>
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  languageOtherDesc?: Maybe<Scalars['String']['output']>
  pacificIslanderOtherSubtypeDesc?: Maybe<Scalars['String']['output']>
  pacificIslanderSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  race?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  sex?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type DemographicsRevisionSchema = {
  __typename?: 'DemographicsRevisionSchema'
  americanIndianTribeDesc?: Maybe<Scalars['String']['output']>
  asianOtherSubtypeDesc?: Maybe<Scalars['String']['output']>
  asianSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  createdAt?: Maybe<Scalars['String']['output']>
  ethnicity?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  hispanicOtherSubtypeDesc?: Maybe<Scalars['String']['output']>
  hispanicSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  id?: Maybe<Scalars['Int']['output']>
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  languageOtherDesc?: Maybe<Scalars['String']['output']>
  pacificIslanderOtherSubtypeDesc?: Maybe<Scalars['String']['output']>
  pacificIslanderSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  race?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  sex?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type DependentAge = {
  dependentAge?: InputMaybe<Scalars['Float']['input']>
}

export type DependentAgeOutput = {
  __typename?: 'DependentAgeOutput'
  dependentAge?: Maybe<Scalars['Int']['output']>
}

export type DirectMailerAnswers = {
  __typename?: 'DirectMailerAnswers'
  city?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type DisclosureInformation = {
  disclosureText: Scalars['String']['input']
  disclosureType: DisclosureType
}

export type DisclosureTrackingRecipientSchema = {
  __typename?: 'DisclosureTrackingRecipientSchema'
  completedAt?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deliveredAt?: Maybe<Scalars['String']['output']>
  deliveryFailedAt?: Maybe<Scalars['String']['output']>
  deliveryFailedReason?: Maybe<Scalars['String']['output']>
  disclosureTrackingId?: Maybe<Scalars['Int']['output']>
  email?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  ipAddress?: Maybe<Scalars['String']['output']>
  recipientType?: Maybe<Scalars['String']['output']>
  sentAt?: Maybe<Scalars['String']['output']>
}

export type DisclosureTrackingSchema = {
  __typename?: 'DisclosureTrackingSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  classification?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  disclosureType?: Maybe<Scalars['String']['output']>
  encompassId?: Maybe<Scalars['String']['output']>
  envelopeCompletedAt?: Maybe<Scalars['String']['output']>
  envelopeDeliveredAt?: Maybe<Scalars['String']['output']>
  envelopeId?: Maybe<Scalars['String']['output']>
  externalEventId?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['Int']['output']>
  recipients?: Maybe<Array<Maybe<DisclosureTrackingRecipientSchema>>>
}

export enum DisclosureType {
  AffiliatedBusinessArrangement = 'AffiliatedBusinessArrangement',
  BankrateProAgentSharingConsent = 'BankrateProAgentSharingConsent',
  CreditAuthorization = 'CreditAuthorization',
  ElectronicConsent = 'ElectronicConsent',
  Glba = 'GLBA',
  MigrationConsent = 'MigrationConsent',
  NonTcpaContactConsent = 'NonTcpaContactConsent',
  PrivacyPolicy = 'PrivacyPolicy',
  SoftCreditConsent = 'SoftCreditConsent',
  Tcpa = 'TCPA',
  TcpaSmsOptIn = 'TCPASmsOptIn',
  TcpaMarketingAndCustomerCareConsent = 'TcpaMarketingAndCustomerCareConsent',
  TcpaTransactionalConsent = 'TcpaTransactionalConsent',
  TermsOfUse = 'TermsOfUse',
  TransUnionSoftCreditConsent = 'TransUnionSoftCreditConsent',
}

export type DocumentExtractSchema = {
  __typename?: 'DocumentExtractSchema'
  applicationGuid?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  extractedData?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  uploadGuid?: Maybe<Scalars['String']['output']>
}

export type DocumentRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  uuid?: InputMaybe<Scalars['String']['input']>
}

export type DocumentRequestNote = {
  __typename?: 'DocumentRequestNote'
  author?: Maybe<DocumentRequestNoteAuthor>
  createdAt?: Maybe<Scalars['String']['output']>
  documentRequestId?: Maybe<Scalars['Int']['output']>
  text?: Maybe<Scalars['String']['output']>
  uuid?: Maybe<Scalars['String']['output']>
}

export type DocumentRequestNoteAuthor = {
  __typename?: 'DocumentRequestNoteAuthor'
  email?: Maybe<Scalars['String']['output']>
  headshotLink?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type DocumentRequestNoteInput = {
  documentRequestUuid: Scalars['String']['input']
  retoolId?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type DocumentRequestSchema = {
  __typename?: 'DocumentRequestSchema'
  accessLevel?: Maybe<Scalars['String']['output']>
  attachments?: Maybe<Array<Maybe<AttachmentSchema>>>
  createdAt?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  encompassId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latestNote?: Maybe<DocumentRequestNote>
  status?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  uuid?: Maybe<Scalars['String']['output']>
}

export type DocumentValidationRunSchema = {
  __typename?: 'DocumentValidationRunSchema'
  attachmentUuid?: Maybe<Scalars['String']['output']>
  confidence?: Maybe<Scalars['Float']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  executionId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  langfuseTraceId?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  validationType?: Maybe<Scalars['String']['output']>
}

/**
 * A single row from the `docutech_document_distributions` table, populated
 * by the Docutech webhook processor lambda.
 */
export type DocutechDocumentDistributionSchema = {
  __typename?: 'DocutechDocumentDistributionSchema'
  consentDeniedAt?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  /** Non-null when this row has been superseded by a redistribution. */
  deletedAt?: Maybe<Scalars['String']['output']>
  docLink?: Maybe<Scalars['String']['output']>
  docLinkExpireDate?: Maybe<Scalars['String']['output']>
  /** One of: 'Initial Disclosure', 'Redisclosure', 'Pre-Closing', 'Closing'. */
  documentPackageType?: Maybe<Scalars['String']['output']>
  emailAddress?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  loanNumber?: Maybe<Scalars['String']['output']>
  partyName?: Maybe<Scalars['String']['output']>
  /** One of: 'borrower', 'coborrower', 'other', 'lender', 'non_purchasing_entity'. */
  partyRole?: Maybe<Scalars['String']['output']>
  signCompletedAt?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export enum EmailSource {
  Graph = 'graph',
  Iterable = 'iterable',
  Sendgrid = 'sendgrid',
}

export enum EmailStatus {
  Bounced = 'bounced',
  Clicked = 'clicked',
  Delivered = 'delivered',
  Dropped = 'dropped',
  Opened = 'opened',
  Sent = 'sent',
  Spam = 'spam',
  Unsubscribed = 'unsubscribed',
}

export enum EmploymentStatus {
  Employed = 'Employed',
  Military = 'Military',
  NotEmployed = 'NotEmployed',
  Other = 'Other',
  SelfEmployed = 'SelfEmployed',
}

export type EncompassLoanImportSchema = {
  __typename?: 'EncompassLoanImportSchema'
  actionDate?: Maybe<Scalars['String']['output']>
  actionTaken?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  appraisalOrderedDate?: Maybe<Scalars['String']['output']>
  appraisalReceivedDate?: Maybe<Scalars['String']['output']>
  appraisalValue?: Maybe<Scalars['Int']['output']>
  ausRunDate?: Maybe<Scalars['String']['output']>
  borrowerEsignDate?: Maybe<Scalars['String']['output']>
  cashAtClose?: Maybe<Scalars['Float']['output']>
  clearToCloseOn?: Maybe<Scalars['String']['output']>
  closerName?: Maybe<Scalars['String']['output']>
  closingDateConfirmed?: Maybe<Scalars['String']['output']>
  conditionallyApprovedOn?: Maybe<Scalars['String']['output']>
  contractContingencyDate?: Maybe<Scalars['String']['output']>
  contractSigned?: Maybe<Scalars['String']['output']>
  copaSubmitDate?: Maybe<Scalars['String']['output']>
  counterOfferAccepted?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditedUnderwriter?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  deniedOn?: Maybe<Scalars['String']['output']>
  docDateConfirmed?: Maybe<Scalars['String']['output']>
  docSignDateConfirmed?: Maybe<Scalars['String']['output']>
  dti?: Maybe<Scalars['Float']['output']>
  edisclosureSignedOn?: Maybe<Scalars['String']['output']>
  estClosingDate?: Maybe<Scalars['String']['output']>
  finalCdSentDate?: Maybe<Scalars['String']['output']>
  floodInsRequired?: Maybe<Scalars['Boolean']['output']>
  fundedOn?: Maybe<Scalars['String']['output']>
  gainLossPercentage?: Maybe<Scalars['Float']['output']>
  gainLossTotal?: Maybe<Scalars['Int']['output']>
  hmdaActionTaken?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lenderLoanId?: Maybe<Scalars['String']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  loEsignDate?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Int']['output']>
  loanProduct?: Maybe<Scalars['String']['output']>
  lockExpirationDate?: Maybe<Scalars['String']['output']>
  lockPeriod?: Maybe<Scalars['String']['output']>
  lockRequestDti?: Maybe<Scalars['Float']['output']>
  lockedOn?: Maybe<Scalars['String']['output']>
  ltv?: Maybe<Scalars['Float']['output']>
  moveToFundDate?: Maybe<Scalars['String']['output']>
  orderOutsFlood?: Maybe<Scalars['String']['output']>
  orderOutsFraud?: Maybe<Scalars['String']['output']>
  orderOutsHazard?: Maybe<Scalars['String']['output']>
  orderOutsPayoff1?: Maybe<Scalars['String']['output']>
  orderOutsPayoff2?: Maybe<Scalars['String']['output']>
  orderOutsPurchaseContract?: Maybe<Scalars['String']['output']>
  orderOutsTitle?: Maybe<Scalars['String']['output']>
  orderOutsWvoe?: Maybe<Scalars['String']['output']>
  orderRecdFlood?: Maybe<Scalars['String']['output']>
  orderRecdFraud?: Maybe<Scalars['String']['output']>
  orderRecdHazard?: Maybe<Scalars['String']['output']>
  orderRecdPayoff1?: Maybe<Scalars['String']['output']>
  orderRecdPayoff2?: Maybe<Scalars['String']['output']>
  orderRecdPurchaseContract?: Maybe<Scalars['String']['output']>
  orderRecdTitle?: Maybe<Scalars['String']['output']>
  orderRecdWvoe?: Maybe<Scalars['String']['output']>
  originalLockPeriod?: Maybe<Scalars['Int']['output']>
  paymentServicerAddress?: Maybe<Scalars['String']['output']>
  paymentServicerCity?: Maybe<Scalars['String']['output']>
  paymentServicerContactName?: Maybe<Scalars['String']['output']>
  paymentServicerEmail?: Maybe<Scalars['String']['output']>
  paymentServicerFax?: Maybe<Scalars['String']['output']>
  paymentServicerName?: Maybe<Scalars['String']['output']>
  paymentServicerPhone?: Maybe<Scalars['String']['output']>
  paymentServicerPostalCode?: Maybe<Scalars['String']['output']>
  paymentServicerState?: Maybe<Scalars['String']['output']>
  preapprovalCreditOnly?: Maybe<Scalars['String']['output']>
  preapprovalDate?: Maybe<Scalars['String']['output']>
  preapprovalPortfolioLoan?: Maybe<Scalars['String']['output']>
  preapprovalUwOnly?: Maybe<Scalars['String']['output']>
  propertyInspectionWaiverEligible?: Maybe<Scalars['Boolean']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Scalars['Float']['output']>
  salesContractDate?: Maybe<Scalars['String']['output']>
  submitToCtcDate?: Maybe<Scalars['String']['output']>
  submittedToUnderwritingOn?: Maybe<Scalars['String']['output']>
  suspendedOn?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  vepaReviewerName?: Maybe<Scalars['String']['output']>
  vepaSubmitDate?: Maybe<Scalars['String']['output']>
  withdrawnOn?: Maybe<Scalars['String']['output']>
}

export type ErrorDataSchema = {
  __typename?: 'ErrorDataSchema'
  eventName?: Maybe<Scalars['String']['output']>
  exists?: Maybe<Scalars['Boolean']['output']>
  sensitive?: Maybe<Scalars['JSON']['output']>
}

export type ErrorPage = {
  __typename?: 'ErrorPage'
  body?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  name: Scalars['String']['output']
  primaryCtaLink?: Maybe<StoryblokSchemaLink>
  primaryCtaTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export enum EscrowOptions {
  InsuranceOnly = 'InsuranceOnly',
  TaxesAndInsurance = 'TaxesAndInsurance',
  TaxesOnly = 'TaxesOnly',
}

export type EventTag = {
  key: Scalars['String']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export enum ExistingRateType {
  Adjustable = 'Adjustable',
  Fixed = 'Fixed',
}

export type ExistingUserEmailDetails = {
  __typename?: 'ExistingUserEmailDetails'
  createdAt?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['Int']['output']>
}

export type ExpenseBreakdownItem = {
  __typename?: 'ExpenseBreakdownItem'
  amount?: Maybe<Scalars['Float']['output']>
  creditor?: Maybe<Scalars['String']['output']>
  liabilityType?: Maybe<Scalars['String']['output']>
}

export enum ExperienceType {
  Baseline = 'Baseline',
  Ntl = 'NTL',
}

export type ExternalRateSeenSchema = {
  __typename?: 'ExternalRateSeenSchema'
  apr?: Maybe<Scalars['Float']['output']>
  product?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Scalars['Float']['output']>
  termMonths?: Maybe<Scalars['Int']['output']>
}

export type Fees = {
  __typename?: 'Fees'
  amount?: Maybe<Scalars['Float']['output']>
  description?: Maybe<Scalars['String']['output']>
  lineNumber?: Maybe<Scalars['String']['output']>
}

export type FeesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  lineNumber?: InputMaybe<Scalars['String']['input']>
}

export type FillCoBorrowerResponse = {
  __typename?: 'FillCoBorrowerResponse'
  coBorrowerId: Scalars['Int']['output']
}

export type FillReoResponse = {
  __typename?: 'FillReoResponse'
  realEstateOwnedIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
}

export type FilterOptions = {
  iceboxNotes?: InputMaybe<Scalars['String']['input']>
  reminderType?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type GeneratedDocumentsPipeline = {
  __typename?: 'GeneratedDocumentsPipeline'
  applicationId?: Maybe<Scalars['Int']['output']>
  applicationUuid?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  createdBy?: Maybe<Scalars['Int']['output']>
  documentClassification?: Maybe<Scalars['String']['output']>
  documentId?: Maybe<Scalars['Int']['output']>
  documentUuid?: Maybe<Scalars['String']['output']>
  loanOfficerName?: Maybe<Scalars['String']['output']>
}

export type GeneratedDocumentsPipelineRequest = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  createdAtRange?: InputMaybe<DateRange>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  documentClassification?: InputMaybe<Scalars['String']['input']>
  pagination?: InputMaybe<Pagination>
  sortBy?: InputMaybe<Scalars['String']['input']>
  sortDirection?: InputMaybe<Scalars['String']['input']>
}

export type GeneratedDocumentsPipelineResponse = {
  __typename?: 'GeneratedDocumentsPipelineResponse'
  pagination?: Maybe<PaginationResponse>
  records?: Maybe<Array<Maybe<GeneratedDocumentsPipeline>>>
}

export type GetAnswersResult = {
  __typename?: 'GetAnswersResult'
  applicationAnswers?: Maybe<ApplicationAnswersOutput>
  bankrateAnswers?: Maybe<BankrateAnswers>
  directMailerAnswers?: Maybe<DirectMailerAnswers>
}

export enum GifterRelationship {
  CommunityNonProfit = 'CommunityNonProfit',
  Employer = 'Employer',
  FederalAgency = 'FederalAgency',
  Lender = 'Lender',
  LocalAgency = 'LocalAgency',
  Other = 'Other',
  Parent = 'Parent',
  Relative = 'Relative',
  ReligiousNonProfit = 'ReligiousNonProfit',
  StateAgency = 'StateAgency',
  UnmarriedPartner = 'UnmarriedPartner',
  UnrelatedFriend = 'UnrelatedFriend',
}

export type GoogleAddressComponent = {
  __typename?: 'GoogleAddressComponent'
  componentName?: Maybe<GoogleAddressComponentName>
  componentType?: Maybe<Scalars['String']['output']>
  confirmationLevel?: Maybe<Scalars['String']['output']>
  inferred?: Maybe<Scalars['Boolean']['output']>
  replaced?: Maybe<Scalars['Boolean']['output']>
  spellCorrected?: Maybe<Scalars['Boolean']['output']>
  unexpected?: Maybe<Scalars['Boolean']['output']>
}

export type GoogleAddressComponentName = {
  __typename?: 'GoogleAddressComponentName'
  languageCode?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export enum GoogleApiStatusCode {
  InvalidRequest = 'INVALID_REQUEST',
  Ok = 'OK',
  ZeroResults = 'ZERO_RESULTS',
}

export type GoogleAutoCompletePrediction = {
  __typename?: 'GoogleAutoCompletePrediction'
  description?: Maybe<Scalars['String']['output']>
}

export type GoogleAutoCompleteResult = {
  __typename?: 'GoogleAutoCompleteResult'
  predictions?: Maybe<Array<Maybe<GoogleAutoCompletePrediction>>>
  status?: Maybe<GoogleApiStatusCode>
}

export type GoogleGeolocationAddressComponent = {
  __typename?: 'GoogleGeolocationAddressComponent'
  long_name?: Maybe<Scalars['String']['output']>
  short_name?: Maybe<Scalars['String']['output']>
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type GoogleGeolocationGeometryComponent = {
  __typename?: 'GoogleGeolocationGeometryComponent'
  location?: Maybe<GoogleGeolocationLocationComponent>
}

export type GoogleGeolocationLocationComponent = {
  __typename?: 'GoogleGeolocationLocationComponent'
  lat?: Maybe<Scalars['Float']['output']>
  lng?: Maybe<Scalars['Float']['output']>
}

export type GoogleGeolocationMatch = {
  __typename?: 'GoogleGeolocationMatch'
  address_components?: Maybe<Array<Maybe<GoogleGeolocationAddressComponent>>>
  geometry?: Maybe<GoogleGeolocationGeometryComponent>
}

export type GoogleGeolocationResult = {
  __typename?: 'GoogleGeolocationResult'
  results?: Maybe<Array<Maybe<GoogleGeolocationMatch>>>
  status?: Maybe<GoogleApiStatusCode>
}

export type GoogleTimeZoneResult = {
  __typename?: 'GoogleTimeZoneResult'
  dstOffset?: Maybe<Scalars['Int']['output']>
  rawOffset?: Maybe<Scalars['Int']['output']>
  status?: Maybe<Scalars['String']['output']>
  timeZoneId?: Maybe<Scalars['String']['output']>
  timeZoneName?: Maybe<Scalars['String']['output']>
}

export type GqlAnswerSet = {
  __typename?: 'GqlAnswerSet'
  answerSetSlug?: Maybe<Scalars['String']['output']>
  answers?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  product?: Maybe<Scalars['String']['output']>
  questionnaireSlug?: Maybe<Scalars['String']['output']>
}

export type GqlAnswerSetInput = {
  answerSetSlug: Scalars['String']['input']
  answers: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  product: Scalars['String']['input']
  questionnaireSlug: Scalars['String']['input']
}

export type HelocDetails = {
  __typename?: 'HelocDetails'
  interestOnlyPeriod?: Maybe<Scalars['Int']['output']>
}

export type HomeEquityDetailsInput = {
  helocPurpose?: InputMaybe<Scalars['String']['input']>
  intendToSellIn12Months?: InputMaybe<Scalars['Boolean']['input']>
  referringLoanOfficerId?: InputMaybe<Scalars['Int']['input']>
}

export type HomeEquityDetailsSchema = {
  __typename?: 'HomeEquityDetailsSchema'
  firstMortgageRate?: Maybe<Scalars['Float']['output']>
  helocPurpose?: Maybe<Scalars['String']['output']>
  intendToSellIn12Months?: Maybe<Scalars['Boolean']['output']>
  referringLoanOfficerId?: Maybe<Scalars['Int']['output']>
}

export type ImportServicerDataInput = {
  applicationId: Scalars['Int']['input']
  fieldsToImport: Array<Scalars['String']['input']>
  servicerLeadUuid: Scalars['String']['input']
}

export type ImportServicerDataResponse = {
  __typename?: 'ImportServicerDataResponse'
  importedFields: Array<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  servicerSource: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export type IncomeBreakdownItem = {
  __typename?: 'IncomeBreakdownItem'
  amount?: Maybe<Scalars['Float']['output']>
  incomeType?: Maybe<Scalars['String']['output']>
  revisionId?: Maybe<Scalars['Int']['output']>
  source?: Maybe<Scalars['String']['output']>
}

export type IncomeOption = {
  __typename?: 'IncomeOption'
  name: Scalars['String']['output']
}

export type IncomeRevisionSchema = {
  __typename?: 'IncomeRevisionSchema'
  aiVepaValidationResultId?: Maybe<Scalars['Int']['output']>
  bonus?: Maybe<Scalars['Float']['output']>
  commissions?: Maybe<Scalars['Float']['output']>
  companyOwnership?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  currentJob?: Maybe<Scalars['Boolean']['output']>
  employedByParty?: Maybe<Scalars['Boolean']['output']>
  employerAddress?: Maybe<Scalars['String']['output']>
  employerCity?: Maybe<Scalars['String']['output']>
  employerIndustry?: Maybe<Scalars['String']['output']>
  employerName?: Maybe<Scalars['String']['output']>
  employerPhone?: Maybe<Scalars['String']['output']>
  employerState?: Maybe<Scalars['String']['output']>
  employerZipcode?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['String']['output']>
  grossAnnualIncomeAmount?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['Int']['output']>
  incomeType?: Maybe<Scalars['String']['output']>
  jobTitle?: Maybe<Scalars['String']['output']>
  nonTaxable?: Maybe<Scalars['Boolean']['output']>
  otherAnnualIncomeAmount?: Maybe<Scalars['Float']['output']>
  otherIncomeSource?: Maybe<Scalars['String']['output']>
  overtime?: Maybe<Scalars['Float']['output']>
  selfEmploymentBusinessType?: Maybe<SelfEmploymentBusinessType>
  startDate?: Maybe<Scalars['String']['output']>
  vaFederalTaxAmount?: Maybe<Scalars['Float']['output']>
  yearsInThisProfession?: Maybe<Scalars['Int']['output']>
}

export type IncomeSource = {
  bonus?: InputMaybe<Scalars['Float']['input']>
  commissions?: InputMaybe<Scalars['Float']['input']>
  companyOwnership?: InputMaybe<Scalars['Boolean']['input']>
  currentJob?: InputMaybe<Scalars['Boolean']['input']>
  employedByParty?: InputMaybe<Scalars['Boolean']['input']>
  employerAddress?: InputMaybe<Scalars['String']['input']>
  employerCity?: InputMaybe<Scalars['String']['input']>
  employerIndustry?: InputMaybe<Scalars['String']['input']>
  employerName?: InputMaybe<Scalars['String']['input']>
  employerPhone?: InputMaybe<Scalars['String']['input']>
  employerState?: InputMaybe<Scalars['String']['input']>
  employerZipcode?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  grossAnnualIncomeAmount?: InputMaybe<Scalars['Float']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  incomeType?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  nonTaxable?: InputMaybe<Scalars['Boolean']['input']>
  otherAnnualIncomeAmount?: InputMaybe<Scalars['Float']['input']>
  otherIncomeSource?: InputMaybe<Scalars['String']['input']>
  overtime?: InputMaybe<Scalars['Float']['input']>
  selfEmploymentBusinessType?: InputMaybe<SelfEmploymentBusinessType>
  startDate?: InputMaybe<Scalars['String']['input']>
  vaFederalTaxAmount?: InputMaybe<Scalars['Float']['input']>
  yearsInThisProfession?: InputMaybe<Scalars['Int']['input']>
}

export type IncomeSourceOutput = {
  __typename?: 'IncomeSourceOutput'
  companyOwnership?: Maybe<Scalars['String']['output']>
  currentJob?: Maybe<Scalars['Boolean']['output']>
  employedByParty?: Maybe<Scalars['String']['output']>
  employerAddress?: Maybe<Scalars['String']['output']>
  employerCity?: Maybe<Scalars['String']['output']>
  employerIndustry?: Maybe<Scalars['String']['output']>
  employerName?: Maybe<Scalars['String']['output']>
  employerPhone?: Maybe<Scalars['String']['output']>
  employerState?: Maybe<Scalars['String']['output']>
  employerZipcode?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['String']['output']>
  grossAnnualIncomeAmount?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['Int']['output']>
  incomeType?: Maybe<Scalars['String']['output']>
  jobTitle?: Maybe<Scalars['String']['output']>
  otherAnnualIncomeAmount?: Maybe<Scalars['Float']['output']>
  otherIncomeSource?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['String']['output']>
  yearsInThisProfession?: Maybe<Scalars['Int']['output']>
}

export type InputFees = {
  amount?: InputMaybe<Scalars['Float']['input']>
  description?: InputMaybe<Scalars['String']['input']>
}

export type IntegrationDataResponse = {
  __typename?: 'IntegrationDataResponse'
  ausDocuments?: Maybe<Array<Maybe<DocumentRequestSchema>>>
  rate?: Maybe<LockedRateSchema>
  revision?: Maybe<ApplicationRevisionDetailsSchema>
  syncStatuses?: Maybe<SyncStatuses>
}

export type LpaGuidance = {
  __typename?: 'LPAGuidance'
  messages?: Maybe<Array<Maybe<LpaGuidanceMessage>>>
  riskClass?: Maybe<Scalars['String']['output']>
}

export type LpaGuidanceMessage = {
  __typename?: 'LPAGuidanceMessage'
  category?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  isLpaChoice?: Maybe<Scalars['Boolean']['output']>
  messageCode?: Maybe<Scalars['String']['output']>
}

export type LatestDonePricingScenario = {
  __typename?: 'LatestDonePricingScenario'
  lockedRate?: Maybe<Rate>
  pricingScenario?: Maybe<PricingScenario>
}

export type LeadData = {
  __typename?: 'LeadData'
  annualIncomeAmount?: Maybe<Scalars['Float']['output']>
  avmPropertyEstimatedValue?: Maybe<Scalars['Int']['output']>
  besmarteeLoanId?: Maybe<Scalars['String']['output']>
  creditData?: Maybe<CreditData>
  creditReportIdentifier?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  debtToIncome?: Maybe<Scalars['Float']['output']>
  escrow?: Maybe<Scalars['Boolean']['output']>
  experienceType?: Maybe<Scalars['String']['output']>
  isRollInEscrow?: Maybe<Scalars['Boolean']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanToValue?: Maybe<Scalars['Float']['output']>
  lockedRate?: Maybe<LeadRate>
  notes?: Maybe<Scalars['String']['output']>
  propertyDownPayment?: Maybe<Scalars['Float']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Float']['output']>
  propertyValue?: Maybe<Scalars['Float']['output']>
  refiReason?: Maybe<Scalars['String']['output']>
  rollInFees?: Maybe<Scalars['Boolean']['output']>
  selectedRate?: Maybe<LeadRate>
  timeInHome?: Maybe<Scalars['String']['output']>
  uuid?: Maybe<Scalars['String']['output']>
}

export type LeadInformation = {
  apt?: InputMaybe<Scalars['String']['input']>
  buyBeforeYouSellAmount?: InputMaybe<Scalars['Float']['input']>
  buyBeforeYouSellApproved?: InputMaybe<Scalars['Boolean']['input']>
  cashOut?: InputMaybe<Scalars['Float']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  closingDate?: InputMaybe<Scalars['String']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  declarationFHALoan?: InputMaybe<Scalars['Boolean']['input']>
  declarationMilitary?: InputMaybe<Scalars['Boolean']['input']>
  declarationVALoan?: InputMaybe<Scalars['Boolean']['input']>
  desiredRateType?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  estimatedValue?: InputMaybe<Scalars['Float']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  landingUrl?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  leadSource: Scalars['String']['input']
  leadType?: InputMaybe<LeadTypes>
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
  loanPurpose?: InputMaybe<LoanPurposes>
  phone: Scalars['String']['input']
  phonePin?: InputMaybe<Scalars['String']['input']>
  propertyDownPayment?: InputMaybe<Scalars['Float']['input']>
  propertyPurchasePrice?: InputMaybe<Scalars['Float']['input']>
  propertyType?: InputMaybe<PropertyTypes>
  propertyUse?: InputMaybe<PropertyUses>
  referrerUrl?: InputMaybe<Scalars['String']['input']>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  sourceLeadId: Scalars['String']['input']
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type LeadPipeline = {
  __typename?: 'LeadPipeline'
  applicationCreatedAt?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  closingDate?: Maybe<Scalars['String']['output']>
  connectedCallsCount?: Maybe<Scalars['Int']['output']>
  daysToClose?: Maybe<Scalars['Int']['output']>
  email?: Maybe<Scalars['String']['output']>
  experienceType?: Maybe<ExperienceType>
  fullName?: Maybe<Scalars['String']['output']>
  iceboxNotes?: Maybe<Scalars['String']['output']>
  isReturningBorrower?: Maybe<Scalars['Boolean']['output']>
  lastContactedAt?: Maybe<Scalars['String']['output']>
  lastContactedType?: Maybe<Scalars['String']['output']>
  lastRingcentralContactedAt?: Maybe<Scalars['String']['output']>
  lastRingcentralContactedType?: Maybe<Scalars['String']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  loanOfficerAssignedAt?: Maybe<Scalars['String']['output']>
  loanOfficerName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<LoanPurpose>
  outBoundCallsCount?: Maybe<Scalars['Int']['output']>
  outBoundSmsCount?: Maybe<Scalars['Int']['output']>
  phone?: Maybe<Scalars['String']['output']>
  relatedApplications?: Maybe<Array<Maybe<RelatedApplications>>>
  reminder?: Maybe<ApplicationReminderSchema>
  secondPhone?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  tridDaysLeft?: Maybe<Scalars['Int']['output']>
}

export type LeadPipelineGroup = {
  __typename?: 'LeadPipelineGroup'
  count?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type LeadPipelineGroups = {
  __typename?: 'LeadPipelineGroups'
  reminderType?: Maybe<Array<Maybe<LeadPipelineGroup>>>
}

export type LeadPipelineRequest = {
  allLeads?: InputMaybe<Scalars['Boolean']['input']>
  applicationId?: InputMaybe<Scalars['Int']['input']>
  createdFrom?: InputMaybe<Scalars['String']['input']>
  createdTo?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  fetchIcebox?: InputMaybe<Scalars['Boolean']['input']>
  filterOut?: InputMaybe<FilterOptions>
  fullName?: InputMaybe<Scalars['String']['input']>
  lenderLoanId?: InputMaybe<Scalars['String']['input']>
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
  loanPurpose?: InputMaybe<LoanPurpose>
  managerId?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Pagination>
  phone?: InputMaybe<Scalars['String']['input']>
  sortByField?: InputMaybe<Scalars['String']['input']>
  sortDirection?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type LeadPipelineResponse = {
  __typename?: 'LeadPipelineResponse'
  groups?: Maybe<LeadPipelineGroups>
  leadPipeline?: Maybe<Array<Maybe<LeadPipeline>>>
  pagination?: Maybe<PaginationResponse>
}

export type LeadRate = {
  __typename?: 'LeadRate'
  rate?: Maybe<Scalars['Float']['output']>
  term?: Maybe<Scalars['Int']['output']>
}

export type LeadResponse = {
  __typename?: 'LeadResponse'
  applicationGuid: Scalars['String']['output']
  applicationId: Scalars['Int']['output']
  success: Scalars['Boolean']['output']
}

export enum LeadTypes {
  Branded = 'Branded',
  Internet = 'Internet',
  Live = 'Live',
}

/**
 * Legacy duplication options that copy additional data not included in standard duplication.
 * WARNING: Using these options may copy data that violates compliance requirements.
 */
export type LegacyDuplicationOptions = {
  /** Copy all liabilities including those linked to credit reports */
  copyAllLiabilities?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy borrower contact history */
  copyContactHistory?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy all credit reports from the original application */
  copyCreditReports?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy demographics revisions for primary and co-borrower */
  copyDemographics?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy pricing scenarios (only effective if isSameAddress is true) */
  copyPricingScenarios?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy TRID metadata from the original application */
  copyTridMetadata?: InputMaybe<Scalars['Boolean']['input']>
  /** Required for pricing scenarios to be copied */
  isSameAddress?: InputMaybe<Scalars['Boolean']['input']>
  /** Create a stub application instead of duplicating (e.g., 'DI-C01', 'DI-C03', 'DI-C04') */
  stubFileData?: InputMaybe<Scalars['String']['input']>
}

export type LenderBaseFee = {
  __typename?: 'LenderBaseFee'
  amount?: Maybe<Scalars['Float']['output']>
  description?: Maybe<Scalars['String']['output']>
  feeSetId?: Maybe<Scalars['Int']['output']>
  feeType?: Maybe<Scalars['String']['output']>
  hudLine?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['Int']['output']>
  includeInApr?: Maybe<Scalars['Boolean']['output']>
  userId?: Maybe<Scalars['Int']['output']>
}

export enum Lenders {
  AmeriSave = 'AmeriSave',
  HomePoint = 'HomePoint',
  PennyMac = 'PennyMac',
  Quicken = 'Quicken',
  Sage = 'Sage',
  Uwm = 'UWM',
}

export type Liability = {
  __typename?: 'Liability'
  liabilityType?: Maybe<Scalars['String']['output']>
  monthlyExpense?: Maybe<Scalars['Float']['output']>
  unpaidBalance?: Maybe<Scalars['Float']['output']>
}

export type LiabilityAndCreditScoreOutput = {
  __typename?: 'LiabilityAndCreditScoreOutput'
  creditScore?: Maybe<Scalars['Int']['output']>
  liabilities?: Maybe<Array<Maybe<Liability>>>
}

export type LiabilityAnswers = {
  id?: InputMaybe<Scalars['Int']['input']>
  otherLiabilityAmount?: InputMaybe<Scalars['Float']['input']>
  otherLiabilityType?: InputMaybe<Scalars['String']['input']>
}

export type LiabilityOutput = {
  __typename?: 'LiabilityOutput'
  id?: Maybe<Scalars['Int']['output']>
  otherLiabilityAmount?: Maybe<Scalars['Float']['output']>
  otherLiabilityType?: Maybe<Scalars['String']['output']>
}

export type LiabilityRevisionSchema = {
  __typename?: 'LiabilityRevisionSchema'
  accountNumber?: Maybe<Scalars['String']['output']>
  apt?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditLine?: Maybe<Scalars['Float']['output']>
  creditLoanType?: Maybe<Scalars['String']['output']>
  creditReportId?: Maybe<Scalars['Int']['output']>
  creditor?: Maybe<Scalars['String']['output']>
  currentHousingExpense?: Maybe<Scalars['Boolean']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  includesEscrows?: Maybe<Scalars['Boolean']['output']>
  liabilityType?: Maybe<Scalars['String']['output']>
  monthlyExpense?: Maybe<Scalars['Float']['output']>
  mortgageType?: Maybe<Scalars['String']['output']>
  omit?: Maybe<Scalars['Boolean']['output']>
  otherDescription?: Maybe<Scalars['String']['output']>
  ownershipType?: Maybe<Scalars['String']['output']>
  partOfPurchase?: Maybe<Scalars['Boolean']['output']>
  remainingTermMonths?: Maybe<Scalars['Int']['output']>
  reo?: Maybe<RealEstateOwnedSchema>
  reoId?: Maybe<Scalars['Int']['output']>
  resubordinate?: Maybe<Scalars['Boolean']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  toBePaidOff?: Maybe<Scalars['Boolean']['output']>
  totalTermMonths?: Maybe<Scalars['Int']['output']>
  unpaidBalance?: Maybe<Scalars['Float']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type LiabilitySchema = {
  __typename?: 'LiabilitySchema'
  liabilitiesList?: Maybe<Array<Maybe<LiabilityRevisionSchema>>>
  totalMortgage?: Maybe<Scalars['Int']['output']>
  totalNonMortgage?: Maybe<Scalars['Int']['output']>
  totalStudentLoan?: Maybe<Scalars['Int']['output']>
}

export enum LiabilityType {
  Alimony = 'Alimony',
  ChildSupport = 'ChildSupport',
  Childcare = 'Childcare',
  CollectionsJudgmentsAndLiens = 'CollectionsJudgmentsAndLiens',
  Heloc = 'HELOC',
  Installment = 'Installment',
  JobRelatedExpenses = 'JobRelatedExpenses',
  LeasePayment = 'LeasePayment',
  MortgageLoan = 'MortgageLoan',
  Open30DayChargeAccount = 'Open30DayChargeAccount',
  Revolving = 'Revolving',
  SeparateMaintenanceExpense = 'SeparateMaintenanceExpense',
  TaxLien = 'TaxLien',
  Taxes = 'Taxes',
}

export type LoanEstimateSectionsInput = {
  A: SectionInput
  B: SectionInput
  C: SectionInput
  D: SectionInput
  E: SectionInput
  F: SectionInput
  G: SectionInput
  H: SectionFeesOptionalInput
  I: SectionInput
  J: SectionInput
  Others: SectionInput
}

export type LoanMatchOfferSchema = {
  __typename?: 'LoanMatchOfferSchema'
  createdAt?: Maybe<Scalars['String']['output']>
  dataSource?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  loanPurpose: Scalars['String']['output']
  matchAnnualSavingsAmount?: Maybe<Scalars['Float']['output']>
  matchCostSavingsAmount?: Maybe<Scalars['Float']['output']>
  matchCostSavingsYears?: Maybe<Scalars['Int']['output']>
  matchEndingLtv?: Maybe<Scalars['Float']['output']>
  matchLifeOfLoanSavingsAmount?: Maybe<Scalars['Float']['output']>
  matchMonthlySavingsAmount?: Maybe<Scalars['Float']['output']>
  matchMonthlySavingsPercent?: Maybe<Scalars['Float']['output']>
  matchRateSavingsPercent?: Maybe<Scalars['Float']['output']>
  matchStartingLtv?: Maybe<Scalars['Float']['output']>
  matchTerm?: Maybe<Scalars['String']['output']>
  roundAnnualSavingsAmount?: Maybe<Scalars['Float']['output']>
  roundCostSavingsAmount?: Maybe<Scalars['Float']['output']>
  roundCostSavingsYears?: Maybe<Scalars['Int']['output']>
  roundEndingLtv?: Maybe<Scalars['Float']['output']>
  roundLifeOfLoanSavingsAmount?: Maybe<Scalars['Float']['output']>
  roundMonthlySavingsAmount?: Maybe<Scalars['Float']['output']>
  roundMonthlySavingsPercent?: Maybe<Scalars['Float']['output']>
  roundRateSavingsPercent?: Maybe<Scalars['Float']['output']>
  roundStartingLtv?: Maybe<Scalars['Float']['output']>
  roundTerm?: Maybe<Scalars['String']['output']>
  termMatchOffer?: Maybe<Rate>
  termRoundOffer?: Maybe<Rate>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type LoanMatchPlaygroundResponseRefi = {
  __typename?: 'LoanMatchPlaygroundResponseRefi'
  autoRolledInFeeRates?: Maybe<Array<Maybe<Rate>>>
  currentLoanDetails?: Maybe<CurrentLoanDetails>
  initialRates?: Maybe<Array<Maybe<Rate>>>
  matchedTerm?: Maybe<ProductTerm>
  maxPoints?: Maybe<Scalars['Int']['output']>
  rate?: Maybe<Rate>
  ratesUnderPointThreshold?: Maybe<Array<Maybe<Rate>>>
  savings?: Maybe<LoanMatchSavings>
  termRoundRate?: Maybe<Rate>
  termRoundSavings?: Maybe<LoanMatchSavings>
  termRoundTerm?: Maybe<ProductTerm>
}

export type LoanMatchRequest = {
  creditScore: Scalars['Int']['input']
  currentMonthlyPayment: Scalars['Float']['input']
  currentRate: Scalars['Float']['input']
  fromPlayground?: InputMaybe<Scalars['Boolean']['input']>
  loanAmount: Scalars['Float']['input']
  loanPurpose: LoanPurpose
  loanToValue: Scalars['Float']['input']
  propertyType: PropertyType
  propertyUse: PropertyUse
  propertyValue?: InputMaybe<Scalars['Float']['input']>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  remainingMonths: Scalars['Int']['input']
  state?: InputMaybe<StateAbbreviation>
  veteran?: InputMaybe<Veteran>
  zipCode: Scalars['String']['input']
}

export type LoanMatchResponse = {
  __typename?: 'LoanMatchResponse'
  currentLoanDetails?: Maybe<CurrentLoanDetails>
  matchedTerm?: Maybe<ProductTerm>
  rate?: Maybe<Rate>
  savings?: Maybe<LoanMatchSavings>
  termRoundRate?: Maybe<Rate>
  termRoundSavings?: Maybe<LoanMatchSavings>
  termRoundTerm?: Maybe<ProductTerm>
}

export type LoanMatchSavings = {
  __typename?: 'LoanMatchSavings'
  annualSavingsAmount?: Maybe<Scalars['Float']['output']>
  costSavingsOverTimeAmount?: Maybe<Scalars['Float']['output']>
  costSavingsYears?: Maybe<Scalars['Int']['output']>
  endingLtv?: Maybe<Scalars['Float']['output']>
  lifeOfLoanSavingsAmount?: Maybe<Scalars['Float']['output']>
  monthlyPaymentSavingsAmount?: Maybe<Scalars['Float']['output']>
  monthlyPaymentSavingsPercent?: Maybe<Scalars['Float']['output']>
  rateSavingsPercent?: Maybe<Scalars['Float']['output']>
  startingLtv?: Maybe<Scalars['Float']['output']>
}

export type LoanOfficerAdminInfo = {
  __typename?: 'LoanOfficerAdminInfo'
  active?: Maybe<Scalars['Boolean']['output']>
  configurationFields?: Maybe<ConfigurationFields>
  elloUserId?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  headshot?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  is_manager?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  nmls?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  retoolId?: Maybe<Scalars['Int']['output']>
  states?: Maybe<Array<Maybe<LoanOfficerStateInfo>>>
}

export type LoanOfficerCapStatus = {
  __typename?: 'LoanOfficerCapStatus'
  capHit: Scalars['Boolean']['output']
  currentLeadCount: Scalars['Int']['output']
  dailyCapLimit?: Maybe<Scalars['Int']['output']>
  percentageFull: Scalars['Float']['output']
}

export enum LoanOfficerConfigurationField {
  IsAnnalyLoanCareEligible = 'isAnnalyLoanCareEligible',
  IsBestMoneyEligible = 'isBestMoneyEligible',
  IsEmployeeLoansEligible = 'isEmployeeLoansEligible',
  IsHomeEquityEligible = 'isHomeEquityEligible',
  IsPhoenixEligible = 'isPhoenixEligible',
  IsRobinhoodConciergeEligible = 'isRobinhoodConciergeEligible',
  IsRobinhoodEligible = 'isRobinhoodEligible',
}

export type LoanOfficerDisplayInfo = {
  __typename?: 'LoanOfficerDisplayInfo'
  email?: Maybe<Scalars['String']['output']>
  headshot?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  nmls?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type LoanOfficerDisplayInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>
  headshot?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nmls?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type LoanOfficerInput = {
  email?: InputMaybe<Scalars['String']['input']>
  headshot?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nmls?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type LoanOfficerSmsAuthor = {
  __typename?: 'LoanOfficerSMSAuthor'
  isLO?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type LoanOfficerSmsLog = {
  __typename?: 'LoanOfficerSMSLog'
  messages?: Maybe<Array<Maybe<LoanOfficerSmsMessage>>>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type LoanOfficerSmsLogResponse = {
  __typename?: 'LoanOfficerSMSLogResponse'
  borrower?: Maybe<LoanOfficerSmsLog>
  coBorrower?: Maybe<LoanOfficerSmsLog>
}

export type LoanOfficerSmsMessage = {
  __typename?: 'LoanOfficerSMSMessage'
  author?: Maybe<LoanOfficerSmsAuthor>
  createdAt?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type LoanOfficerStateInfo = {
  __typename?: 'LoanOfficerStateInfo'
  activeInState?: Maybe<Scalars['Boolean']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type LoanProgram = {
  __typename?: 'LoanProgram'
  adjustRateTerm?: Maybe<Scalars['Int']['output']>
  class?: Maybe<ProductClass>
  code?: Maybe<Scalars['String']['output']>
  family?: Maybe<Scalars['String']['output']>
  fixRateTerm?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['Int']['output']>
  initialCap?: Maybe<Scalars['Float']['output']>
  interestOnlyMonths?: Maybe<Scalars['Int']['output']>
  isMortgageInsurancePaidByLender?: Maybe<Scalars['Boolean']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  lifetimeCap?: Maybe<Scalars['Float']['output']>
  lockOverrides?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  margin?: Maybe<Scalars['Float']['output']>
  name?: Maybe<Scalars['String']['output']>
  periodicCap?: Maybe<Scalars['Float']['output']>
  prePaymentPenalty?: Maybe<Scalars['Boolean']['output']>
  rateSheetId?: Maybe<Scalars['Int']['output']>
  shouldIncludeHighBalance?: Maybe<Scalars['Boolean']['output']>
  term?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export enum LoanPurpose {
  HomeEquity = 'HomeEquity',
  Purchase = 'Purchase',
  Refinance = 'Refinance',
}

export enum LoanPurposes {
  HomeEquity = 'HomeEquity',
  Purchase = 'Purchase',
  Refinance = 'Refinance',
}

export type LoanSetupChecklist = {
  __typename?: 'LoanSetupChecklist'
  createdAt?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  items?: Maybe<Array<Maybe<LoanSetupChecklistItem>>>
}

export type LoanSetupChecklistItem = {
  __typename?: 'LoanSetupChecklistItem'
  checkedAt?: Maybe<Scalars['String']['output']>
  checkedBy?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type LoanSetupPipelineRequest = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  lenderLoanId?: InputMaybe<Scalars['String']['input']>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SortInput>
}

export type LoanSetupPipelineResponse = {
  __typename?: 'LoanSetupPipelineResponse'
  pagination?: Maybe<PaginationResponse>
  pipeline?: Maybe<Array<Maybe<LoanSetupRecord>>>
}

export type LoanSetupRecord = {
  __typename?: 'LoanSetupRecord'
  applicationId?: Maybe<Scalars['Int']['output']>
  borrowerName?: Maybe<Scalars['String']['output']>
  checklist?: Maybe<LoanSetupChecklist>
  closingDate?: Maybe<Scalars['String']['output']>
  dateLocked?: Maybe<Scalars['String']['output']>
  daysToClose?: Maybe<Scalars['Int']['output']>
  latestAttachmentUploadedAt?: Maybe<Scalars['String']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  loanOfficerName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  loanSetupAdmin?: Maybe<Scalars['String']['output']>
  loanSetupAnalyst?: Maybe<Scalars['String']['output']>
  lockFormId?: Maybe<Scalars['Int']['output']>
  processorId?: Maybe<Scalars['Int']['output']>
  processorName?: Maybe<Scalars['String']['output']>
  trippedTRIDDate?: Maybe<Scalars['String']['output']>
}

export enum LoanType {
  HomeEquity = 'HomeEquity',
  Purchase = 'Purchase',
  Refinance = 'Refinance',
}

export enum LoanTypeAssigned {
  Both = 'Both',
  Purchase = 'Purchase',
  Refinance = 'Refinance',
}

export type LockData = {
  __typename?: 'LockData'
  administrator?: Maybe<Scalars['String']['output']>
  application?: Maybe<ApplicationSchema>
  applicationDemographics?: Maybe<ApplicationDemographics>
  applicationRevision?: Maybe<ApplicationRevisionSchema>
  coBorrowerDemographics?: Maybe<ApplicationDemographics>
  coBorrowerManualLiabilities?: Maybe<
    Array<Maybe<ApplicationLiabilitiesSchema>>
  >
  creditData?: Maybe<CreditData>
  dateLocked?: Maybe<Scalars['String']['output']>
  isFloated?: Maybe<Scalars['Boolean']['output']>
  loanOfficer?: Maybe<LoanOfficerDisplayInfo>
  lockDate?: Maybe<Scalars['String']['output']>
  lockDeskNotes?: Maybe<Scalars['String']['output']>
  lockFormId?: Maybe<Scalars['Int']['output']>
  lockProgress?: Maybe<Scalars['String']['output']>
  manualLiabilities?: Maybe<Array<Maybe<ApplicationLiabilitiesSchema>>>
  notes?: Maybe<Scalars['String']['output']>
  pricingScenario?: Maybe<PricingScenario>
  processingQuestions?: Maybe<Scalars['String']['output']>
  processingTeam?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Rate>
  realEstateOwned?: Maybe<Array<Maybe<RealEstateOwnedSchema>>>
  requestType?: Maybe<LockRequestType>
  tridDaysLeft?: Maybe<Scalars['Int']['output']>
}

export type LockDeskPipeline = {
  __typename?: 'LockDeskPipeline'
  administrator?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  beSmarteeLoanId?: Maybe<Scalars['String']['output']>
  dateLocked?: Maybe<Scalars['String']['output']>
  disclosureSetupAdmin?: Maybe<Scalars['String']['output']>
  experienceType?: Maybe<ExperienceType>
  firstName?: Maybe<Scalars['String']['output']>
  firstTouched?: Maybe<Scalars['String']['output']>
  isErrored?: Maybe<Scalars['Boolean']['output']>
  isFloated?: Maybe<Scalars['Boolean']['output']>
  isManual?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  loanOfficerName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  loanSetupAdmin?: Maybe<Scalars['String']['output']>
  lockDate?: Maybe<Scalars['String']['output']>
  lockDeskNotes?: Maybe<Scalars['String']['output']>
  lockFormId?: Maybe<Scalars['Int']['output']>
  lockProgress?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  paidCompensation?: Maybe<Scalars['Float']['output']>
  processingTeam?: Maybe<Scalars['String']['output']>
  processorId?: Maybe<Scalars['Int']['output']>
  processorName?: Maybe<Scalars['String']['output']>
  propertyPurchasePrice?: Maybe<Scalars['Float']['output']>
  requestType?: Maybe<LockRequestType>
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type LockDeskPipelineRequest = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  besmarteeLoanId?: InputMaybe<Scalars['String']['input']>
  borrowerName?: InputMaybe<Scalars['String']['input']>
  createdDateRange?: InputMaybe<DateRange>
  isFloated?: InputMaybe<Scalars['Boolean']['input']>
  lenderName?: InputMaybe<Scalars['String']['input']>
  lockProgress?: InputMaybe<Scalars['String']['input']>
  lockedDateRange?: InputMaybe<DateRange>
  lockedTo?: InputMaybe<Scalars['String']['input']>
  pagination?: InputMaybe<Pagination>
  processingQueuePipeline?: InputMaybe<Scalars['Boolean']['input']>
  processorId?: InputMaybe<Scalars['Int']['input']>
  requestType?: InputMaybe<Array<InputMaybe<LockRequestType>>>
}

export type LockDeskPipelineResponse = {
  __typename?: 'LockDeskPipelineResponse'
  lockDeskPipeline?: Maybe<Array<Maybe<LockDeskPipeline>>>
  pagination?: Maybe<PaginationResponse>
}

export enum LockRequestType {
  Cic = 'CIC',
  DoesNotQualify = 'DoesNotQualify',
  Float = 'Float',
  Lock = 'Lock',
  Wip = 'WIP',
}

export type LockedOrFloatedLoansNotESigned = {
  __typename?: 'LockedOrFloatedLoansNotESigned'
  applicationId: Scalars['Int']['output']
  borrowerName?: Maybe<Scalars['String']['output']>
  daysSinceTrippedTrid?: Maybe<Scalars['Int']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  loanOfficerAssigned?: Maybe<Scalars['String']['output']>
  lockedOnDate?: Maybe<Scalars['String']['output']>
  trippedTridDate?: Maybe<Scalars['String']['output']>
}

export type LockedOrFloatedLoansNotESignedRequest = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  filterOutInvalidStatuses?: InputMaybe<Scalars['Boolean']['input']>
  filterOutProcessorAssigned?: InputMaybe<Scalars['Boolean']['input']>
  lenderLoanId?: InputMaybe<Scalars['String']['input']>
  moreThan10DaysSinceTrippedTrid: Scalars['Boolean']['input']
  pagination?: InputMaybe<PaginationInput>
}

export type LockedOrFloatedLoansNotESignedResponse = {
  __typename?: 'LockedOrFloatedLoansNotESignedResponse'
  lockedOrFloatedLoansNotESigned?: Maybe<
    Array<Maybe<LockedOrFloatedLoansNotESigned>>
  >
  pagination?: Maybe<PaginationResponse>
}

export type LockedRateSchema = {
  __typename?: 'LockedRateSchema'
  additionalCreditAmount?: Maybe<Scalars['Float']['output']>
  additionalCreditSource?: Maybe<Scalars['String']['output']>
  adjustments?: Maybe<Array<Maybe<Adjustment>>>
  adjustmentsTotal?: Maybe<Scalars['Float']['output']>
  apr?: Maybe<Scalars['Float']['output']>
  basePrice?: Maybe<Scalars['Float']['output']>
  borrowerName?: Maybe<Scalars['String']['output']>
  cashAtClose?: Maybe<Scalars['Float']['output']>
  cashOut?: Maybe<Scalars['Int']['output']>
  closingFeeProvider?: Maybe<Scalars['String']['output']>
  combinedLoanToValue?: Maybe<Scalars['Float']['output']>
  costOfLoan?: Maybe<Scalars['Float']['output']>
  costOfLoanYears?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  discountOrCreditAmount?: Maybe<Scalars['Float']['output']>
  discountPoints?: Maybe<Scalars['Float']['output']>
  discountPointsAsDollarAmount?: Maybe<Scalars['Float']['output']>
  escrowFees?: Maybe<Scalars['Float']['output']>
  family?: Maybe<Scalars['String']['output']>
  fees?: Maybe<Array<Maybe<Fees>>>
  fewerUpfrontCosts?: Maybe<Scalars['Float']['output']>
  finalPrice?: Maybe<Scalars['Float']['output']>
  fundingFee?: Maybe<Scalars['Float']['output']>
  isRollInEscrow?: Maybe<Scalars['Boolean']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanEstimateSections?: Maybe<LoanEstimateSections>
  loanProgramName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  loanTerm?: Maybe<Scalars['Int']['output']>
  loanToValue?: Maybe<Scalars['Float']['output']>
  lockPeriod?: Maybe<Scalars['Int']['output']>
  monthlyEscrowFees?: Maybe<Scalars['Float']['output']>
  monthlyInsurance?: Maybe<Scalars['Float']['output']>
  monthlyPayment?: Maybe<Scalars['Float']['output']>
  monthlyPrivateMortgageInsurance?: Maybe<Scalars['Float']['output']>
  monthlyPropertyTax?: Maybe<Scalars['Float']['output']>
  mortgageInsurancePremium?: Maybe<MortgageInsurancePremium>
  originationPoints?: Maybe<Scalars['Float']['output']>
  points?: Maybe<Scalars['Int']['output']>
  principleAndInterestPayment?: Maybe<Scalars['Float']['output']>
  privateMortgageInsuranceQuote?: Maybe<PmiQuote>
  productClass?: Maybe<ProductClass>
  productCode?: Maybe<Scalars['String']['output']>
  propertyValue?: Maybe<Scalars['Float']['output']>
  quoteType?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Scalars['Float']['output']>
  rateSheetPrice?: Maybe<Scalars['Float']['output']>
  rollInFees?: Maybe<Scalars['Int']['output']>
  silkFees?: Maybe<Array<Maybe<Fees>>>
  subordinateLienAmount?: Maybe<Scalars['Int']['output']>
  term?: Maybe<Scalars['String']['output']>
  totalLenderFees?: Maybe<Scalars['Float']['output']>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export enum MeetingType {
  FollowUp = 'FollowUp',
}

export type MessageAuthorSchema = {
  __typename?: 'MessageAuthorSchema'
  loanOfficer?: Maybe<AuthorSchema>
  processor?: Maybe<AuthorSchema>
  user?: Maybe<AuthorSchema>
}

export type MessageInput = {
  elloUserId?: InputMaybe<Scalars['String']['input']>
  retoolId?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  threadUuid?: InputMaybe<Scalars['String']['input']>
}

export type MessageSchema = {
  __typename?: 'MessageSchema'
  author?: Maybe<MessageAuthorSchema>
  createdAt?: Maybe<Scalars['String']['output']>
  messageUuid?: Maybe<Scalars['String']['output']>
  readAt?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type MessageThreadSchema = {
  __typename?: 'MessageThreadSchema'
  createdAt?: Maybe<Scalars['String']['output']>
  isCoborrower?: Maybe<Scalars['Boolean']['output']>
  messages?: Maybe<Array<Maybe<MessageSchema>>>
  threadUuid?: Maybe<Scalars['String']['output']>
}

export type MortgageEstimate = {
  __typename?: 'MortgageEstimate'
  currentBalance?: Maybe<Scalars['Float']['output']>
  estimatedInterestRate?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  openedDate?: Maybe<Scalars['String']['output']>
  paymentDueAmount?: Maybe<Scalars['Float']['output']>
  paymentScheduleMonthCount?: Maybe<Scalars['Int']['output']>
}

export type MortgageInsurancePremium = {
  __typename?: 'MortgageInsurancePremium'
  adjustments?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  annualDollarPremium?: Maybe<Scalars['Float']['output']>
  annualPercentageRate?: Maybe<Scalars['Float']['output']>
  company?: Maybe<Scalars['String']['output']>
  monthlyDollarPremium?: Maybe<Scalars['Float']['output']>
  monthlyPercentageRate?: Maybe<Scalars['Float']['output']>
  upfrontDollarPremium?: Maybe<Scalars['Float']['output']>
  upfrontPercentageRate?: Maybe<Scalars['Float']['output']>
}

export type MortgageInsurancePremiumInput = {
  adjustments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  annualDollarPremium?: InputMaybe<Scalars['Float']['input']>
  annualPercentageRate?: InputMaybe<Scalars['Float']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  monthlyDollarPremium?: InputMaybe<Scalars['Float']['input']>
  monthlyPercentageRate?: InputMaybe<Scalars['Float']['input']>
  upfrontDollarPremium?: InputMaybe<Scalars['Float']['input']>
  upfrontPercentageRate?: InputMaybe<Scalars['Float']['input']>
}

export type MqApiRate = {
  __typename?: 'MqApiRate'
  adjustments?: Maybe<Array<Maybe<Adjustment>>>
  adjustmentsTotal?: Maybe<Scalars['Float']['output']>
  apr?: Maybe<Scalars['Float']['output']>
  aprNoInsurance?: Maybe<Scalars['Float']['output']>
  armDetails?: Maybe<ArmDetails>
  basePrice?: Maybe<Scalars['Float']['output']>
  bestExecutionLoanProgram?: Maybe<Scalars['String']['output']>
  combinedLoanToValue?: Maybe<Scalars['Float']['output']>
  discountOrCreditAmount?: Maybe<Scalars['Float']['output']>
  discountPoints?: Maybe<Scalars['Float']['output']>
  discountPointsAsDollarAmount?: Maybe<Scalars['Float']['output']>
  finalPrice?: Maybe<Scalars['Float']['output']>
  governmentFees?: Maybe<Scalars['Float']['output']>
  hasAdd?: Maybe<Scalars['Boolean']['output']>
  helocDetails?: Maybe<HelocDetails>
  id?: Maybe<Scalars['String']['output']>
  interestOnlyMonths?: Maybe<Scalars['Float']['output']>
  lenderBaseFees?: Maybe<Array<Maybe<LenderBaseFee>>>
  lenderCredit?: Maybe<Scalars['Float']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanProgram?: Maybe<LoanProgram>
  loanPurpose?: Maybe<Scalars['String']['output']>
  loanTerm?: Maybe<Scalars['Int']['output']>
  lockId?: Maybe<Scalars['String']['output']>
  lockPeriod?: Maybe<Scalars['Int']['output']>
  matchedDisallowPricingRuleDescription?: Maybe<Scalars['String']['output']>
  mortgageInsurancePremium?: Maybe<MortgageInsurancePremium>
  note?: Maybe<Scalars['String']['output']>
  originalApr?: Maybe<Scalars['Float']['output']>
  originationPoints?: Maybe<Scalars['Float']['output']>
  prePaymentPenalty?: Maybe<Scalars['Boolean']['output']>
  principleAndInterestPayment?: Maybe<Scalars['Float']['output']>
  quoteType?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Scalars['Float']['output']>
  rateSheetPrice?: Maybe<Scalars['Float']['output']>
  silkFees?: Maybe<Array<Maybe<Fees>>>
  specialNotes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  stopEncountered?: Maybe<Scalars['Boolean']['output']>
  totalBaseFees?: Maybe<Scalars['Float']['output']>
  totalLenderFees?: Maybe<Scalars['Float']['output']>
  userId?: Maybe<Scalars['Int']['output']>
}

/** Define Mutations */
export type Mutation = {
  __typename?: 'Mutation'
  /** Bankrate Lead Submission */
  BankrateLeadSubmission?: Maybe<RedirectUrl>
  addCoBorrower?: Maybe<Scalars['Boolean']['output']>
  addCondition?: Maybe<Scalars['Boolean']['output']>
  addTaskToApplication?: Maybe<Scalars['Boolean']['output']>
  /** Assign loan officer to an application */
  assignApplicationLoanOfficer?: Maybe<Scalars['Boolean']['output']>
  assignColorToProcessorAssignment?: Maybe<Scalars['Boolean']['output']>
  assignProcessor?: Maybe<ProcessorAssignment>
  /** Attach lender loan Id to an application */
  attachLenderLoanId?: Maybe<Scalars['Boolean']['output']>
  clearCreditReport?: Maybe<Scalars['Boolean']['output']>
  /** Convert NTL application to Baseline */
  convertNtlToBaseline?: Maybe<Scalars['Boolean']['output']>
  copyCreditReport?: Maybe<Scalars['Boolean']['output']>
  correctLenderLoanId?: Maybe<Scalars['Boolean']['output']>
  correctPhoneNumber?: Maybe<Scalars['Boolean']['output']>
  /** Create Auth0 Account */
  createAuth0Account: Auth0AccountCreationResponse
  createLoanOfficer?: Maybe<AdminLoanOfficer>
  createTask?: Maybe<Scalars['Boolean']['output']>
  deleteAddress?: Maybe<Scalars['Boolean']['output']>
  deleteAsset?: Maybe<Scalars['Boolean']['output']>
  deleteCondition?: Maybe<Scalars['Boolean']['output']>
  deleteDocumentRequest?: Maybe<Scalars['Boolean']['output']>
  deleteIncome?: Maybe<Scalars['Boolean']['output']>
  /** Soft delete loan officer and set active flag to false */
  deleteLoanOfficer?: Maybe<Scalars['Boolean']['output']>
  /** Soft delete processor and set active flag to false */
  deleteProcessor?: Maybe<Scalars['Boolean']['output']>
  deleteRealEstateOwned?: Maybe<Scalars['Boolean']['output']>
  deleteRingCentralAccount?: Maybe<Scalars['Boolean']['output']>
  deleteTask?: Maybe<Scalars['Boolean']['output']>
  editCondition?: Maybe<Scalars['Boolean']['output']>
  editDocumentRequest?: Maybe<Scalars['Boolean']['output']>
  /** Edit loan officer's phone number */
  editLoanOfficerPhone?: Maybe<Scalars['Boolean']['output']>
  /** Fill application */
  fill?: Maybe<Scalars['Boolean']['output']>
  /** Fill application address */
  fillAddress?: Maybe<Array<Maybe<RecordId>>>
  /** Fill co-borrower */
  fillCoBorrower?: Maybe<FillCoBorrowerResponse>
  /** Fill Co-Borrower addresses */
  fillCoBorrowerAddresses: Array<RecordId>
  /** Fill Co-Borrower demographics */
  fillCoBorrowerDemographics?: Maybe<RecordId>
  /** Fill Co-Borrower income */
  fillCoBorrowerIncome: Array<RecordId>
  /** Fill Co-Borrower liabilities */
  fillCoBorrowerLiabilities?: Maybe<Array<Maybe<RecordId>>>
  /** Fill demographics */
  fillDemographics?: Maybe<RecordId>
  /** Fill application income */
  fillIncome?: Maybe<Array<Maybe<RecordId>>>
  /** Fill liabilities */
  fillLiabilities?: Maybe<Array<Maybe<RecordId>>>
  /** Fill real estate owned */
  fillReo?: Maybe<FillReoResponse>
  /** Fill ApplicationSession */
  fillSession: Scalars['Boolean']['output']
  /** Get and save Corelogic AVM Property Info */
  getAndSaveAVMData?: Maybe<AvmPropertyDataResult>
  /** Import servicer data into application */
  importServicerData: ImportServicerDataResponse
  /** Initialize application */
  initialize?: Maybe<InitializeResponse>
  /**
   * Temporary resolver to be called to initalize a checklist on any
   * loans that were backfilled/not assigned through Retool
   */
  initializeChecklist?: Maybe<Scalars['Boolean']['output']>
  /** Lock WIP Lock Form */
  lockWipLockForm?: Maybe<Scalars['Boolean']['output']>
  /** Manually esign an application's current lock form */
  manualEsign?: Maybe<Scalars['Boolean']['output']>
  newRelicIncrement?: Maybe<Scalars['Boolean']['output']>
  /** Frontend New Relic Events */
  newRelicTiming?: Maybe<Scalars['Boolean']['output']>
  /** Issue the next sequence number for the demo borrower's prefilled email */
  nextDemoBorrowerEmailSequence?: Maybe<Scalars['Int']['output']>
  /**
   * Push an application's lead info to NewZip. Returns missingFields when the
   * application is missing data required by NewZip; the client should surface
   * these to the user.
   */
  pushLeadToNewZip: NewZipSubmissionResult
  /** Release the mq_lock_id from an application */
  releaseLockId?: Maybe<Scalars['Boolean']['output']>
  removeCoBorrower?: Maybe<Scalars['Boolean']['output']>
  removeTaskFromApplication?: Maybe<Scalars['Boolean']['output']>
  /** Replicate an application */
  replicateApplicationV2?: Maybe<Scalars['Int']['output']>
  /** Saves AVM Property Info */
  saveAVMPropertyInfo?: Maybe<Scalars['Boolean']['output']>
  /** Save answer set */
  saveAnswerSet?: Maybe<Scalars['Boolean']['output']>
  saveApplicationAddressRevision?: Maybe<Scalars['Boolean']['output']>
  /** Save application contact (create or update) */
  saveApplicationContact: ApplicationContact
  /** Save Application Disclosures Consent Revisions */
  saveApplicationDisclosure?: Maybe<Scalars['Boolean']['output']>
  /** Save Application Disclosures Consent Revisions */
  saveApplicationDisclosures?: Maybe<Scalars['Boolean']['output']>
  /** Save application loan officer action revision */
  saveApplicationLoanOfficerActionRevision?: Maybe<Scalars['Boolean']['output']>
  /** Saves an application note with the authenticated user as author */
  saveApplicationNote?: Maybe<Scalars['Boolean']['output']>
  /** Saves an application reminder */
  saveApplicationReminder?: Maybe<Scalars['Boolean']['output']>
  saveApplicationRevision?: Maybe<SaveApplicationRevisionResponse>
  saveAssetRevision?: Maybe<Scalars['Boolean']['output']>
  saveCoBorrowerApplicationAddressRevision?: Maybe<Scalars['Boolean']['output']>
  saveCoBorrowerApplicationDisclosure?: Maybe<Scalars['Boolean']['output']>
  /** Save CoBorrower Application Disclosures Consent Revisions */
  saveCoBorrowerApplicationDisclosures?: Maybe<Scalars['Boolean']['output']>
  saveCoBorrowerApplicationRevision?: Maybe<SaveApplicationRevisionResponse>
  saveCoBorrowerDemographics?: Maybe<Scalars['Boolean']['output']>
  /** Save co borrower SSN alias to co borrower revision */
  saveCoBorrowerSSNAlias: Scalars['Boolean']['output']
  saveContactTemplate?: Maybe<Scalars['Boolean']['output']>
  saveDemographics?: Maybe<Scalars['Boolean']['output']>
  saveDocumentRequestNote?: Maybe<DocumentRequestNote>
  saveDocumentRequestStatus?: Maybe<Scalars['Boolean']['output']>
  saveHomeEquityDetails?: Maybe<Scalars['Boolean']['output']>
  saveIncomeRevision?: Maybe<Scalars['Boolean']['output']>
  saveLiabilityRevision?: Maybe<Scalars['Boolean']['output']>
  saveLockForm?: Maybe<Scalars['Boolean']['output']>
  /** Save a non-borrowing spouse */
  saveNonBorrowingSpouse?: Maybe<Scalars['Boolean']['output']>
  /** Save NTL disqualified reason */
  saveNtlDisqualifiedReason?: Maybe<Scalars['Boolean']['output']>
  savePrelockedRate?: Maybe<Scalars['Boolean']['output']>
  savePricingScenario?: Maybe<Scalars['Boolean']['output']>
  /** Add or update a processor's info */
  saveProcessorInfo?: Maybe<Scalars['Boolean']['output']>
  saveRealEstateOwned?: Maybe<Scalars['Boolean']['output']>
  saveRingCentralAccount?: Maybe<Scalars['Boolean']['output']>
  /** Save SSN alias to application revision */
  saveSSNAlias: Scalars['Boolean']['output']
  /** Save Sage Contact */
  saveSageContact?: Maybe<Scalars['String']['output']>
  /** Save Sage Contact Assignment */
  saveSageContactAssignment?: Maybe<Scalars['Boolean']['output']>
  selectAUSReport?: Maybe<Scalars['Boolean']['output']>
  /** Trigger Lock Desk failure Slack alert */
  sendLockDeskFailureSlackAlert?: Maybe<Scalars['Boolean']['output']>
  sendRingCentralSMSByTemplate?: Maybe<SendSmsResponse>
  /** Set experience type */
  setExperienceType?: Maybe<Scalars['Int']['output']>
  setLoanOfficerConfiguration?: Maybe<Scalars['Boolean']['output']>
  /** Soft delete application disclosure consent revision by type */
  softDeleteApplicationDisclosure?: Maybe<Scalars['Boolean']['output']>
  softDeleteCoBorrowerApplicationDisclosure?: Maybe<
    Scalars['Boolean']['output']
  >
  /** Soft pull Credit Score */
  softPullCreditScore?: Maybe<SoftPullResponse>
  storeAddressValidationEvent?: Maybe<Scalars['Boolean']['output']>
  /** Submit a manual lead (proxy to main API) */
  submitAdminLead: LeadResponse
  /** Bankrate Compare Lead Submission (initialize + fill application) */
  submitBRCompareLead?: Maybe<LeadResponse>
  /** General Lead Submission (initialize + fill application) */
  submitLead?: Maybe<LeadResponse>
  /** Submit lock form */
  submitLockForm?: Maybe<Scalars['Boolean']['output']>
  /** Save Rate Selection */
  submitRateSelection?: Maybe<Scalars['Boolean']['output']>
  /**
   * Toggle the sync locked flag on an application's external reference record
   * and returns the status of sync locked
   */
  toggleSyncLocked?: Maybe<Scalars['Boolean']['output']>
  /** Update application session */
  updateApplicationSession?: Maybe<Scalars['Boolean']['output']>
  updateApplicationTask?: Maybe<Scalars['Boolean']['output']>
  updateAttachmentApproval?: Maybe<Scalars['Boolean']['output']>
  /** Update lender loan Id in an application */
  updateLenderLoanId?: Maybe<Scalars['Boolean']['output']>
  /** Update loan setup checklist item */
  updateLoanSetupCheckListItem?: Maybe<Scalars['Boolean']['output']>
  updateLockForm?: Maybe<Scalars['Boolean']['output']>
  /** Fill application */
  updateQStatus?: Maybe<Scalars['Boolean']['output']>
  verifyRateLock?: Maybe<Scalars['Int']['output']>
}

/** Define Mutations */
export type MutationBankrateLeadSubmissionArgs = {
  lead?: InputMaybe<BankrateLeadRequest>
}

/** Define Mutations */
export type MutationAddCoBorrowerArgs = {
  applicationId: Scalars['Int']['input']
  revision: SaveCoBorrowerApplicationRevisionInputSchema
}

/** Define Mutations */
export type MutationAddConditionArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  coBorrowerApplicationId?: InputMaybe<Scalars['Int']['input']>
  conditionInput?: InputMaybe<AddConditionInput>
}

/** Define Mutations */
export type MutationAddTaskToApplicationArgs = {
  applicationId: Scalars['Int']['input']
  taskId: Scalars['Int']['input']
  userId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationAssignApplicationLoanOfficerArgs = {
  applicationId: Scalars['Int']['input']
  createdByUser?: InputMaybe<Scalars['String']['input']>
  loanOfficerId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationAssignColorToProcessorAssignmentArgs = {
  assignmentColor?: InputMaybe<ProcessorAssignmentColorInput>
}

/** Define Mutations */
export type MutationAssignProcessorArgs = {
  assignmentData?: InputMaybe<ProcessorAssignmentInput>
}

/** Define Mutations */
export type MutationAttachLenderLoanIdArgs = {
  request: AttachLenderLoanIdRequest
}

/** Define Mutations */
export type MutationClearCreditReportArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  isPrequal?: InputMaybe<Scalars['Boolean']['input']>
  retoolId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationCopyCreditReportArgs = {
  applicationId: Scalars['Int']['input']
  crIdentifier: Scalars['String']['input']
  isCoborrower?: InputMaybe<Scalars['Boolean']['input']>
  isPrequal?: InputMaybe<Scalars['Boolean']['input']>
}

/** Define Mutations */
export type MutationCorrectLenderLoanIdArgs = {
  applicationId: Scalars['Int']['input']
  lenderLoanId: Scalars['String']['input']
}

/** Define Mutations */
export type MutationCorrectPhoneNumberArgs = {
  applicationId: Scalars['Int']['input']
  phone: Scalars['String']['input']
}

/** Define Mutations */
export type MutationCreateAuth0AccountArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

/** Define Mutations */
export type MutationCreateLoanOfficerArgs = {
  loanOfficer: CreateLoanOfficerInput
}

/** Define Mutations */
export type MutationCreateTaskArgs = {
  task: SaveTaskInput
}

/** Define Mutations */
export type MutationDeleteAddressArgs = {
  addressId?: InputMaybe<Scalars['Int']['input']>
  coBorrowerAddressId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationDeleteAssetArgs = {
  applicationId: Scalars['Int']['input']
  assetId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationDeleteConditionArgs = {
  conditionUuid: Scalars['String']['input']
}

/** Define Mutations */
export type MutationDeleteDocumentRequestArgs = {
  documentRequestUuid: Scalars['String']['input']
}

/** Define Mutations */
export type MutationDeleteIncomeArgs = {
  coBorrowerIncomeId?: InputMaybe<Scalars['Int']['input']>
  incomeId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationDeleteLoanOfficerArgs = {
  loanOfficerId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationDeleteProcessorArgs = {
  processorId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationDeleteRealEstateOwnedArgs = {
  reoId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationDeleteRingCentralAccountArgs = {
  email: Scalars['String']['input']
}

/** Define Mutations */
export type MutationDeleteTaskArgs = {
  taskId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationEditConditionArgs = {
  conditionEdit?: InputMaybe<ConditionInput>
}

/** Define Mutations */
export type MutationEditDocumentRequestArgs = {
  docRequestEdit?: InputMaybe<DocumentRequestInput>
}

/** Define Mutations */
export type MutationEditLoanOfficerPhoneArgs = {
  loanOfficerId: Scalars['Int']['input']
  phone: Scalars['String']['input']
}

/** Define Mutations */
export type MutationFillArgs = {
  answers?: InputMaybe<ApplicationAnswers>
}

/** Define Mutations */
export type MutationFillAddressArgs = {
  addresses?: InputMaybe<Array<InputMaybe<MutationFillAddress>>>
  applicationId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationFillCoBorrowerArgs = {
  answers?: InputMaybe<ApplicationAnswers>
  applicationId?: InputMaybe<Scalars['Int']['input']>
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationFillCoBorrowerAddressesArgs = {
  coBorrowerAddresses: Array<CoBorrowerAddress>
  coBorrowerId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationFillCoBorrowerDemographicsArgs = {
  coBorrowerId: Scalars['Int']['input']
  demographicsAnswers?: InputMaybe<DemographicsAnswers>
}

/** Define Mutations */
export type MutationFillCoBorrowerIncomeArgs = {
  coBorrowerId: Scalars['Int']['input']
  incomeSources: Array<IncomeSource>
}

/** Define Mutations */
export type MutationFillCoBorrowerLiabilitiesArgs = {
  coBorrowerId: Scalars['Int']['input']
  liabilities?: InputMaybe<Array<InputMaybe<LiabilityAnswers>>>
}

/** Define Mutations */
export type MutationFillDemographicsArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  demographicsAnswers?: InputMaybe<DemographicsAnswers>
}

/** Define Mutations */
export type MutationFillIncomeArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  incomeSources?: InputMaybe<Array<InputMaybe<IncomeSource>>>
}

/** Define Mutations */
export type MutationFillLiabilitiesArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  liabilities?: InputMaybe<Array<InputMaybe<LiabilityAnswers>>>
}

/** Define Mutations */
export type MutationFillReoArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  realEstateOwned?: InputMaybe<Array<InputMaybe<RealEstateOwnedAnswer>>>
  realEstateOwnedIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Define Mutations */
export type MutationFillSessionArgs = {
  questionSet: Scalars['String']['input']
}

/** Define Mutations */
export type MutationGetAndSaveAvmDataArgs = {
  request: AvmPropertyDataRequest
}

/** Define Mutations */
export type MutationImportServicerDataArgs = {
  input: ImportServicerDataInput
}

/** Define Mutations */
export type MutationInitializeArgs = {
  bankrateLeadId?: InputMaybe<Scalars['String']['input']>
  fBLeadId?: InputMaybe<Scalars['String']['input']>
  landingUrl?: InputMaybe<Scalars['String']['input']>
  leadId?: InputMaybe<Scalars['Int']['input']>
  leadSource?: InputMaybe<Scalars['String']['input']>
  leadType?: InputMaybe<Scalars['String']['input']>
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
  manualLead?: InputMaybe<Scalars['Boolean']['input']>
  questionnaireType?: InputMaybe<Scalars['String']['input']>
  referrerUrl?: InputMaybe<Scalars['String']['input']>
  sourceLeadId?: InputMaybe<Scalars['String']['input']>
  trackingAttributes?: InputMaybe<Scalars['JSON']['input']>
}

/** Define Mutations */
export type MutationInitializeChecklistArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationManualEsignArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationNewRelicIncrementArgs = {
  name: Scalars['String']['input']
  tags?: InputMaybe<Array<InputMaybe<EventTag>>>
}

/** Define Mutations */
export type MutationNewRelicTimingArgs = {
  name: Scalars['String']['input']
  tags?: InputMaybe<Array<InputMaybe<EventTag>>>
  value: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationPushLeadToNewZipArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationReleaseLockIdArgs = {
  lockFormId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationRemoveCoBorrowerArgs = {
  coBorrowerId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationRemoveTaskFromApplicationArgs = {
  applicationTaskId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationReplicateApplicationV2Args = {
  applicationId: Scalars['Int']['input']
  options?: InputMaybe<ReplicateApplicationOptions>
}

/** Define Mutations */
export type MutationSaveAvmPropertyInfoArgs = {
  applicationId: Scalars['Int']['input']
  corelogicPropertyId?: InputMaybe<Scalars['String']['input']>
  propertyInfo: AvmPropertyDetailsInput
}

/** Define Mutations */
export type MutationSaveAnswerSetArgs = {
  answerSet?: InputMaybe<GqlAnswerSetInput>
}

/** Define Mutations */
export type MutationSaveApplicationAddressRevisionArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  revision?: InputMaybe<SaveApplicationAddressRevisionInputSchema>
}

/** Define Mutations */
export type MutationSaveApplicationContactArgs = {
  applicationId: Scalars['Int']['input']
  contact: ApplicationContactInput
}

/** Define Mutations */
export type MutationSaveApplicationDisclosureArgs = {
  applicationId: Scalars['Int']['input']
  disclosure: DisclosureInformation
}

/** Define Mutations */
export type MutationSaveApplicationDisclosuresArgs = {
  disclosures?: InputMaybe<Array<InputMaybe<DisclosureInformation>>>
  slug?: InputMaybe<Scalars['String']['input']>
}

/** Define Mutations */
export type MutationSaveApplicationLoanOfficerActionRevisionArgs = {
  request: SaveApplicationLoanOfficerActionRevisionRequest
}

/** Define Mutations */
export type MutationSaveApplicationNoteArgs = {
  request: ApplicationNoteSaveRequest
}

/** Define Mutations */
export type MutationSaveApplicationReminderArgs = {
  request: ApplicationReminderSaveRequest
}

/** Define Mutations */
export type MutationSaveApplicationRevisionArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  revision?: InputMaybe<SaveApplicationRevisionInputSchema>
}

/** Define Mutations */
export type MutationSaveAssetRevisionArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  assets?: InputMaybe<Array<InputMaybe<AssetInput>>>
}

/** Define Mutations */
export type MutationSaveCoBorrowerApplicationAddressRevisionArgs = {
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  revision?: InputMaybe<SaveCoBorrowerApplicationAddressRevisionInputSchema>
}

/** Define Mutations */
export type MutationSaveCoBorrowerApplicationDisclosureArgs = {
  coBorrowerId: Scalars['Int']['input']
  disclosure: DisclosureInformation
}

/** Define Mutations */
export type MutationSaveCoBorrowerApplicationDisclosuresArgs = {
  disclosures?: InputMaybe<Array<InputMaybe<DisclosureInformation>>>
  slug?: InputMaybe<Scalars['String']['input']>
}

/** Define Mutations */
export type MutationSaveCoBorrowerApplicationRevisionArgs = {
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  revision?: InputMaybe<SaveCoBorrowerApplicationRevisionInputSchema>
}

/** Define Mutations */
export type MutationSaveCoBorrowerDemographicsArgs = {
  coBorrowerId: Scalars['Int']['input']
  demographicsAnswers?: InputMaybe<DemographicsAnswers>
}

/** Define Mutations */
export type MutationSaveCoBorrowerSsnAliasArgs = {
  coBorrowerId: Scalars['Int']['input']
  ssnAlias: Scalars['String']['input']
}

/** Define Mutations */
export type MutationSaveContactTemplateArgs = {
  name: Scalars['String']['input']
  retoolId?: InputMaybe<Scalars['Int']['input']>
  retoolUserType: Scalars['String']['input']
  text: Scalars['String']['input']
  type: Scalars['String']['input']
}

/** Define Mutations */
export type MutationSaveDemographicsArgs = {
  applicationId: Scalars['Int']['input']
  demographicsAnswers?: InputMaybe<DemographicsAnswers>
}

/** Define Mutations */
export type MutationSaveDocumentRequestNoteArgs = {
  docRequestNote?: InputMaybe<DocumentRequestNoteInput>
}

/** Define Mutations */
export type MutationSaveDocumentRequestStatusArgs = {
  docRequestUuid?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

/** Define Mutations */
export type MutationSaveHomeEquityDetailsArgs = {
  applicationId: Scalars['Int']['input']
  details?: InputMaybe<HomeEquityDetailsInput>
}

/** Define Mutations */
export type MutationSaveIncomeRevisionArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  incomeSources?: InputMaybe<Array<InputMaybe<IncomeSource>>>
}

/** Define Mutations */
export type MutationSaveLiabilityRevisionArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  editorName?: InputMaybe<Scalars['String']['input']>
  liability?: InputMaybe<SaveLiabilityRevisionInputSchema>
}

/** Define Mutations */
export type MutationSaveLockFormArgs = {
  additionalCreditAmount?: InputMaybe<Scalars['Float']['input']>
  additionalCreditSource?: InputMaybe<Scalars['String']['input']>
  applicationId: Scalars['Int']['input']
  cicSlackEnabled?: InputMaybe<Scalars['Boolean']['input']>
  costOfLoan?: InputMaybe<Scalars['Float']['input']>
  costOfLoanYears?: InputMaybe<Scalars['Int']['input']>
  isFloated: Scalars['Boolean']['input']
  isManual?: InputMaybe<Scalars['Boolean']['input']>
  isNoTalkLock?: InputMaybe<Scalars['Boolean']['input']>
  lockId?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  pricingScenario: PricingInput
  processingQuestions?: InputMaybe<Scalars['String']['input']>
  rate: RateInput
  requestType?: InputMaybe<LockRequestType>
}

/** Define Mutations */
export type MutationSaveNonBorrowingSpouseArgs = {
  applicationId: Scalars['Int']['input']
  nonBorrowingSpouse: SaveNonBorrowingSpouseInput
}

/** Define Mutations */
export type MutationSaveNtlDisqualifiedReasonArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  reason: Scalars['String']['input']
}

/** Define Mutations */
export type MutationSavePrelockedRateArgs = {
  additionalCreditAmount?: InputMaybe<Scalars['Float']['input']>
  additionalCreditSource?: InputMaybe<Scalars['String']['input']>
  applicationId: Scalars['Int']['input']
  costOfLoan?: InputMaybe<Scalars['Float']['input']>
  costOfLoanYears?: InputMaybe<Scalars['Int']['input']>
  lockId?: InputMaybe<Scalars['String']['input']>
  rate: RateInput
}

/** Define Mutations */
export type MutationSavePricingScenarioArgs = {
  applicationId: Scalars['Int']['input']
  input: PricingInput
}

/** Define Mutations */
export type MutationSaveProcessorInfoArgs = {
  processorInfo?: InputMaybe<ProcessorInfoInput>
}

/** Define Mutations */
export type MutationSaveRealEstateOwnedArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  liabilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  owner?: InputMaybe<Scalars['String']['input']>
  reo?: InputMaybe<SaveRealEstateOwnedInputSchema>
}

/** Define Mutations */
export type MutationSaveRingCentralAccountArgs = {
  elloUserId?: InputMaybe<Scalars['String']['input']>
  extensionNumber: Scalars['Int']['input']
  jwt: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
  retoolId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationSaveSsnAliasArgs = {
  ssnAlias: Scalars['String']['input']
}

/** Define Mutations */
export type MutationSaveSageContactArgs = {
  contact: SaveSageContactInput
}

/** Define Mutations */
export type MutationSaveSageContactAssignmentArgs = {
  assignment: SaveSageContactAssignmentInput
}

/** Define Mutations */
export type MutationSelectAusReportArgs = {
  applicationId: Scalars['Int']['input']
  ausReportId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationSendLockDeskFailureSlackAlertArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationSendRingCentralSmsByTemplateArgs = {
  applicationId: Scalars['Int']['input']
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  elloUserId?: InputMaybe<Scalars['String']['input']>
  retoolId?: InputMaybe<Scalars['Int']['input']>
  templateId?: InputMaybe<Scalars['Int']['input']>
}

/** Define Mutations */
export type MutationSetExperienceTypeArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  experienceType: ExperienceType
}

/** Define Mutations */
export type MutationSetLoanOfficerConfigurationArgs = {
  request?: InputMaybe<SetConfigurationArgs>
}

/** Define Mutations */
export type MutationSoftDeleteApplicationDisclosureArgs = {
  applicationId: Scalars['Int']['input']
  disclosureType: DisclosureType
}

/** Define Mutations */
export type MutationSoftDeleteCoBorrowerApplicationDisclosureArgs = {
  coBorrowerId: Scalars['Int']['input']
  disclosureType: DisclosureType
}

/** Define Mutations */
export type MutationSoftPullCreditScoreArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  isTrimerge?: InputMaybe<Scalars['Boolean']['input']>
  returnMatchingEstimate?: InputMaybe<Scalars['Boolean']['input']>
}

/** Define Mutations */
export type MutationStoreAddressValidationEventArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationSubmitAdminLeadArgs = {
  leadInfo: AdminLeadInformation
}

/** Define Mutations */
export type MutationSubmitBrCompareLeadArgs = {
  leadInfo?: InputMaybe<BankrateCompareLeadInformation>
}

/** Define Mutations */
export type MutationSubmitLeadArgs = {
  leadInfo?: InputMaybe<LeadInformation>
}

/** Define Mutations */
export type MutationSubmitLockFormArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  lockRequestType?: InputMaybe<LockRequestType>
  pricingScenarioInfo?: InputMaybe<PricingScenarioInfoInput>
  rate?: InputMaybe<RateInput>
}

/** Define Mutations */
export type MutationSubmitRateSelectionArgs = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  isSimpleV2Flow?: InputMaybe<Scalars['Boolean']['input']>
  rate: RateInput
}

/** Define Mutations */
export type MutationToggleSyncLockedArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define Mutations */
export type MutationUpdateApplicationSessionArgs = {
  applicationGuid: Scalars['String']['input']
}

/** Define Mutations */
export type MutationUpdateApplicationTaskArgs = {
  applicationTaskId: Scalars['Int']['input']
  task: SaveApplicationTaskInput
}

/** Define Mutations */
export type MutationUpdateAttachmentApprovalArgs = {
  attachments?: InputMaybe<Array<InputMaybe<UpdateAttachmentInput>>>
}

/** Define Mutations */
export type MutationUpdateLenderLoanIdArgs = {
  request: UpdateLenderLoanIdRequest
}

/** Define Mutations */
export type MutationUpdateLoanSetupCheckListItemArgs = {
  request: UpdateLoanSetupChecklistItemRequest
}

/** Define Mutations */
export type MutationUpdateLockFormArgs = {
  request: UpdateLockFormRequest
}

/** Define Mutations */
export type MutationUpdateQStatusArgs = {
  status: Status
}

/** Define Mutations */
export type MutationVerifyRateLockArgs = {
  request: VerifyRateLockRequest
}

export type MutationFillAddress = {
  apt?: InputMaybe<Scalars['String']['input']>
  autoCompleteAddressFields?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  isAttached?: InputMaybe<Scalars['Boolean']['input']>
  moveInDate?: InputMaybe<Scalars['String']['input']>
  moveOutDate?: InputMaybe<Scalars['String']['input']>
  numberOfStories?: InputMaybe<Scalars['Int']['input']>
  occupancyType?: InputMaybe<OccupancyType>
  rentAmount?: InputMaybe<Scalars['Float']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<AddressType>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type NameAlias = {
  __typename?: 'NameAlias'
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  middleName?: Maybe<Scalars['String']['output']>
}

export type NameAliasInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
}

export type NewZipPushStatus = {
  __typename?: 'NewZipPushStatus'
  enabled: Scalars['Boolean']['output']
  hasBeenPushed: Scalars['Boolean']['output']
}

export type NewZipSubmissionResult = {
  __typename?: 'NewZipSubmissionResult'
  errorMessage?: Maybe<Scalars['String']['output']>
  missingFields?: Maybe<Array<Scalars['String']['output']>>
  success: Scalars['Boolean']['output']
}

export type NonBorrowingSpouseSchema = {
  __typename?: 'NonBorrowingSpouseSchema'
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type NtlQualResult = {
  __typename?: 'NtlQualResult'
  currentLoanTerm?: Maybe<Scalars['Int']['output']>
  debtToIncome?: Maybe<Scalars['Float']['output']>
  isQualified?: Maybe<Scalars['Boolean']['output']>
  reason?: Maybe<Scalars['String']['output']>
}

export enum OccupancyType {
  NoExpense = 'NoExpense',
  Owned = 'Owned',
  Renting = 'Renting',
}

export type Option = {
  __typename?: 'Option'
  component?: Maybe<Scalars['String']['output']>
  iconName?: Maybe<Scalars['String']['output']>
  inputField?: Maybe<Array<Maybe<QuestionInput>>>
  subOptions?: Maybe<Array<Maybe<QuestionCheckboxMulti>>>
  text: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type OtherPage =
  | ErrorPage
  | RateSelectPage
  | RedirectInterstitial
  | SuccessPage

export enum OwnershipClassification {
  Both = 'Both',
  Primary = 'Primary',
  Secondary = 'Secondary',
}

export type PmiQuote = {
  __typename?: 'PMIQuote'
  firstPremiumPeriod?: Maybe<PmiQuotePeriod>
  secondPremiumPeriod?: Maybe<PmiQuotePeriod>
}

export type PmiQuoteInput = {
  firstPremiumPeriod?: InputMaybe<PmiQuotePeriodInput>
  secondPremiumPeriod?: InputMaybe<PmiQuotePeriodInput>
}

export type PmiQuotePeriod = {
  __typename?: 'PMIQuotePeriod'
  durationInMonths?: Maybe<Scalars['Int']['output']>
  monthlyRatePercent?: Maybe<Scalars['Float']['output']>
  premiumAmount?: Maybe<Scalars['Float']['output']>
}

export type PmiQuotePeriodInput = {
  durationInMonths?: InputMaybe<Scalars['Int']['input']>
  monthlyRatePercent?: InputMaybe<Scalars['Float']['input']>
  premiumAmount?: InputMaybe<Scalars['Float']['input']>
}

export type Page = {
  __typename?: 'Page'
  allowSkip?: Maybe<Scalars['Boolean']['output']>
  component?: Maybe<Scalars['String']['output']>
  customPageValidation?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  displaySumOfFields?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  nextButtonText?: Maybe<Scalars['String']['output']>
  questions?: Maybe<Array<Maybe<Questions>>>
  section?: Maybe<Scalars['String']['output']>
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
  validationErrorMsg?: Maybe<Scalars['String']['output']>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type Pagination = {
  pageSize?: InputMaybe<Scalars['Int']['input']>
  paginationOffset?: InputMaybe<Scalars['Int']['input']>
}

export type PaginationInput = {
  offset?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type PaginationResponse = {
  __typename?: 'PaginationResponse'
  total?: Maybe<Scalars['Int']['output']>
}

export enum PointEnum {
  ClosestTo01 = 'ClosestTo01',
  ClosestTo02 = 'ClosestTo02',
  ClosestTo03 = 'ClosestTo03',
  ClosestToZeroNoFee = 'ClosestToZeroNoFee',
  ClosestToZeroWithFee = 'ClosestToZeroWithFee',
  GreaterThan3Point = 'GreaterThan3Point',
  NotSet = 'NotSet',
}

export type PrequalRevisionSchema = {
  __typename?: 'PrequalRevisionSchema'
  loanAmount?: Maybe<Scalars['Float']['output']>
  maxDownPayment?: Maybe<Scalars['Float']['output']>
  maxPurchasePrice?: Maybe<Scalars['Float']['output']>
  originatedAt?: Maybe<Scalars['String']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
}

export type PricingAdjustmentSchema = {
  __typename?: 'PricingAdjustmentSchema'
  applicationId: Scalars['Int']['output']
  bips?: Maybe<Scalars['Float']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  createdBy?: Maybe<Scalars['String']['output']>
  dollarAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['Int']['output']
}

export type PricingExceptionSchema = {
  __typename?: 'PricingExceptionSchema'
  amount: Scalars['Float']['output']
  applicationId: Scalars['Int']['output']
  autoAcceptLevel?: Maybe<Scalars['Float']['output']>
  canMatchOrBeat?: Maybe<Scalars['Boolean']['output']>
  compAdjustmentsRevenue?: Maybe<Scalars['Float']['output']>
  comparisonRate?: Maybe<Scalars['JSON']['output']>
  competitorUpfrontCosts?: Maybe<Scalars['Float']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  createdBy?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  documentExtractId?: Maybe<Scalars['Int']['output']>
  documentType?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  ineligibleReason?: Maybe<Scalars['String']['output']>
  lockBonusUsedInCalculation?: Maybe<Scalars['Float']['output']>
  lockedWithOtherLender?: Maybe<Scalars['Boolean']['output']>
  margin?: Maybe<Scalars['Float']['output']>
  sageUpfrontCosts?: Maybe<Scalars['Float']['output']>
  source: Scalars['String']['output']
  totalRevenue?: Maybe<Scalars['Float']['output']>
}

export type PricingInput = {
  appraisalDownPayment?: InputMaybe<Scalars['Float']['input']>
  appraisalDownPaymentPercent?: InputMaybe<Scalars['Float']['input']>
  cashOut: Scalars['Int']['input']
  city: Scalars['String']['input']
  closingFeeClient?: InputMaybe<Scalars['String']['input']>
  costOfLoanYears?: InputMaybe<Scalars['Int']['input']>
  creditScore: Scalars['Int']['input']
  debtToIncome: Scalars['Float']['input']
  entitlement?: InputMaybe<Scalars['Float']['input']>
  escrowOptions?: InputMaybe<EscrowOptions>
  feesInControlledByLockDesk?: InputMaybe<Scalars['Boolean']['input']>
  firstTimeUsingVaLoan?: InputMaybe<Scalars['Boolean']['input']>
  homeownersInsuranceMonths?: InputMaybe<Scalars['Int']['input']>
  incomeType: Scalars['String']['input']
  initialAppraisalDownPayment?: InputMaybe<Scalars['Float']['input']>
  initialAppraisalDownPaymentPercent?: InputMaybe<Scalars['Float']['input']>
  loanAmount: Scalars['Float']['input']
  loanTerm?: InputMaybe<ProductTerm>
  loanTerms?: InputMaybe<Array<InputMaybe<ProductTerm>>>
  loanToValue: Scalars['Float']['input']
  lockId?: InputMaybe<Scalars['String']['input']>
  lockPeriod?: InputMaybe<Scalars['Int']['input']>
  monthlyInsurance?: InputMaybe<Scalars['Float']['input']>
  points?: InputMaybe<PointEnum>
  product?: InputMaybe<Scalars['String']['input']>
  productClass?: InputMaybe<ProductClass>
  productFamilies?: InputMaybe<Array<InputMaybe<ProductFamily>>>
  productFamily?: InputMaybe<ProductFamily>
  propertyDownPayment?: InputMaybe<Scalars['Float']['input']>
  propertyTax?: InputMaybe<Scalars['Float']['input']>
  propertyTaxMonths?: InputMaybe<Scalars['Int']['input']>
  propertyType: PropertyType
  propertyUse: PropertyUse
  propertyValue: Scalars['Int']['input']
  quotingChannel?: InputMaybe<QuotingChannel>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  rollInEscrow?: InputMaybe<Scalars['Float']['input']>
  rollInFee: Scalars['Int']['input']
  state: StateAbbreviation
  subordinateLien: Scalars['Int']['input']
  subordinateLienCreditLimit?: InputMaybe<Scalars['Float']['input']>
  useFeesInChannel?: InputMaybe<Scalars['Boolean']['input']>
  veteranDisabled?: InputMaybe<Scalars['Boolean']['input']>
  veteranType?: InputMaybe<VeteranType>
  waiveEscrow: Scalars['Boolean']['input']
  zip: Scalars['String']['input']
}

export type PricingScenario = {
  __typename?: 'PricingScenario'
  applicationId: Scalars['String']['output']
  appraisalDownPayment?: Maybe<Scalars['Float']['output']>
  appraisalDownPaymentPercent?: Maybe<Scalars['Float']['output']>
  cashOut?: Maybe<Scalars['Int']['output']>
  city?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  costOfLoanYears?: Maybe<Scalars['Int']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  debtToIncome?: Maybe<Scalars['Float']['output']>
  escrowOptions?: Maybe<EscrowOptions>
  feesInControlledByLockDesk?: Maybe<Scalars['Boolean']['output']>
  firstTimeUsingVaLoan?: Maybe<Scalars['Boolean']['output']>
  homeownersInsuranceMonths?: Maybe<Scalars['Int']['output']>
  incomeType?: Maybe<Scalars['String']['output']>
  initialAppraisalDownPayment?: Maybe<Scalars['Float']['output']>
  initialAppraisalDownPaymentPercent?: Maybe<Scalars['Float']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanTerm?: Maybe<ProductTerm>
  loanTerms?: Maybe<Array<Maybe<ProductTerm>>>
  loanToValue?: Maybe<Scalars['Float']['output']>
  lockId?: Maybe<Scalars['String']['output']>
  lockPeriod?: Maybe<Scalars['Int']['output']>
  monthlyInsurance?: Maybe<Scalars['Float']['output']>
  points?: Maybe<PointEnum>
  product?: Maybe<Scalars['String']['output']>
  productClass?: Maybe<ProductClass>
  productFamilies?: Maybe<Array<Maybe<ProductFamily>>>
  productFamily?: Maybe<ProductFamily>
  propertyDownPayment?: Maybe<Scalars['Float']['output']>
  propertyTax?: Maybe<Scalars['Float']['output']>
  propertyTaxMonths?: Maybe<Scalars['Int']['output']>
  propertyType?: Maybe<PropertyType>
  propertyUse?: Maybe<PropertyUse>
  propertyValue?: Maybe<Scalars['Int']['output']>
  quotingChannel?: Maybe<QuotingChannel>
  remainingBalance?: Maybe<Scalars['Float']['output']>
  rollInEscrow?: Maybe<Scalars['Float']['output']>
  rollInFee?: Maybe<Scalars['Int']['output']>
  state?: Maybe<StateAbbreviation>
  subordinateLien?: Maybe<Scalars['Int']['output']>
  subordinateLienCreditLimit?: Maybe<Scalars['Float']['output']>
  useFeesInChannel?: Maybe<Scalars['Boolean']['output']>
  veteranDisabled?: Maybe<Scalars['Boolean']['output']>
  veteranType?: Maybe<VeteranType>
  waiveEscrow?: Maybe<Scalars['Boolean']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type PricingScenarioInfoInput = {
  debtToIncome?: InputMaybe<Scalars['Int']['input']>
  remainingBalance?: InputMaybe<Scalars['Int']['input']>
}

export type ProcessorAssignment = {
  __typename?: 'ProcessorAssignment'
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  displayColor?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  processorId?: Maybe<Scalars['Int']['output']>
}

export type ProcessorAssignmentColorInput = {
  applicationProcessorAssignmentId?: InputMaybe<Scalars['Int']['input']>
  displayColor?: InputMaybe<Scalars['String']['input']>
}

export type ProcessorAssignmentInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  processorId?: InputMaybe<Scalars['Int']['input']>
}

/** Processor Entity Schemas */
export type ProcessorInfo = {
  __typename?: 'ProcessorInfo'
  active?: Maybe<Scalars['Boolean']['output']>
  activeFilesCount?: Maybe<Scalars['Int']['output']>
  assignmentAllotment?: Maybe<Scalars['Int']['output']>
  email?: Maybe<Scalars['String']['output']>
  employerId?: Maybe<Scalars['Int']['output']>
  employerName?: Maybe<Scalars['String']['output']>
  encompassId?: Maybe<Scalars['String']['output']>
  filesLeft?: Maybe<Scalars['Int']['output']>
  headshotLink?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  importantFlag?: Maybe<Scalars['Boolean']['output']>
  is_manager?: Maybe<Scalars['Boolean']['output']>
  latestAssignmentDate?: Maybe<Scalars['String']['output']>
  managerId?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  retoolId?: Maybe<Scalars['Int']['output']>
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  slackUsername?: Maybe<Scalars['String']['output']>
}

export type ProcessorInfoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  assignmentAllotment?: InputMaybe<Scalars['Int']['input']>
  besmarteeId?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  employerId?: InputMaybe<Scalars['Int']['input']>
  encompassId?: InputMaybe<Scalars['String']['input']>
  headshotLink?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  importantFlag?: InputMaybe<Scalars['Boolean']['input']>
  isManager?: InputMaybe<Scalars['Boolean']['input']>
  managerId?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  retoolId?: InputMaybe<Scalars['Int']['input']>
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slackUsername?: InputMaybe<Scalars['String']['input']>
}

export type ProcessorPipelineRecord = {
  __typename?: 'ProcessorPipelineRecord'
  applicationId?: Maybe<Scalars['Int']['output']>
  borrowerName?: Maybe<Scalars['String']['output']>
  borrowerPhone?: Maybe<Scalars['String']['output']>
  checklist?: Maybe<Array<Maybe<ChecklistTask>>>
  closingDate?: Maybe<Scalars['String']['output']>
  closingLoanOfficerId?: Maybe<Scalars['Int']['output']>
  conditionallyApprovedOn?: Maybe<Scalars['String']['output']>
  ctcDate?: Maybe<Scalars['String']['output']>
  cycleTimes?: Maybe<CycleTimes>
  daysToClose?: Maybe<Scalars['Int']['output']>
  displayColor?: Maybe<Scalars['String']['output']>
  estClosingDate?: Maybe<Scalars['String']['output']>
  fundedDate?: Maybe<Scalars['String']['output']>
  isReLock?: Maybe<Scalars['Boolean']['output']>
  lastContacted?: Maybe<Scalars['String']['output']>
  lastStatusUpdate?: Maybe<Scalars['String']['output']>
  leadStartedDate?: Maybe<Scalars['String']['output']>
  lender?: Maybe<Scalars['String']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  loName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  lockExpiration?: Maybe<Scalars['String']['output']>
  lockExpirationDate?: Maybe<Scalars['String']['output']>
  lockTerm?: Maybe<Scalars['String']['output']>
  lockedDate?: Maybe<Scalars['String']['output']>
  managerId?: Maybe<Scalars['Int']['output']>
  mlo?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Array<Maybe<ApplicationNotesSchema>>>
  processorName?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  uwDate?: Maybe<Scalars['String']['output']>
  withdrawnDate?: Maybe<Scalars['String']['output']>
}

/** Processor Pipeline Schemas */
export type ProcessorPipelineRequest = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  dateRange?: InputMaybe<DateRangeInput>
  email?: InputMaybe<Scalars['String']['input']>
  fetchIcebox?: InputMaybe<Scalars['Boolean']['input']>
  fundedOn?: InputMaybe<Scalars['Boolean']['input']>
  includeNonCompleted?: InputMaybe<Scalars['Boolean']['input']>
  lenderLoanId?: InputMaybe<Scalars['String']['input']>
  loManagerId?: InputMaybe<Scalars['Int']['input']>
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
  managerId?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pagination?: InputMaybe<Pagination>
  phone?: InputMaybe<Scalars['String']['input']>
  processorId?: InputMaybe<Scalars['Int']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  withdrawnOn?: InputMaybe<Scalars['Boolean']['input']>
}

export type ProcessorPipelineResponse = {
  __typename?: 'ProcessorPipelineResponse'
  pagination?: Maybe<PaginationResponse>
  records?: Maybe<Array<Maybe<ProcessorPipelineRecord>>>
}

export type ProcessorTableRequest = {
  employerId?: InputMaybe<Scalars['Int']['input']>
  processorId?: InputMaybe<Scalars['Int']['input']>
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum ProductClass {
  Equity = 'Equity',
  HighBalance = 'HighBalance',
  HighBalanceIo = 'HighBalanceIo',
  InterestOnly = 'InterestOnly',
  Jumbo = 'Jumbo',
  JumboIo = 'JumboIo',
  NotSet = 'NotSet',
  Standard = 'Standard',
  Streamline = 'Streamline',
  StreamlineHb = 'StreamlineHb',
  StreamlineIrrrl = 'StreamlineIrrrl',
  StreamlineIrrrlHb = 'StreamlineIrrrlHb',
  StreamlineIrrrlJumbo = 'StreamlineIrrrlJumbo',
}

export enum ProductFamily {
  Conventional = 'Conventional',
  ConventionalLpmi = 'ConventionalLpmi',
  ConventionalReno = 'ConventionalReno',
  Fha = 'Fha',
  Fha203K = 'Fha203K',
  HarpDu = 'HarpDu',
  HarpLp = 'HarpLp',
  Heloc = 'Heloc',
  HomeAdvantage = 'HomeAdvantage',
  HomePossible = 'HomePossible',
  HomePossibleLpmi = 'HomePossibleLpmi',
  HomeReady = 'HomeReady',
  HomeReadyLpmi = 'HomeReadyLpmi',
  MyCommunity = 'MyCommunity',
  MyCommunityLpmi = 'MyCommunityLpmi',
  NotSet = 'NotSet',
  Usda = 'Usda',
  Va = 'Va',
}

export enum ProductTerm {
  A1_1 = 'A1_1',
  A2_1 = 'A2_1',
  A3_1 = 'A3_1',
  A5_1 = 'A5_1',
  A5_5 = 'A5_5',
  A5_6 = 'A5_6',
  A7_1 = 'A7_1',
  A7_6 = 'A7_6',
  A10_1 = 'A10_1',
  A10_6 = 'A10_6',
  A15_1 = 'A15_1',
  F5 = 'F5',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  F13 = 'F13',
  F14 = 'F14',
  F15 = 'F15',
  F16 = 'F16',
  F17 = 'F17',
  F18 = 'F18',
  F19 = 'F19',
  F20 = 'F20',
  F21 = 'F21',
  F22 = 'F22',
  F23 = 'F23',
  F24 = 'F24',
  F25 = 'F25',
  F26 = 'F26',
  F27 = 'F27',
  F28 = 'F28',
  F29 = 'F29',
  F30 = 'F30',
  F40 = 'F40',
  NotSet = 'NotSet',
}

export type Property = {
  __typename?: 'Property'
  applicationId?: Maybe<Scalars['Int']['output']>
  city: Scalars['String']['output']
  loanPurpose: Scalars['String']['output']
  propertyUse: Scalars['String']['output']
  propertyValue: Scalars['Int']['output']
  state: Scalars['String']['output']
  streetAddress: Scalars['String']['output']
  zip: Scalars['String']['output']
}

export type PropertyTaxInput = {
  propertyTaxDate: Scalars['String']['input']
  propertyTaxEstimate: Scalars['Float']['input']
  propertyTaxFrequency: Scalars['String']['input']
  propertyTaxMonthlyEstimate: Scalars['Float']['input']
  propertyTaxMonths: Scalars['Int']['input']
}

export type PropertyTaxResponse = {
  __typename?: 'PropertyTaxResponse'
  propertyTaxDate: Scalars['String']['output']
  propertyTaxEstimate: Scalars['Int']['output']
  propertyTaxFrequency: Scalars['String']['output']
  propertyTaxMonthlyEstimate: Scalars['Int']['output']
  propertyTaxMonths: Scalars['Int']['output']
}

export type PropertyTaxRetrieve = {
  __typename?: 'PropertyTaxRetrieve'
  applicationId?: Maybe<Scalars['String']['output']>
  fulfillmentPartyOrderIdentifier: Scalars['String']['output']
  respondingPartyOrderIdentifier: Scalars['String']['output']
  submittingPartyOrderIdentifier: Scalars['String']['output']
}

export enum PropertyTaxUse {
  Investment = 'Investment',
  Other = 'Other',
  PrimaryResidence = 'PrimaryResidence',
  SecondHome = 'SecondHome',
}

export enum PropertyType {
  Condo4OrFewerStories = 'Condo4OrFewerStories',
  Condo5OrMoreStories = 'Condo5OrMoreStories',
  Coop = 'Coop',
  DetachedCondo = 'DetachedCondo',
  Leasehold = 'Leasehold',
  MobileOrManufactured = 'MobileOrManufactured',
  Modular = 'Modular',
  MultiFamily2Units = 'MultiFamily2Units',
  MultiFamily3Units = 'MultiFamily3Units',
  MultiFamily4Units = 'MultiFamily4Units',
  NotSpecified = 'NotSpecified',
  Pud = 'Pud',
  SingleFamily = 'SingleFamily',
  Townhouse = 'Townhouse',
}

export enum PropertyTypes {
  Condo4OrFewerStories = 'Condo4OrFewerStories',
  Condo5OrMoreStories = 'Condo5OrMoreStories',
  Coop = 'Coop',
  Leasehold = 'Leasehold',
  MobileOrManufactured = 'MobileOrManufactured',
  Modular = 'Modular',
  MultiFamily2Units = 'MultiFamily2Units',
  MultiFamily3Units = 'MultiFamily3Units',
  MultiFamily4Units = 'MultiFamily4Units',
  NotSpecified = 'NotSpecified',
  Pud = 'Pud',
  SingleFamily = 'SingleFamily',
  Townhouse = 'Townhouse',
}

export enum PropertyUse {
  InvestmentOrRental = 'InvestmentOrRental',
  NotSpecified = 'NotSpecified',
  PrimaryResidence = 'PrimaryResidence',
  SecondaryOrVacation = 'SecondaryOrVacation',
}

export enum PropertyUses {
  InvestmentOrRental = 'InvestmentOrRental',
  NotSpecified = 'NotSpecified',
  PrimaryResidence = 'PrimaryResidence',
  SecondaryOrVacation = 'SecondaryOrVacation',
}

/** Define queries */
export type Query = {
  __typename?: 'Query'
  /** Get application */
  application: AdminLead
  /** Get application details */
  applicationDetails: ApplicationDetailsSchema
  /** Get the value for DTI */
  calculateDebtToIncome?: Maybe<Scalars['Float']['output']>
  /** Compare soft and hard credit scores */
  compareCreditScores?: Maybe<CompareCreditScoresResponse>
  /** Get Contact Templates */
  contactTemplates?: Maybe<Array<Maybe<ContactTemplate>>>
  /** Check if application should use Direct AUS service */
  enableDirectAusService: Scalars['Boolean']['output']
  /** Get Address Auto-Complete Results */
  getAddressAutoCompleteResults?: Maybe<GoogleAutoCompleteResult>
  /** Get State Results From ZipCode */
  getAddressInfoByZipCode?: Maybe<AddressOutput>
  /** Get answer sets */
  getAnswerSets: Array<Maybe<GqlAnswerSet>>
  /** Get Answers */
  getAnswers?: Maybe<GetAnswersResult>
  /** Get basic application information for admin purposes */
  getApplicationBasicInfo: ApplicationBasicInfo
  /** Get application contact */
  getApplicationContact?: Maybe<ApplicationContact>
  /** Get application external references */
  getApplicationExternalEvents?: Maybe<
    Array<Maybe<ApplicationExternalEventSchema>>
  >
  /** Get Application Id from Guid */
  getApplicationIdFromGuid?: Maybe<ApplicationInfoByGuid>
  /** Get application loan officer action revision */
  getApplicationLoanOfficerActionRevision?: Maybe<ApplicationLoanOfficerActionRevisionResponse>
  /** Get all notes for an application */
  getApplicationNotes?: Maybe<Array<Maybe<ApplicationNotesSchema>>>
  /** Get application reporting records */
  getApplicationReportingRecords?: Maybe<
    Array<Maybe<ApplicationReportingSchema>>
  >
  /** Get application tasks */
  getApplicationTasks?: Maybe<Array<Maybe<ApplicationTask>>>
  /** Get attachment status change events for an application */
  getAttachmentStatusEvents?: Maybe<Array<Maybe<AttachmentStatusChangeEvent>>>
  /** Get User Location */
  getCohesionTipLocation?: Maybe<UserLocation>
  /** Get application Communication logs */
  getCommunicationLogs?: Maybe<CommunicationLogResponse>
  /** Get condition status history timeline */
  getConditionStatusHistory?: Maybe<Array<Maybe<ConditionTimelineEvent>>>
  /** Get the value and breakdown for DTI */
  getDebtToIncomeBreakdown?: Maybe<DebtToIncomeBreakdown>
  /** Get generated documents */
  getGeneratedDocumentsPipeline?: Maybe<GeneratedDocumentsPipelineResponse>
  /** Get Address Auto-Complete Results */
  getGeolocationResults?: Maybe<GoogleGeolocationResult>
  /** Get data for integrations page */
  getIntegrationsData?: Maybe<IntegrationDataResponse>
  /** Get latest AUS Report Data */
  getLatestAUSAnalysisData?: Maybe<AusAnalysisDataResponse>
  /** Get lead data */
  getLeadData?: Maybe<LeadData>
  /** Get pipeline leads */
  getLeadPipeline?: Maybe<LeadPipelineResponse>
  /** Get application liabilities and credit score */
  getLiabilitiesAndCreditScore?: Maybe<LiabilityAndCreditScoreOutput>
  /** Get Licensed States */
  getLicensedStates?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Get Loan Officer Display Information */
  getLoanOfficer?: Maybe<LoanOfficerDisplayInfo>
  /** Get loan officer lead cap status */
  getLoanOfficerCapStatus: LoanOfficerCapStatus
  /** Get application LOs SMS logs */
  getLoanOfficerSMSLogs?: Maybe<LoanOfficerSmsLogResponse>
  /** Get loan officer information for administrative purposes */
  getLoanOfficers?: Maybe<Array<Maybe<LoanOfficerAdminInfo>>>
  /** Get Loan Setup Pipeline */
  getLoanSetupPipeline?: Maybe<LoanSetupPipelineResponse>
  /** Get lock data */
  getLockData?: Maybe<LockData>
  /** Get lock desk pipeline data */
  getLockDeskPipeline?: Maybe<LockDeskPipelineResponse>
  /** Get locked or floated loans that have not been e-signed */
  getLockedOrFloatedLoansNotESigned?: Maybe<LockedOrFloatedLoansNotESignedResponse>
  /** Get Pricing */
  getPricing: ApplicationPricing
  /** Get Latest Lock or Float Pricing Scenario */
  getPricingBeforeCICRequest?: Maybe<LatestDonePricingScenario>
  /** Get processor pipeline for all loans with a withdrawn or funded date */
  getProcessorPipelineWithAllStatus?: Maybe<ProcessorPipelineResponse>
  /** Get processor pipeline for all loans with a withdrawn or funded date and with loan setup completed status */
  getProcessorPipelineWithLoanSetupCompletedStatus?: Maybe<ProcessorPipelineResponse>
  /** Get processors table for managerial view */
  getProcessorTable?: Maybe<Array<Maybe<ProcessorInfo>>>
  /** Get all Processors */
  getProcessors?: Maybe<Array<Maybe<ProcessorInfo>>>
  /** Get Questionnaire */
  getQuestionnaire?: Maybe<QuestionSet>
  /** Get Rates */
  getRates?: Maybe<Array<Maybe<Rate>>>
  /** Get Refi Home Liability */
  getRefiHomeLiability?: Maybe<RefiHomeLiabilityOutput>
  /** Get All Sage Contacts */
  getSageContacts?: Maybe<Array<Maybe<SageContactSchema>>>
  /** Get Sensitive Error Data for Applications */
  getSensitiveErrorData?: Maybe<Array<Maybe<ErrorDataSchema>>>
  /** Get servicer leads by phone number for an application */
  getServicerLeadMatch?: Maybe<Array<Maybe<ServicerLeadSchema>>>
  /** Get tasks */
  getTasks?: Maybe<Array<Maybe<Task>>>
  /** Get Trid Days left dashboard */
  getTridDaysLeft?: Maybe<Array<Maybe<TridCountData>>>
  /** Check if address has been validated */
  hasAddressBeenValidated?: Maybe<Scalars['Boolean']['output']>
  /** Has User Account */
  hasExistingAccount?: Maybe<Scalars['Boolean']['output']>
  /**
   * Whether the "Push to NewZip" feature is enabled and whether a lead has
   * already been pushed for this application. Cheap: one flag check plus an
   * indexed lookup. Application-data validation happens in pushLeadToNewZip.
   */
  newZipPushStatus: NewZipPushStatus
  /** Get NTL hard qualification status */
  ntlQualificationStatus?: Maybe<NtlQualResult>
  /** Get Google Address Validation */
  validateAddress?: Maybe<AddressValidationResponse>
  /** Verify user based on phone number and zip code */
  verifyWithLastFourPhone?: Maybe<VerifyWithLastFourPhoneResult>
}

/** Define queries */
export type QueryApplicationArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryApplicationDetailsArgs = {
  applicationId: Scalars['Int']['input']
  retoolId?: InputMaybe<Scalars['Int']['input']>
}

/** Define queries */
export type QueryCalculateDebtToIncomeArgs = {
  applicationId: Scalars['Int']['input']
  customBaseIncome?: InputMaybe<Scalars['Float']['input']>
}

/** Define queries */
export type QueryContactTemplatesArgs = {
  retoolUserType: Scalars['String']['input']
  type: Scalars['String']['input']
}

/** Define queries */
export type QueryEnableDirectAusServiceArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetAddressAutoCompleteResultsArgs = {
  address: Scalars['String']['input']
  userLatitude?: InputMaybe<Scalars['Float']['input']>
  userLongitude?: InputMaybe<Scalars['Float']['input']>
}

/** Define queries */
export type QueryGetAddressInfoByZipCodeArgs = {
  zipCode: Scalars['String']['input']
}

/** Define queries */
export type QueryGetAnswerSetsArgs = {
  questionnaireSlug: Scalars['String']['input']
}

/** Define queries */
export type QueryGetAnswersArgs = {
  applicationGuid?: InputMaybe<Scalars['String']['input']>
  bankrateLeadId?: InputMaybe<Scalars['String']['input']>
  directMailerOfferCode?: InputMaybe<Scalars['String']['input']>
  isAuthenticated?: InputMaybe<Scalars['Boolean']['input']>
}

/** Define queries */
export type QueryGetApplicationBasicInfoArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetApplicationContactArgs = {
  applicationId: Scalars['Int']['input']
  type: Scalars['String']['input']
}

/** Define queries */
export type QueryGetApplicationExternalEventsArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetApplicationIdFromGuidArgs = {
  applicationGuid: Scalars['String']['input']
}

/** Define queries */
export type QueryGetApplicationLoanOfficerActionRevisionArgs = {
  request: ApplicationLoanOfficerActionRevisionRequest
}

/** Define queries */
export type QueryGetApplicationNotesArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetApplicationReportingRecordsArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetApplicationTasksArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetAttachmentStatusEventsArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetCommunicationLogsArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetConditionStatusHistoryArgs = {
  conditionId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetDebtToIncomeBreakdownArgs = {
  applicationId: Scalars['Int']['input']
  customBaseIncome?: InputMaybe<Scalars['Float']['input']>
}

/** Define queries */
export type QueryGetGeneratedDocumentsPipelineArgs = {
  request: GeneratedDocumentsPipelineRequest
}

/** Define queries */
export type QueryGetGeolocationResultsArgs = {
  address: Scalars['String']['input']
}

/** Define queries */
export type QueryGetIntegrationsDataArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetLatestAusAnalysisDataArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetLeadDataArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetLeadPipelineArgs = {
  leadsRequest: LeadPipelineRequest
}

/** Define queries */
export type QueryGetLiabilitiesAndCreditScoreArgs = {
  applicationGuid: Scalars['String']['input']
}

/** Define queries */
export type QueryGetLicensedStatesArgs = {
  productName?: InputMaybe<Scalars['String']['input']>
}

/** Define queries */
export type QueryGetLoanOfficerArgs = {
  bankrateLeadId?: InputMaybe<Scalars['String']['input']>
}

/** Define queries */
export type QueryGetLoanOfficerCapStatusArgs = {
  loanOfficerId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetLoanOfficerSmsLogsArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetLoanSetupPipelineArgs = {
  request?: InputMaybe<LoanSetupPipelineRequest>
}

/** Define queries */
export type QueryGetLockDataArgs = {
  lockFormId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetLockDeskPipelineArgs = {
  request?: InputMaybe<LockDeskPipelineRequest>
}

/** Define queries */
export type QueryGetLockedOrFloatedLoansNotESignedArgs = {
  request?: InputMaybe<LockedOrFloatedLoansNotESignedRequest>
}

/** Define queries */
export type QueryGetPricingArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetPricingBeforeCicRequestArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetProcessorPipelineWithAllStatusArgs = {
  request?: InputMaybe<ProcessorPipelineRequest>
}

/** Define queries */
export type QueryGetProcessorPipelineWithLoanSetupCompletedStatusArgs = {
  request?: InputMaybe<ProcessorPipelineRequest>
}

/** Define queries */
export type QueryGetProcessorTableArgs = {
  request?: InputMaybe<ProcessorTableRequest>
}

/** Define queries */
export type QueryGetQuestionnaireArgs = {
  bankrateLeadId?: InputMaybe<Scalars['String']['input']>
  hostName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
}

/** Define queries */
export type QueryGetRatesArgs = {
  request?: InputMaybe<RatesRequest>
}

/** Define queries */
export type QueryGetSageContactsArgs = {
  occupation: Scalars['String']['input']
}

/** Define queries */
export type QueryGetSensitiveErrorDataArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetServicerLeadMatchArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryGetTridDaysLeftArgs = {
  request: TridCountRequest
}

/** Define queries */
export type QueryHasAddressBeenValidatedArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryHasExistingAccountArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

/** Define queries */
export type QueryNewZipPushStatusArgs = {
  applicationId: Scalars['Int']['input']
}

/** Define queries */
export type QueryNtlQualificationStatusArgs = {
  isPrequalEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

/** Define queries */
export type QueryValidateAddressArgs = {
  address: AddressValidationInputSchema
}

/** Define queries */
export type QueryVerifyWithLastFourPhoneArgs = {
  applicationGuid: Scalars['String']['input']
  lastFourPhone: Scalars['String']['input']
  zipCodeVerify: Scalars['String']['input']
}

export type QuestionApiCallLoader = QuestionBase & {
  __typename?: 'QuestionAPICallLoader'
  apiCall?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  continueOnError?: Maybe<Scalars['Boolean']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  minimumTimeout?: Maybe<Scalars['String']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionAusResults = QuestionBase & {
  __typename?: 'QuestionAUSResults'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionAddressAutoComplete = QuestionBase & {
  __typename?: 'QuestionAddressAutoComplete'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  maxLength?: Maybe<Scalars['String']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionAddressFieldsAutoComplete = QuestionBase & {
  __typename?: 'QuestionAddressFieldsAutoComplete'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  maxLength?: Maybe<Scalars['String']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionAmazonBenefits = QuestionBase & {
  __typename?: 'QuestionAmazonBenefits'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionBase = {
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionBinaryButton = QuestionBase & {
  __typename?: 'QuestionBinaryButton'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  defaultYes?: Maybe<Scalars['Boolean']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionCheckbox = QuestionBase & {
  __typename?: 'QuestionCheckbox'
  checked?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionCheckboxMulti = QuestionBase & {
  __typename?: 'QuestionCheckboxMulti'
  bottomContent?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  defaultOption?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  multiAnswerEnabled?: Maybe<Scalars['Boolean']['output']>
  options?: Maybe<Array<Maybe<Option>>>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionCompareLeRateSelection = QuestionBase & {
  __typename?: 'QuestionCompareLERateSelection'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  redirectToSlug?: Maybe<Scalars['String']['output']>
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionCreateAccount = QuestionBase & {
  __typename?: 'QuestionCreateAccount'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  questions?: Maybe<Array<Maybe<Questions>>>
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionFinicityLink = QuestionBase & {
  __typename?: 'QuestionFinicityLink'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionGroup = QuestionBase & {
  __typename?: 'QuestionGroup'
  autoRepeatValidationKey?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  questions?: Maybe<Array<Maybe<Questions>>>
  subTitle?: Maybe<Scalars['String']['output']>
  textForDeleteButton?: Maybe<Scalars['String']['output']>
  textForRepeatButton?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  titleForRepeatButton?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionHidden = QuestionBase & {
  __typename?: 'QuestionHidden'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  value: Scalars['String']['output']
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionHomeEquityOfferSelection = QuestionBase & {
  __typename?: 'QuestionHomeEquityOfferSelection'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionIncome = QuestionBase & {
  __typename?: 'QuestionIncome'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  options?: Maybe<Array<Maybe<Option>>>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionInfoAccordion = QuestionBase & {
  __typename?: 'QuestionInfoAccordion'
  accordionContent?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionInput = QuestionBase & {
  __typename?: 'QuestionInput'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  inputType?: Maybe<Scalars['String']['output']>
  maxLength?: Maybe<Scalars['String']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionLoanOfficerIntro = QuestionBase & {
  __typename?: 'QuestionLoanOfficerIntro'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionMultiButton = QuestionBase & {
  __typename?: 'QuestionMultiButton'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  options?: Maybe<Array<Maybe<Option>>>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionMultiSelectButton = QuestionBase & {
  __typename?: 'QuestionMultiSelectButton'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  options?: Maybe<Array<Maybe<Option>>>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionNtlRateSelection = QuestionBase & {
  __typename?: 'QuestionNTLRateSelection'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionName = {
  __typename?: 'QuestionName'
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  name: Scalars['String']['output']
  plugin?: Maybe<Scalars['String']['output']>
}

export type QuestionPlaidAssets = QuestionBase & {
  __typename?: 'QuestionPlaidAssets'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionRadio = QuestionBase & {
  __typename?: 'QuestionRadio'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  defaultValue?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  options?: Maybe<Array<Maybe<Option>>>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionRateSelection = QuestionBase & {
  __typename?: 'QuestionRateSelection'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSsn = QuestionBase & {
  __typename?: 'QuestionSSN'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSsnPage = QuestionBase & {
  __typename?: 'QuestionSSNPage'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSelect = QuestionBase & {
  __typename?: 'QuestionSelect'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  options?: Maybe<Array<Maybe<Option>>>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSet = {
  __typename?: 'QuestionSet'
  flowId?: Maybe<Scalars['String']['output']>
  otherPages?: Maybe<Array<Maybe<OtherPage>>>
  pages?: Maybe<Array<Maybe<Page>>>
  title: Scalars['String']['output']
}

export type QuestionSimpleSuccess = QuestionBase & {
  __typename?: 'QuestionSimpleSuccess'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2AddressFields = QuestionBase & {
  __typename?: 'QuestionSimpleV2AddressFields'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2CoBorrowerDeclarations = QuestionBase & {
  __typename?: 'QuestionSimpleV2CoBorrowerDeclarations'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2CoBorrowerQuestion = QuestionBase & {
  __typename?: 'QuestionSimpleV2CoBorrowerQuestion'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2CoBorrowerSsnTask = QuestionBase & {
  __typename?: 'QuestionSimpleV2CoBorrowerSsnTask'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2CreditLoad = QuestionBase & {
  __typename?: 'QuestionSimpleV2CreditLoad'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2Declarations = QuestionBase & {
  __typename?: 'QuestionSimpleV2Declarations'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2DownPayment = QuestionBase & {
  __typename?: 'QuestionSimpleV2DownPayment'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2EmploymentHistory = QuestionBase & {
  __typename?: 'QuestionSimpleV2EmploymentHistory'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2FannieLoaders = QuestionBase & {
  __typename?: 'QuestionSimpleV2FannieLoaders'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2IncomeAssignment = QuestionBase & {
  __typename?: 'QuestionSimpleV2IncomeAssignment'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2Info = QuestionBase & {
  __typename?: 'QuestionSimpleV2Info'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2Offramp = QuestionBase & {
  __typename?: 'QuestionSimpleV2Offramp'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2OfframpFailed = QuestionBase & {
  __typename?: 'QuestionSimpleV2OfframpFailed'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2OfframpSuccess = QuestionBase & {
  __typename?: 'QuestionSimpleV2OfframpSuccess'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2PlaidIntro = QuestionBase & {
  __typename?: 'QuestionSimpleV2PlaidIntro'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2PricingLoad = QuestionBase & {
  __typename?: 'QuestionSimpleV2PricingLoad'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionSimpleV2ResidencyHistory = QuestionBase & {
  __typename?: 'QuestionSimpleV2ResidencyHistory'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionStateSelect = QuestionBase & {
  __typename?: 'QuestionStateSelect'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionToggle = QuestionBase & {
  __typename?: 'QuestionToggle'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  toggled: Scalars['String']['output']
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type QuestionUploader = QuestionBase & {
  __typename?: 'QuestionUploader'
  component: Scalars['String']['output']
  content?: Maybe<Scalars['String']['output']>
  documentType?: Maybe<Scalars['String']['output']>
  infoContent?: Maybe<Scalars['String']['output']>
  infoTitle?: Maybe<Scalars['String']['output']>
  infoWarning?: Maybe<Scalars['Boolean']['output']>
  modifierClass?: Maybe<Scalars['String']['output']>
  questionName: QuestionName
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  topSubHeader?: Maybe<Scalars['String']['output']>
  uploadButtonText?: Maybe<Scalars['String']['output']>
  uploadErrorText?: Maybe<Scalars['String']['output']>
  validations?: Maybe<Array<Maybe<Validations>>>
  visibleIf?: Maybe<Scalars['String']['output']>
  visibleIfConstructor?: Maybe<Array<Maybe<VisibleIfCondition>>>
}

export type Questions =
  | QuestionApiCallLoader
  | QuestionAusResults
  | QuestionAddressAutoComplete
  | QuestionAddressFieldsAutoComplete
  | QuestionAmazonBenefits
  | QuestionBinaryButton
  | QuestionCheckbox
  | QuestionCheckboxMulti
  | QuestionCompareLeRateSelection
  | QuestionCreateAccount
  | QuestionFinicityLink
  | QuestionGroup
  | QuestionHidden
  | QuestionHomeEquityOfferSelection
  | QuestionIncome
  | QuestionInfoAccordion
  | QuestionInput
  | QuestionLoanOfficerIntro
  | QuestionMultiButton
  | QuestionMultiSelectButton
  | QuestionNtlRateSelection
  | QuestionPlaidAssets
  | QuestionRadio
  | QuestionRateSelection
  | QuestionSsn
  | QuestionSsnPage
  | QuestionSelect
  | QuestionSimpleSuccess
  | QuestionSimpleV2AddressFields
  | QuestionSimpleV2CoBorrowerDeclarations
  | QuestionSimpleV2CoBorrowerQuestion
  | QuestionSimpleV2CoBorrowerSsnTask
  | QuestionSimpleV2CreditLoad
  | QuestionSimpleV2Declarations
  | QuestionSimpleV2DownPayment
  | QuestionSimpleV2EmploymentHistory
  | QuestionSimpleV2FannieLoaders
  | QuestionSimpleV2IncomeAssignment
  | QuestionSimpleV2Info
  | QuestionSimpleV2Offramp
  | QuestionSimpleV2OfframpFailed
  | QuestionSimpleV2OfframpSuccess
  | QuestionSimpleV2PlaidIntro
  | QuestionSimpleV2PricingLoad
  | QuestionSimpleV2ResidencyHistory
  | QuestionStateSelect
  | QuestionToggle
  | QuestionUploader

export enum QuotingChannel {
  Bankrate = 'Bankrate',
  CampaignRateTable = 'CampaignRateTable',
  Costco = 'Costco',
  CostcoExecutive = 'CostcoExecutive',
  Default = 'Default',
  FreeRateUpdate = 'FreeRateUpdate',
  LendingTreeLoanExplorer = 'LendingTreeLoanExplorer',
  LoanPricerOnly = 'LoanPricerOnly',
  LoanTek = 'LoanTek',
  NotChannelSpecific = 'NotChannelSpecific',
  NotSpecified = 'NotSpecified',
  /** Organic is not an actual quoting channel - must be translated to LoanTek before sending */
  Organic = 'Organic',
  Rh = 'RH',
  Test = 'Test',
  TestValidation = 'TestValidation',
  Utility1 = 'Utility1',
  Utility2 = 'Utility2',
  Utility3 = 'Utility3',
  Utility4 = 'Utility4',
  Utility5 = 'Utility5',
  Utility6 = 'Utility6',
  Utility7 = 'Utility7',
  Zillow = 'Zillow',
}

export type Rate = {
  __typename?: 'Rate'
  adjustments?: Maybe<Array<Maybe<Adjustment>>>
  adjustmentsTotal?: Maybe<Scalars['Float']['output']>
  apr?: Maybe<Scalars['Float']['output']>
  armDetails?: Maybe<ArmDetails>
  basePrice?: Maybe<Scalars['Float']['output']>
  borrowerName?: Maybe<Scalars['String']['output']>
  cashAtClose?: Maybe<Scalars['Float']['output']>
  cashOut?: Maybe<Scalars['Int']['output']>
  closingCosts?: Maybe<Scalars['Float']['output']>
  closingFeeProvider?: Maybe<Scalars['String']['output']>
  combinedLoanToValue?: Maybe<Scalars['Float']['output']>
  costOfLoan?: Maybe<Scalars['Float']['output']>
  costOfLoanYears?: Maybe<Scalars['Int']['output']>
  creditScore?: Maybe<Scalars['Int']['output']>
  discountOrCreditAmount?: Maybe<Scalars['Float']['output']>
  discountPoints?: Maybe<Scalars['Float']['output']>
  discountPointsAsDollarAmount?: Maybe<Scalars['Float']['output']>
  escrowFees?: Maybe<Scalars['Float']['output']>
  estimatedPrepaidItems?: Maybe<Scalars['Float']['output']>
  family?: Maybe<Scalars['String']['output']>
  fees?: Maybe<Array<Maybe<Fees>>>
  fewerUpfrontCosts?: Maybe<Scalars['Float']['output']>
  fhaMipMonthlyPayment?: Maybe<Scalars['Float']['output']>
  finalPrice?: Maybe<Scalars['Float']['output']>
  fundingFee?: Maybe<Scalars['Float']['output']>
  governmentRefinanceType?: Maybe<Scalars['String']['output']>
  helocDetails?: Maybe<HelocDetails>
  id?: Maybe<Scalars['String']['output']>
  insurancePremium?: Maybe<Scalars['Float']['output']>
  isRollInEscrow?: Maybe<Scalars['Boolean']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  loanAmount?: Maybe<Scalars['Float']['output']>
  loanEstimateSections?: Maybe<LoanEstimateSections>
  loanOfficer?: Maybe<LoanOfficerDisplayInfo>
  loanProgramName?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  loanTerm?: Maybe<Scalars['Int']['output']>
  loanToValue?: Maybe<Scalars['Float']['output']>
  lockId?: Maybe<Scalars['String']['output']>
  lockPeriod?: Maybe<Scalars['Int']['output']>
  matchedDisallowPricingRuleDescription?: Maybe<Scalars['String']['output']>
  monthlyEscrowFees?: Maybe<Scalars['Float']['output']>
  monthlyInsurance?: Maybe<Scalars['Float']['output']>
  monthlyPayment?: Maybe<Scalars['Float']['output']>
  monthlyPrivateMortgageInsurance?: Maybe<Scalars['Float']['output']>
  monthlyPropertyTax?: Maybe<Scalars['Float']['output']>
  mortgageInsurancePremium?: Maybe<MortgageInsurancePremium>
  originationPoints?: Maybe<Scalars['Float']['output']>
  points?: Maybe<Scalars['Int']['output']>
  principleAndInterestPayment?: Maybe<Scalars['Float']['output']>
  privateMortgageInsuranceQuote?: Maybe<PmiQuote>
  productClass?: Maybe<ProductClass>
  productCode?: Maybe<Scalars['String']['output']>
  propertyValue?: Maybe<Scalars['Float']['output']>
  quoteType?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Scalars['Float']['output']>
  rateSheetPrice?: Maybe<Scalars['Float']['output']>
  rollInFees?: Maybe<Scalars['Int']['output']>
  silkFees?: Maybe<Array<Maybe<Fees>>>
  startingAdjustedPrice?: Maybe<Scalars['Float']['output']>
  startingAdjustedRate?: Maybe<Scalars['Float']['output']>
  stopEncountered?: Maybe<Scalars['Boolean']['output']>
  subordinateLienAmount?: Maybe<Scalars['Int']['output']>
  term?: Maybe<Scalars['String']['output']>
  titleFeeProvider?: Maybe<Scalars['String']['output']>
  totalLenderFees?: Maybe<Scalars['Float']['output']>
  type?: Maybe<Scalars['String']['output']>
  undiscountedRate?: Maybe<Scalars['Float']['output']>
}

export enum RateExecutionMethod {
  ByPointGroup = 'ByPointGroup',
  ByRate = 'ByRate',
  JustRemoveStops = 'JustRemoveStops',
}

export type RateInput = {
  adjustments?: InputMaybe<Array<InputMaybe<AdjustmentInput>>>
  adjustmentsTotal?: InputMaybe<Scalars['Float']['input']>
  apr?: InputMaybe<Scalars['Float']['input']>
  armDetails?: InputMaybe<ArmDetailsInput>
  basePrice?: InputMaybe<Scalars['Float']['input']>
  borrowerName?: InputMaybe<Scalars['String']['input']>
  cashAtClose?: InputMaybe<Scalars['Float']['input']>
  cashOut?: InputMaybe<Scalars['Int']['input']>
  closingCosts?: InputMaybe<Scalars['Float']['input']>
  closingFeeProvider?: InputMaybe<Scalars['String']['input']>
  combinedLoanToValue?: InputMaybe<Scalars['Float']['input']>
  costOfLoan?: InputMaybe<Scalars['Float']['input']>
  costOfLoanYears?: InputMaybe<Scalars['Int']['input']>
  discountOrCreditAmount?: InputMaybe<Scalars['Float']['input']>
  discountPoints?: InputMaybe<Scalars['Float']['input']>
  discountPointsAsDollarAmount?: InputMaybe<Scalars['Float']['input']>
  escrowFees?: InputMaybe<Scalars['Float']['input']>
  estimatedPrepaidItems?: InputMaybe<Scalars['Float']['input']>
  family?: InputMaybe<Scalars['String']['input']>
  fees?: InputMaybe<Array<InputMaybe<InputFees>>>
  fewerUpfrontCosts?: InputMaybe<Scalars['Float']['input']>
  fhaMipMonthlyPayment?: InputMaybe<Scalars['Float']['input']>
  finalPrice?: InputMaybe<Scalars['Float']['input']>
  fundingFee?: InputMaybe<Scalars['Float']['input']>
  governmentRefinanceType?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isRollInEscrow?: InputMaybe<Scalars['Boolean']['input']>
  lenderName?: InputMaybe<Scalars['String']['input']>
  loanAmount?: InputMaybe<Scalars['Float']['input']>
  loanEstimateSections?: InputMaybe<LoanEstimateSectionsInput>
  loanOfficer?: InputMaybe<LoanOfficerInput>
  loanProgramName?: InputMaybe<Scalars['String']['input']>
  loanPurpose?: InputMaybe<Scalars['String']['input']>
  loanTerm?: InputMaybe<Scalars['Int']['input']>
  loanToValue?: InputMaybe<Scalars['Float']['input']>
  lockId?: InputMaybe<Scalars['String']['input']>
  lockPeriod?: InputMaybe<Scalars['Int']['input']>
  matchedDisallowPricingRuleDescription?: InputMaybe<Scalars['String']['input']>
  monthlyEscrowFees?: InputMaybe<Scalars['Float']['input']>
  monthlyInsurance?: InputMaybe<Scalars['Float']['input']>
  monthlyPayment?: InputMaybe<Scalars['Float']['input']>
  monthlyPrivateMortgageInsurance?: InputMaybe<Scalars['Float']['input']>
  monthlyPropertyTax?: InputMaybe<Scalars['Float']['input']>
  mortgageInsurancePremium?: InputMaybe<MortgageInsurancePremiumInput>
  originationPoints?: InputMaybe<Scalars['Float']['input']>
  points?: InputMaybe<Scalars['Float']['input']>
  principleAndInterestPayment?: InputMaybe<Scalars['Float']['input']>
  privateMortgageInsuranceQuote?: InputMaybe<PmiQuoteInput>
  productClass?: InputMaybe<ProductClass>
  productCode?: InputMaybe<Scalars['String']['input']>
  propertyValue?: InputMaybe<Scalars['Float']['input']>
  quoteType?: InputMaybe<Scalars['String']['input']>
  rate?: InputMaybe<Scalars['Float']['input']>
  rateSheetPrice?: InputMaybe<Scalars['Float']['input']>
  rollInFees?: InputMaybe<Scalars['Int']['input']>
  silkFees?: InputMaybe<Array<InputMaybe<InputFees>>>
  startingAdjustedPrice?: InputMaybe<Scalars['Float']['input']>
  startingAdjustedRate?: InputMaybe<Scalars['Float']['input']>
  stopEncountered?: InputMaybe<Scalars['Boolean']['input']>
  subordinateLienAmount?: InputMaybe<Scalars['Int']['input']>
  term?: InputMaybe<Scalars['String']['input']>
  titleFeeProvider?: InputMaybe<Scalars['String']['input']>
  totalLenderFees?: InputMaybe<Scalars['Float']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  undiscountedRate?: InputMaybe<Scalars['Float']['input']>
}

export type RateSelectPage = {
  __typename?: 'RateSelectPage'
  component: Scalars['String']['output']
  variations: Array<RateSelectPageVariation>
}

export type RateSelectPageVariation = {
  __typename?: 'RateSelectPageVariation'
  cta: Scalars['String']['output']
  subTitle: Scalars['String']['output']
  title: Scalars['String']['output']
  variation: Scalars['String']['output']
}

export type RateSelectionSchema = {
  __typename?: 'RateSelectionSchema'
  createdAt?: Maybe<Scalars['String']['output']>
  rate?: Maybe<Scalars['Float']['output']>
  rateFamily?: Maybe<Scalars['String']['output']>
  rateTerm?: Maybe<Scalars['Int']['output']>
  rateType?: Maybe<Scalars['String']['output']>
}

export type RatesRequest = {
  address?: InputMaybe<Scalars['String']['input']>
  amcProduct?: InputMaybe<Scalars['String']['input']>
  applicationId?: InputMaybe<Scalars['Int']['input']>
  applyFeesInMarginAdjustment?: InputMaybe<Scalars['Boolean']['input']>
  borrowerName?: InputMaybe<Scalars['String']['input']>
  cashOut?: InputMaybe<Scalars['Int']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  closingFeeAnswers?: InputMaybe<Array<InputMaybe<ClosingFeeAnswer>>>
  closingFeeClient?: InputMaybe<Scalars['String']['input']>
  closingFeeProvider?: InputMaybe<Scalars['String']['input']>
  combinedLoanToValue?: InputMaybe<Scalars['Float']['input']>
  costOfLoanYears?: InputMaybe<Scalars['Int']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  debtToIncome?: InputMaybe<Scalars['Float']['input']>
  escrowOptions?: InputMaybe<Scalars['String']['input']>
  excludeForcedFeeQuotes?: InputMaybe<Scalars['Boolean']['input']>
  executionMethod?: InputMaybe<RateExecutionMethod>
  fallbackCreditScore?: InputMaybe<Scalars['Int']['input']>
  financeUpFrontMortgageInsurancePremium?: InputMaybe<
    Scalars['Boolean']['input']
  >
  fipsCode?: InputMaybe<Scalars['String']['input']>
  firstTimeBuyer?: InputMaybe<Scalars['Boolean']['input']>
  forceCurrentPricing?: InputMaybe<Scalars['Boolean']['input']>
  hasInternalFeesInPricingPermission?: InputMaybe<Scalars['Boolean']['input']>
  hasLockExtensionMarginPricingPermission?: InputMaybe<
    Scalars['Boolean']['input']
  >
  homeownersInsuranceMonths?: InputMaybe<Scalars['Int']['input']>
  ignoreStops?: InputMaybe<Scalars['Boolean']['input']>
  includeZeroAmountAdjustments?: InputMaybe<Scalars['Boolean']['input']>
  isLockQuote?: InputMaybe<Scalars['Boolean']['input']>
  leadId?: InputMaybe<Scalars['Int']['input']>
  loanAmount?: InputMaybe<Scalars['Float']['input']>
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
  loanPurpose: LoanPurpose
  loanTerm?: InputMaybe<Array<InputMaybe<ProductTerm>>>
  loanToValue?: InputMaybe<Scalars['Float']['input']>
  lockId?: InputMaybe<Scalars['String']['input']>
  lockPeriod?: InputMaybe<Scalars['Int']['input']>
  monthlyInsurance?: InputMaybe<Scalars['Float']['input']>
  monthlyPropertyTax?: InputMaybe<Scalars['Float']['input']>
  newConstruction?: InputMaybe<Scalars['Boolean']['input']>
  points?: InputMaybe<Array<InputMaybe<PointEnum>>>
  productFamily?: InputMaybe<Array<InputMaybe<ProductFamily>>>
  propertyDownPayment?: InputMaybe<Scalars['Float']['input']>
  propertyPurchasePrice?: InputMaybe<Scalars['Float']['input']>
  propertyTaxEstimate?: InputMaybe<PropertyTaxInput>
  propertyType?: InputMaybe<PropertyType>
  propertyUse?: InputMaybe<PropertyUse>
  propertyValue?: InputMaybe<Scalars['Int']['input']>
  quotingChannel?: InputMaybe<QuotingChannel>
  recordingOfficeId?: InputMaybe<Scalars['String']['input']>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  rollInEscrow?: InputMaybe<Scalars['Float']['input']>
  rollInFees?: InputMaybe<Scalars['Float']['input']>
  selfEmployed?: InputMaybe<Scalars['Boolean']['input']>
  servicerLeadId?: InputMaybe<Scalars['Int']['input']>
  skipSilkFees?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<RatesRequestSource>
  state?: InputMaybe<StateAbbreviation>
  subJurisdiction?: InputMaybe<Scalars['String']['input']>
  subordinateLienAmount?: InputMaybe<Scalars['Float']['input']>
  subordinateLienCreditLimit?: InputMaybe<Scalars['Float']['input']>
  veteran?: InputMaybe<Veteran>
  waiveEscrow?: InputMaybe<Scalars['Boolean']['input']>
  willRollInEscrow?: InputMaybe<Scalars['Boolean']['input']>
  willRollInFees?: InputMaybe<Scalars['Boolean']['input']>
  zipCode: Scalars['String']['input']
}

export enum RatesRequestSource {
  Borrowerportal = 'BORROWERPORTAL',
  Ello = 'ELLO',
  Full1003 = 'FULL1003',
  Loanmatch = 'LOANMATCH',
  Retool = 'RETOOL',
}

export type RealEstateOwnedAnswer = {
  apt?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  numberOfUnits?: InputMaybe<Scalars['Int']['input']>
  propertyOwners?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type RealEstateOwnedOutput = {
  __typename?: 'RealEstateOwnedOutput'
  apt?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  propertyOwners?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type RealEstateOwnedSchema = {
  __typename?: 'RealEstateOwnedSchema'
  apt?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  currentOccupancy?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  dtiCalculations?: Maybe<DtiCalculationsSchema>
  expenses?: Maybe<Scalars['Float']['output']>
  grossRentalIncome?: Maybe<Scalars['Float']['output']>
  hoaDuesMonthly?: Maybe<Scalars['Float']['output']>
  id: Scalars['Int']['output']
  includesEscrows?: Maybe<Scalars['Boolean']['output']>
  intendedOccupancy?: Maybe<Scalars['String']['output']>
  intendedType?: Maybe<Scalars['String']['output']>
  isCurrent?: Maybe<Scalars['Boolean']['output']>
  isSubject?: Maybe<Scalars['Boolean']['output']>
  liabilities?: Maybe<Array<Maybe<LiabilityRevisionSchema>>>
  maintenanceExpensesMonthly?: Maybe<Scalars['Float']['output']>
  netProceeds?: Maybe<Scalars['Float']['output']>
  netRentalIncome?: Maybe<Scalars['Float']['output']>
  numberOfUnits?: Maybe<Scalars['Int']['output']>
  occupancyRate?: Maybe<Scalars['Float']['output']>
  ownerId?: Maybe<Scalars['Int']['output']>
  propertyInsuranceMonthly?: Maybe<Scalars['Float']['output']>
  propertyOwners?: Maybe<Scalars['String']['output']>
  propertyTaxesMonthly?: Maybe<Scalars['Float']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyValue?: Maybe<Scalars['Float']['output']>
  state?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type RecordId = {
  __typename?: 'RecordId'
  id?: Maybe<Scalars['Int']['output']>
}

export type RedirectInterstitial = {
  __typename?: 'RedirectInterstitial'
  body?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  time?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type RedirectUrl = {
  __typename?: 'RedirectUrl'
  redirectUrl: Scalars['String']['output']
}

export type RefiHomeLiabilityOutput = {
  __typename?: 'RefiHomeLiabilityOutput'
  monthly_expense?: Maybe<Scalars['Float']['output']>
  remaining_term_months?: Maybe<Scalars['Int']['output']>
  total_term_months?: Maybe<Scalars['Int']['output']>
  unpaid_balance?: Maybe<Scalars['Float']['output']>
}

export type RelatedApplications = {
  __typename?: 'RelatedApplications'
  id?: Maybe<Scalars['Int']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type ReplicateApplicationBorrowerIds = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  coborrowerId?: InputMaybe<Scalars['Int']['input']>
}

export type ReplicateApplicationOptions = {
  coborrowerId?: InputMaybe<ReplicateApplicationBorrowerIds>
  /** Legacy options for copying additional data (admin only) */
  legacy?: InputMaybe<LegacyDuplicationOptions>
  loId?: InputMaybe<Scalars['Int']['input']>
  primaryBorrowerId?: InputMaybe<ReplicateApplicationBorrowerIds>
  reappReason?: InputMaybe<Scalars['String']['input']>
  structuredReappReason?: InputMaybe<Scalars['String']['input']>
}

export type SmsFrom = {
  __typename?: 'SMSFrom'
  extensionNumber?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
}

export type SmsLog = {
  __typename?: 'SMSLog'
  conversationId?: Maybe<Scalars['String']['output']>
  creationTime?: Maybe<Scalars['String']['output']>
  deliveryErrorCode?: Maybe<Scalars['String']['output']>
  direction?: Maybe<Scalars['String']['output']>
  from?: Maybe<SmsFrom>
  id?: Maybe<Scalars['String']['output']>
  lastModifiedTime?: Maybe<Scalars['String']['output']>
  messageStatus?: Maybe<Scalars['String']['output']>
  priority?: Maybe<Scalars['String']['output']>
  readStatus?: Maybe<Scalars['String']['output']>
  smsDeliveryTime?: Maybe<Scalars['String']['output']>
  smsSendingAttemptsCount?: Maybe<Scalars['Int']['output']>
  subject?: Maybe<Scalars['String']['output']>
  to?: Maybe<Array<Maybe<SmsTo>>>
  type?: Maybe<Scalars['String']['output']>
}

export type SmsTo = {
  __typename?: 'SMSTo'
  extensionNumber?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  messageStatus?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  target?: Maybe<Scalars['Boolean']['output']>
}

export type SageContactSchema = {
  __typename?: 'SageContactSchema'
  broker?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  joinDate?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  occupation?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  realStateLicense?: Maybe<Scalars['String']['output']>
  referrer?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  yearsExperience?: Maybe<Scalars['Int']['output']>
}

export type SaveApplicationAddressRevisionInputSchema = {
  apt?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  isAttached?: InputMaybe<Scalars['Boolean']['input']>
  isMailingAddress?: InputMaybe<Scalars['Boolean']['input']>
  moveInDate?: InputMaybe<Scalars['String']['input']>
  moveOutDate?: InputMaybe<Scalars['String']['input']>
  numberOfStories?: InputMaybe<Scalars['Int']['input']>
  occupancyType?: InputMaybe<OccupancyType>
  rentAmount?: InputMaybe<Scalars['Float']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type SaveApplicationLoanOfficerActionRevisionRequest = {
  actionStatus?: InputMaybe<Scalars['String']['input']>
  applicationId: Scalars['Int']['input']
  contactStatus?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  retoolId: Scalars['Int']['input']
}

export type SaveApplicationRevisionInputSchema = {
  abadDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  address?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  amortizationType?: InputMaybe<Scalars['String']['input']>
  appraisalFee?: InputMaybe<Scalars['Float']['input']>
  cashOut?: InputMaybe<Scalars['Float']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  closingDate?: InputMaybe<Scalars['String']['input']>
  contractMustCloseBy?: InputMaybe<Scalars['String']['input']>
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  creditScoreSource?: InputMaybe<Scalars['String']['input']>
  currentTotalMonthlyPayment?: InputMaybe<Scalars['Float']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  debtToIncome?: InputMaybe<Scalars['Float']['input']>
  declarationAlimony?: InputMaybe<Scalars['Boolean']['input']>
  declarationBankrupcy?: InputMaybe<Scalars['Boolean']['input']>
  declarationBankruptcyType?: InputMaybe<Scalars['String']['input']>
  declarationBorrowedDown?: InputMaybe<Scalars['Boolean']['input']>
  declarationBorrowedDownFundsAmount?: InputMaybe<Scalars['Float']['input']>
  declarationCitizen?: InputMaybe<Scalars['Boolean']['input']>
  declarationCitizenStatus?: InputMaybe<Scalars['String']['input']>
  declarationConveyedTitle?: InputMaybe<Scalars['Boolean']['input']>
  declarationEthnicity?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  declarationFhaLoan?: InputMaybe<Scalars['Boolean']['input']>
  declarationForeclosures?: InputMaybe<Scalars['Boolean']['input']>
  declarationGender?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  declarationHomeOwnership?: InputMaybe<Scalars['Boolean']['input']>
  declarationJudgements?: InputMaybe<Scalars['Boolean']['input']>
  declarationLawsuits?: InputMaybe<Scalars['Boolean']['input']>
  declarationLoanDefaults?: InputMaybe<Scalars['Boolean']['input']>
  declarationLoanForeclosures?: InputMaybe<Scalars['Boolean']['input']>
  declarationMilitary?: InputMaybe<Scalars['Boolean']['input']>
  declarationNoteEndorser?: InputMaybe<Scalars['Boolean']['input']>
  declarationPrimaryResidence?: InputMaybe<Scalars['Boolean']['input']>
  declarationPropertyTitle?: InputMaybe<Scalars['String']['input']>
  declarationPropertyType?: InputMaybe<Scalars['String']['input']>
  declarationRace?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  declarationRelationWithSeller?: InputMaybe<Scalars['Boolean']['input']>
  declarationResident?: InputMaybe<Scalars['Boolean']['input']>
  declarationSchooling?: InputMaybe<Scalars['String']['input']>
  declarationSubjectToLien?: InputMaybe<Scalars['Boolean']['input']>
  declarationUndisclosedCreditApplicationIndicator?: InputMaybe<
    Scalars['Boolean']['input']
  >
  declarationVaLoan?: InputMaybe<Scalars['Boolean']['input']>
  dependentsAges?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  dueDiligence?: InputMaybe<Scalars['Float']['input']>
  earnestMoney?: InputMaybe<Scalars['Float']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  escrow?: InputMaybe<Scalars['Boolean']['input']>
  existingLoanType?: InputMaybe<Scalars['String']['input']>
  expectedRentalIncome?: InputMaybe<Scalars['Float']['input']>
  expenseFirstMortgage?: InputMaybe<Scalars['Float']['input']>
  expenseHoaDues?: InputMaybe<Scalars['Float']['input']>
  expenseHomeInsurance?: InputMaybe<Scalars['Float']['input']>
  expenseMortgageInsurance?: InputMaybe<Scalars['Float']['input']>
  expensePropertyTax?: InputMaybe<Scalars['Float']['input']>
  expenseRent?: InputMaybe<Scalars['Float']['input']>
  expenseSecondMortgage?: InputMaybe<Scalars['Float']['input']>
  fipsCode?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  firstTimeHomeBuyer?: InputMaybe<Scalars['Boolean']['input']>
  forbearance?: InputMaybe<Scalars['Boolean']['input']>
  frozenCreditCheck?: InputMaybe<Scalars['Boolean']['input']>
  goalRate?: InputMaybe<Scalars['Float']['input']>
  hasRefinancedBefore?: InputMaybe<Scalars['Boolean']['input']>
  homeBusiness?: InputMaybe<Scalars['Boolean']['input']>
  iceBox?: InputMaybe<Scalars['Boolean']['input']>
  interestRate?: InputMaybe<Scalars['Float']['input']>
  isCurrentAddress?: InputMaybe<Scalars['Boolean']['input']>
  isCurrentPropertyListed?: InputMaybe<Scalars['Boolean']['input']>
  isRollInEscrow?: InputMaybe<Scalars['Boolean']['input']>
  jointApplicantIntention?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  latestLoanAmount?: InputMaybe<Scalars['Float']['input']>
  latestLoanDate?: InputMaybe<Scalars['String']['input']>
  latestLoanYear?: InputMaybe<Scalars['Int']['input']>
  leadGoal?: InputMaybe<Scalars['String']['input']>
  loDisclosureAcknowledgedBy?: InputMaybe<Scalars['String']['input']>
  loDisclosureAcknowledgedDate?: InputMaybe<Scalars['String']['input']>
  loPriorityLevel?: InputMaybe<Scalars['String']['input']>
  loanAmount?: InputMaybe<Scalars['Float']['input']>
  loanPurpose?: InputMaybe<Scalars['String']['input']>
  loanToValue?: InputMaybe<Scalars['Float']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  mergeExistingUserEmail?: InputMaybe<Scalars['Boolean']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  militaryDetails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  militaryServiceMember?: InputMaybe<Scalars['String']['input']>
  militaryServiceTourDate?: InputMaybe<Scalars['String']['input']>
  monthlyPaymentSavingsGoal?: InputMaybe<Scalars['Float']['input']>
  moveExplanation?: InputMaybe<Scalars['String']['input']>
  nameAliases?: InputMaybe<Array<InputMaybe<NameAliasInput>>>
  needToSellBeforePurchase?: InputMaybe<Scalars['Boolean']['input']>
  nextRevision?: InputMaybe<Scalars['Int']['input']>
  nonSpousePropertyRights?: InputMaybe<Scalars['Boolean']['input']>
  nonSpousePropertyRightsState?: InputMaybe<Scalars['String']['input']>
  nonSpousePropertyRightsType?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  originalCost?: InputMaybe<Scalars['Float']['input']>
  originalLoanTerm?: InputMaybe<Scalars['Float']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  preapprovedWithOtherLender?: InputMaybe<Scalars['Boolean']['input']>
  previousCashOut?: InputMaybe<Scalars['Boolean']['input']>
  previousRefinance?: InputMaybe<Scalars['Boolean']['input']>
  previousRefinanceCloseDate?: InputMaybe<Scalars['String']['input']>
  promotionMentioned?: InputMaybe<Scalars['Boolean']['input']>
  propertyAttachment?: InputMaybe<Scalars['String']['input']>
  propertyCondoDesignType?: InputMaybe<Scalars['String']['input']>
  propertyDownPayment?: InputMaybe<Scalars['Float']['input']>
  propertyInspectionWaiver?: InputMaybe<Scalars['Boolean']['input']>
  propertyNumberOfStories?: InputMaybe<Scalars['String']['input']>
  propertyPurchasePrice?: InputMaybe<Scalars['Float']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyUse?: InputMaybe<Scalars['String']['input']>
  propertyValue?: InputMaybe<Scalars['Float']['input']>
  propertyYearBuilt?: InputMaybe<Scalars['Int']['input']>
  propertyYearPurchased?: InputMaybe<Scalars['Int']['input']>
  proposedExpenseFirstMortgage?: InputMaybe<Scalars['Float']['input']>
  proposedExpenseHoaDues?: InputMaybe<Scalars['Float']['input']>
  proposedExpenseHomeInsurance?: InputMaybe<Scalars['Float']['input']>
  proposedExpenseMortgageInsurance?: InputMaybe<Scalars['Float']['input']>
  proposedExpensePropertyTax?: InputMaybe<Scalars['Float']['input']>
  proposedExpenseSecondMortgage?: InputMaybe<Scalars['Float']['input']>
  purchaseStage?: InputMaybe<Scalars['String']['input']>
  refiReason?: InputMaybe<Scalars['String']['input']>
  refinanceExplanation?: InputMaybe<Scalars['String']['input']>
  refinancePrimaryPurpose?: InputMaybe<Scalars['String']['input']>
  remainingBalance?: InputMaybe<Scalars['Float']['input']>
  revisionType?: InputMaybe<Scalars['String']['input']>
  rollInFees?: InputMaybe<Scalars['Boolean']['input']>
  sellerCredit?: InputMaybe<Scalars['Float']['input']>
  ssnAlias?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  submissionAuthorization?: InputMaybe<Scalars['Boolean']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
  tcpaDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  termsAndCreditAuthorization?: InputMaybe<Scalars['Boolean']['input']>
  termsOfUseDisclosure?: InputMaybe<Scalars['Boolean']['input']>
  timeInHome?: InputMaybe<Scalars['String']['input']>
  titleHolderLegalNames?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  titleMannerHeld?: InputMaybe<Scalars['String']['input']>
  totalAssets?: InputMaybe<Scalars['Float']['input']>
  undisclosedBorrowedFundsAmount?: InputMaybe<Scalars['Float']['input']>
  undisclosedBorrowedFundsIndicator?: InputMaybe<Scalars['Boolean']['input']>
  vaFeesExemptStatus?: InputMaybe<Scalars['Boolean']['input']>
  vaHas6Payments?: InputMaybe<Scalars['Boolean']['input']>
  vaHas210Days?: InputMaybe<Scalars['Boolean']['input']>
  vaLoanPurpose?: InputMaybe<Scalars['String']['input']>
  vaNewRate?: InputMaybe<Scalars['Float']['input']>
  vaNewTerm?: InputMaybe<Scalars['String']['input']>
  vaOccupancyCertType?: InputMaybe<Scalars['String']['input']>
  vaOccupancyCertification?: InputMaybe<Scalars['Boolean']['input']>
  vaPrevAmortType?: InputMaybe<Scalars['String']['input']>
  vaPrevBalance?: InputMaybe<Scalars['Float']['input']>
  vaPrevFirstPaymentDate?: InputMaybe<Scalars['String']['input']>
  vaPrevPI?: InputMaybe<Scalars['Float']['input']>
  vaPrevRate?: InputMaybe<Scalars['Float']['input']>
  vaRecoupEstClosingCosts?: InputMaybe<Scalars['Float']['input']>
  vaSeasoningCertified?: InputMaybe<Scalars['Boolean']['input']>
  vaVeteranFirstUse?: InputMaybe<Scalars['Boolean']['input']>
  vaVeteranStatus?: InputMaybe<Scalars['Boolean']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type SaveApplicationRevisionResponse = {
  __typename?: 'SaveApplicationRevisionResponse'
  existingUserEmailDetails?: Maybe<ExistingUserEmailDetails>
  success: Scalars['Boolean']['output']
}

export type SaveApplicationTaskInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<TaskStatus>
  taskId?: InputMaybe<Scalars['Int']['input']>
  userId?: InputMaybe<Scalars['Int']['input']>
}

export type SaveCoBorrowerApplicationAddressRevisionInputSchema = {
  apt?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  coBorrowerId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  isMailingAddress?: InputMaybe<Scalars['Boolean']['input']>
  moveInDate?: InputMaybe<Scalars['String']['input']>
  moveOutDate?: InputMaybe<Scalars['String']['input']>
  occupancyType?: InputMaybe<OccupancyType>
  rentAmount?: InputMaybe<Scalars['Float']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type SaveCoBorrowerApplicationRevisionInputSchema = {
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>
  creditScore?: InputMaybe<Scalars['Int']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  declarationAlimony?: InputMaybe<Scalars['Boolean']['input']>
  declarationBankrupcy?: InputMaybe<Scalars['Boolean']['input']>
  declarationBankruptcyType?: InputMaybe<Scalars['String']['input']>
  declarationBorrowedDown?: InputMaybe<Scalars['Boolean']['input']>
  declarationBorrowedDownFundsAmount?: InputMaybe<Scalars['Float']['input']>
  declarationCitizen?: InputMaybe<Scalars['Boolean']['input']>
  declarationCitizenStatus?: InputMaybe<Scalars['String']['input']>
  declarationConveyedTitle?: InputMaybe<Scalars['Boolean']['input']>
  declarationEthnicity?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  declarationFhaLoan?: InputMaybe<Scalars['Boolean']['input']>
  declarationForeclosures?: InputMaybe<Scalars['Boolean']['input']>
  declarationGender?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  declarationHomeOwnership?: InputMaybe<Scalars['Boolean']['input']>
  declarationJudgements?: InputMaybe<Scalars['Boolean']['input']>
  declarationLawsuits?: InputMaybe<Scalars['Boolean']['input']>
  declarationLoanDefaults?: InputMaybe<Scalars['Boolean']['input']>
  declarationLoanForeclosures?: InputMaybe<Scalars['Boolean']['input']>
  declarationMilitary?: InputMaybe<Scalars['Boolean']['input']>
  declarationNoteEndorser?: InputMaybe<Scalars['Boolean']['input']>
  declarationPrimaryResidence?: InputMaybe<Scalars['Boolean']['input']>
  declarationPropertyTitle?: InputMaybe<Scalars['String']['input']>
  declarationPropertyType?: InputMaybe<Scalars['String']['input']>
  declarationRace?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  declarationRelationWithSeller?: InputMaybe<Scalars['Boolean']['input']>
  declarationResident?: InputMaybe<Scalars['Boolean']['input']>
  declarationSchooling?: InputMaybe<Scalars['String']['input']>
  declarationSubjectToLien?: InputMaybe<Scalars['Boolean']['input']>
  declarationUndisclosedCreditApplicationIndicator?: InputMaybe<
    Scalars['Boolean']['input']
  >
  declarationVaLoan?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  financesUsedToQualify?: InputMaybe<Scalars['Boolean']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  firstTimeHomeBuyer?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  marriedToPrimary?: InputMaybe<Scalars['Boolean']['input']>
  mergeExistingUserEmail?: InputMaybe<Scalars['Boolean']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  militaryDetails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  militaryServiceTourDate?: InputMaybe<Scalars['String']['input']>
  nameAliases?: InputMaybe<Array<InputMaybe<NameAliasInput>>>
  nextRevision?: InputMaybe<Scalars['Int']['input']>
  nonSpousePropertyRights?: InputMaybe<Scalars['Boolean']['input']>
  nonSpousePropertyRightsState?: InputMaybe<Scalars['String']['input']>
  nonSpousePropertyRightsType?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  revisionType?: InputMaybe<Scalars['String']['input']>
  sameAddressAsPrimary?: InputMaybe<Scalars['Boolean']['input']>
  ssnAlias?: InputMaybe<Scalars['String']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
  termsAndCreditAuthorization?: InputMaybe<Scalars['Boolean']['input']>
  undisclosedBorrowedFundsAmount?: InputMaybe<Scalars['Float']['input']>
  undisclosedBorrowedFundsIndicator?: InputMaybe<Scalars['Boolean']['input']>
}

export type SaveLiabilityRevisionInputSchema = {
  accountNumber?: InputMaybe<Scalars['String']['input']>
  apt?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  creditLine?: InputMaybe<Scalars['Float']['input']>
  creditLoanType?: InputMaybe<Scalars['String']['input']>
  creditReportId?: InputMaybe<Scalars['Int']['input']>
  creditor?: InputMaybe<Scalars['String']['input']>
  currentHousingExpense?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  includesEscrows?: InputMaybe<Scalars['Boolean']['input']>
  liabilityType?: InputMaybe<Scalars['String']['input']>
  monthlyExpense?: InputMaybe<Scalars['Float']['input']>
  mortgageType?: InputMaybe<Scalars['String']['input']>
  omit?: InputMaybe<Scalars['Boolean']['input']>
  otherDescription?: InputMaybe<Scalars['String']['input']>
  ownershipType?: InputMaybe<Scalars['String']['input']>
  partOfPurchase?: InputMaybe<Scalars['Boolean']['input']>
  remainingTermMonths?: InputMaybe<Scalars['Int']['input']>
  reoId?: InputMaybe<Scalars['Int']['input']>
  resubordinate?: InputMaybe<Scalars['Boolean']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  toBePaidOff?: InputMaybe<Scalars['Boolean']['input']>
  totalTermMonths?: InputMaybe<Scalars['Int']['input']>
  unpaidBalance?: InputMaybe<Scalars['Float']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type SaveNonBorrowingSpouseInput = {
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type SaveRealEstateOwnedInputSchema = {
  application_id?: InputMaybe<Scalars['Int']['input']>
  apt?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  currentOccupancy?: InputMaybe<Scalars['String']['input']>
  expenses?: InputMaybe<Scalars['Float']['input']>
  grossRentalIncome?: InputMaybe<Scalars['Float']['input']>
  hoaDuesMonthly?: InputMaybe<Scalars['Float']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  includesEscrows?: InputMaybe<Scalars['Boolean']['input']>
  intendedOccupancy?: InputMaybe<Scalars['String']['input']>
  intendedType?: InputMaybe<Scalars['String']['input']>
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>
  isSubject?: InputMaybe<Scalars['Boolean']['input']>
  maintenanceExpensesMonthly?: InputMaybe<Scalars['Float']['input']>
  netProceeds?: InputMaybe<Scalars['Float']['input']>
  netRentalIncome?: InputMaybe<Scalars['Float']['input']>
  numberOfUnits?: InputMaybe<Scalars['Int']['input']>
  occupancyRate?: InputMaybe<Scalars['Float']['input']>
  propertyInsuranceMonthly?: InputMaybe<Scalars['Float']['input']>
  propertyTaxesMonthly?: InputMaybe<Scalars['Float']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyValue?: InputMaybe<Scalars['Float']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type SaveSageContactAssignmentInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  assignmentId?: InputMaybe<Scalars['String']['input']>
  borrowerPhone?: InputMaybe<Scalars['String']['input']>
  contactId?: InputMaybe<Scalars['String']['input']>
  dateEnded?: InputMaybe<Scalars['String']['input']>
  dateSigned?: InputMaybe<Scalars['String']['input']>
  referredBorrower?: InputMaybe<Scalars['Boolean']['input']>
}

export type SaveSageContactInput = {
  broker?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  contactId?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  joinDate?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  realStateLicense?: InputMaybe<Scalars['String']['input']>
  referrer?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  yearsExperience?: InputMaybe<Scalars['Int']['input']>
}

export type SaveTaskInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<TaskType>
}

export type Section = {
  __typename?: 'Section'
  fees: Array<SectionFees>
  total: Scalars['Float']['output']
}

export type SectionFees = {
  __typename?: 'SectionFees'
  amount: Scalars['Float']['output']
  description: Scalars['String']['output']
  lineNumber?: Maybe<Scalars['String']['output']>
}

export type SectionFeesInput = {
  amount: Scalars['Float']['input']
  description: Scalars['String']['input']
  lineNumber?: InputMaybe<Scalars['String']['input']>
}

export type SectionFeesOptional = {
  __typename?: 'SectionFeesOptional'
  fees?: Maybe<Array<SectionFees>>
  total: Scalars['Float']['output']
}

export type SectionFeesOptionalInput = {
  fees?: InputMaybe<Array<SectionFeesInput>>
  total: Scalars['Float']['input']
}

export type SectionInput = {
  fees: Array<SectionFeesInput>
  total: Scalars['Float']['input']
}

export enum SelfEmploymentBusinessType {
  Corporation = 'Corporation',
  Llc = 'LLC',
  Partnership = 'Partnership',
  SCorp = 'SCorp',
  SoleProprietorship = 'SoleProprietorship',
}

export type SendSmsResponse = {
  __typename?: 'SendSMSResponse'
  from?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  to?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type Sender = {
  __typename?: 'Sender'
  isLO?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type ServicerLeadSchema = {
  __typename?: 'ServicerLeadSchema'
  address: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  coBorrowerEmail?: Maybe<Scalars['String']['output']>
  coBorrowerFirstName?: Maybe<Scalars['String']['output']>
  coBorrowerLastName?: Maybe<Scalars['String']['output']>
  coBorrowerPhone?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  creditScore: Scalars['Int']['output']
  currentMonthlyPayment: Scalars['Float']['output']
  currentRate: Scalars['Float']['output']
  email: Scalars['String']['output']
  escrowLienAmount?: Maybe<Scalars['Float']['output']>
  escrowShortOrOver?: Maybe<Scalars['Float']['output']>
  firstName: Scalars['String']['output']
  floodInsurance?: Maybe<Scalars['Float']['output']>
  homeownersInsurance?: Maybe<Scalars['Float']['output']>
  id: Scalars['Int']['output']
  lastName: Scalars['String']['output']
  loanAmount: Scalars['Float']['output']
  loanMatchOffers?: Maybe<Array<Maybe<LoanMatchOfferSchema>>>
  loanNumber: Scalars['String']['output']
  loanToValue: Scalars['Float']['output']
  phone: Scalars['String']['output']
  pmiMiPaymentAmountMonthly?: Maybe<Scalars['Float']['output']>
  propertyTax?: Maybe<Scalars['Float']['output']>
  propertyType: Scalars['String']['output']
  propertyUse: Scalars['String']['output']
  propertyValue?: Maybe<Scalars['Float']['output']>
  remainingBalance?: Maybe<Scalars['Float']['output']>
  remainingMonths: Scalars['Int']['output']
  source: Scalars['String']['output']
  state?: Maybe<Scalars['String']['output']>
  taxesAndInsuranceValue?: Maybe<Scalars['Float']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  uuid: Scalars['String']['output']
  veteran?: Maybe<Scalars['String']['output']>
  zipCode: Scalars['String']['output']
}

export type SetConfigurationArgs = {
  configurationFields?: InputMaybe<ConfigurationFieldInput>
  loanOfficerId?: InputMaybe<Scalars['Int']['input']>
}

export type SoftPullResponse = {
  __typename?: 'SoftPullResponse'
  mortgageRateEstimate?: Maybe<Array<Maybe<MortgageEstimate>>>
  success: Scalars['Boolean']['output']
}

export enum SortDirectionType {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SortInput = {
  direction?: InputMaybe<SortDirectionType>
  field?: InputMaybe<Scalars['String']['input']>
}

export enum StateAbbreviation {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

export type StateResult = {
  __typename?: 'StateResult'
  state?: Maybe<Scalars['String']['output']>
}

export enum Status {
  NtlRatesDisplayed = 'NTLRatesDisplayed',
  QCreateAccountSectionTouched = 'QCreateAccountSectionTouched',
  QDeclarationsSectionTouched = 'QDeclarationsSectionTouched',
  QEmploymentSectionTouched = 'QEmploymentSectionTouched',
  QExpensesSectionTouched = 'QExpensesSectionTouched',
  QFormCompleted = 'QFormCompleted',
  QNoRatesDisplayed = 'QNoRatesDisplayed',
  QPersonalInfoSectionTouched = 'QPersonalInfoSectionTouched',
  QPropertyInfoSectionTouched = 'QPropertyInfoSectionTouched',
  QRateSelected = 'QRateSelected',
  QRatesDisplayed = 'QRatesDisplayed',
  AccountLinkingCompleted = 'accountLinkingCompleted',
  AccountLinkingTouched = 'accountLinkingTouched',
  AdditionalConditionsSent = 'additionalConditionsSent',
  AlfieCompleted = 'alfieCompleted',
  ApplicationCreated = 'applicationCreated',
  ApplicationImported = 'applicationImported',
  ApplyFlowCompleted = 'applyFlowCompleted',
  ApplyFlowTouched = 'applyFlowTouched',
  Approved = 'approved',
  BorrowerPortalRateSelected = 'borrowerPortalRateSelected',
  BorrowerPortalRatesDisplayed = 'borrowerPortalRatesDisplayed',
  BsmApplicationCreated = 'bsmApplicationCreated',
  BsmApplicationStarted = 'bsmApplicationStarted',
  BsmApplicationVerified = 'bsmApplicationVerified',
  BsmAppraisal = 'bsmAppraisal',
  BsmArchived = 'bsmArchived',
  BsmCanceled = 'bsmCanceled',
  BsmChoseLoan = 'bsmChoseLoan',
  BsmClosed = 'bsmClosed',
  BsmClosing = 'bsmClosing',
  BsmDeclined = 'bsmDeclined',
  BsmImportWaiting = 'bsmImportWaiting',
  BsmOnHold = 'bsmOnHold',
  BsmPendingCancellation = 'bsmPendingCancellation',
  BsmPendingEscalatedReview = 'bsmPendingEscalatedReview',
  BsmPendingWithdrawal = 'bsmPendingWithdrawal',
  BsmSkippedImportBankAccount = 'bsmSkippedImportBankAccount',
  BsmSubmittedApplication = 'bsmSubmittedApplication',
  BsmUnderwriting = 'bsmUnderwriting',
  BsmVerifiedIncomeAndExpenses = 'bsmVerifiedIncomeAndExpenses',
  BsmWaitingForCoBorrower = 'bsmWaitingForCoBorrower',
  BsmWithdrawn = 'bsmWithdrawn',
  CallRequested = 'callRequested',
  ClearToClose = 'clearToClose',
  ClearToPurchase = 'clearToPurchase',
  ConditionReview = 'conditionReview',
  CounterOfferApproved = 'counterOfferApproved',
  DocsBack = 'docsBack',
  DocsDrawn = 'docsDrawn',
  DocsOrdered = 'docsOrdered',
  DocsOut = 'docsOut',
  DocsUploaded = 'docsUploaded',
  DocumentCheck = 'documentCheck',
  DocumentCheckFailed = 'documentCheckFailed',
  FannieFlowCompleted = 'fannieFlowCompleted',
  FannieFlowTouched = 'fannieFlowTouched',
  FinalDocs = 'finalDocs',
  FinalUnderwriting = 'finalUnderwriting',
  Funded = 'funded',
  HomeEquityFlowCompleted = 'homeEquityFlowCompleted',
  HomeEquityFlowTouched = 'homeEquityFlowTouched',
  HomeEquityLeadSubmitted = 'homeEquityLeadSubmitted',
  HomeEquityManualReview = 'homeEquityManualReview',
  HomeEquityNoOffersFound = 'homeEquityNoOffersFound',
  HomeEquityOffersDisplayed = 'homeEquityOffersDisplayed',
  InUnderwriting = 'inUnderwriting',
  InboundCallAnswered = 'inboundCallAnswered',
  InboundCallUnanswered = 'inboundCallUnanswered',
  InvestorConditions = 'investorConditions',
  InvestorConditionsSent = 'investorConditionsSent',
  LeadReceived = 'leadReceived',
  LenderAdditionalInfoNeeded = 'lenderAdditionalInfoNeeded',
  LenderAdverse = 'lenderAdverse',
  LenderApplicationApprovedNotAccepted = 'lenderApplicationApprovedNotAccepted',
  LenderApplicationLocked = 'lenderApplicationLocked',
  LenderApproved = 'lenderApproved',
  LenderApprovedPendingLock = 'lenderApprovedPendingLock',
  LenderApprovedWithConditions = 'lenderApprovedWithConditions',
  LenderApprovedWithConditionsNewConditions = 'lenderApprovedWithConditionsNewConditions',
  LenderCicPending = 'lenderCICPending',
  LenderCancelled = 'lenderCancelled',
  LenderCancelledDuplicate = 'lenderCancelledDuplicate',
  LenderCancelledOther = 'lenderCancelledOther',
  LenderClearToClose = 'lenderClearToClose',
  LenderClosed = 'lenderClosed',
  LenderClosedPackageReceivedFromTitle = 'lenderClosedPackageReceivedFromTitle',
  LenderClosing = 'lenderClosing',
  LenderClosingConditionsAvailable = 'lenderClosingConditionsAvailable',
  LenderClosingDisclosureSent = 'lenderClosingDisclosureSent',
  LenderClosingOrSigningHasBeenScheduled = 'lenderClosingOrSigningHasBeenScheduled',
  LenderClosingPackageReceived = 'lenderClosingPackageReceived',
  LenderCollateralReview = 'lenderCollateralReview',
  LenderCollateralSentToWarehouse = 'lenderCollateralSentToWarehouse',
  LenderCompletion = 'lenderCompletion',
  LenderConditionalApproval = 'lenderConditionalApproval',
  LenderConditionallyApproved = 'lenderConditionallyApproved',
  LenderCreditPackageSubmitted = 'lenderCreditPackageSubmitted',
  LenderCreditReview = 'lenderCreditReview',
  LenderDeclined = 'lenderDeclined',
  LenderDenied = 'lenderDenied',
  LenderDiligenceReview = 'lenderDiligenceReview',
  LenderDisclosureSubmitted = 'lenderDisclosureSubmitted',
  LenderDocsOut = 'lenderDocsOut',
  LenderDocsOutToSettlementAgent = 'lenderDocsOutToSettlementAgent',
  LenderEscalatedReview = 'lenderEscalatedReview',
  LenderFileClosedForIncompleteness = 'lenderFileClosedForIncompleteness',
  LenderFileImported = 'lenderFileImported',
  LenderFileImportedProblemUpload = 'lenderFileImportedProblemUpload',
  LenderFinalApproval = 'lenderFinalApproval',
  LenderFinalClosingDisclosureInReview = 'lenderFinalClosingDisclosureInReview',
  LenderFinalClosingDisclosureReviewComplete = 'lenderFinalClosingDisclosureReviewComplete',
  LenderFullConditionsSignOff = 'lenderFullConditionsSignOff',
  LenderFullPackageReceivedAwaitingReview = 'lenderFullPackageReceivedAwaitingReview',
  LenderFullPackageReceivedIncomplete = 'lenderFullPackageReceivedIncomplete',
  LenderFunded = 'lenderFunded',
  LenderFundingComplete = 'lenderFundingComplete',
  LenderInClosing = 'lenderInClosing',
  LenderInPreclear = 'lenderInPreclear',
  LenderIncompleteSubmission = 'lenderIncompleteSubmission',
  LenderInquiryOnly = 'lenderInquiryOnly',
  LenderIntentToProceedReviewCompleted = 'lenderIntentToProceedReviewCompleted',
  LenderLeOnlyDisclosure = 'lenderLEOnlyDisclosure',
  LenderLoanCreated = 'lenderLoanCreated',
  LenderLoanDisbursedByLender = 'lenderLoanDisbursedByLender',
  LenderLoanRegistered = 'lenderLoanRegistered',
  LenderLoanRescinded = 'lenderLoanRescinded',
  LenderLoanSubmitted = 'lenderLoanSubmitted',
  LenderPmDocsOut = 'lenderPMDocsOut',
  LenderPmFunded = 'lenderPMFunded',
  LenderPmSuspended = 'lenderPMSuspended',
  LenderPartialConditionsSignOff = 'lenderPartialConditionsSignOff',
  LenderPostClosing = 'lenderPostClosing',
  LenderPreclearQueue = 'lenderPreclearQueue',
  LenderRegistered = 'lenderRegistered',
  LenderRegistrationIncomplete = 'lenderRegistrationIncomplete',
  LenderRejected = 'lenderRejected',
  LenderRequestClosingDocs = 'lenderRequestClosingDocs',
  LenderRequestForDisbursement = 'lenderRequestForDisbursement',
  LenderRescinded = 'lenderRescinded',
  LenderSetup = 'lenderSetup',
  LenderStarted = 'lenderStarted',
  LenderSubmittedToUnderwriting = 'lenderSubmittedToUnderwriting',
  LenderSuspended = 'lenderSuspended',
  LenderUwmSuspended = 'lenderUWMSuspended',
  LenderUnderwriting = 'lenderUnderwriting',
  LenderUnknownStatus = 'lenderUnknownStatus',
  LenderUnprocessedCancellation = 'lenderUnprocessedCancellation',
  LenderUnprocessedDecline = 'lenderUnprocessedDecline',
  LenderWaitingForFullPackage = 'lenderWaitingForFullPackage',
  LenderWholesaleClearToClose = 'lenderWholesaleClearToClose',
  LenderWithdrawn = 'lenderWithdrawn',
  LoanCanceled = 'loanCanceled',
  LoanClosed = 'loanClosed',
  LoanDenied = 'loanDenied',
  LoanOnHold = 'loanOnHold',
  LoanOpen = 'loanOpen',
  LoanPurchased = 'loanPurchased',
  LoanRejected = 'loanRejected',
  LoanShipped = 'loanShipped',
  LoanSold = 'loanSold',
  LoanSuspended = 'loanSuspended',
  LoanWithdrawn = 'loanWithdrawn',
  LockRejected = 'lockRejected',
  LockRequested = 'lockRequested',
  Migrated = 'migrated',
  PhoneFlowCompleted = 'phoneFlowCompleted',
  PhoneFlowTouched = 'phoneFlowTouched',
  PlaidFlowCompleted = 'plaidFlowCompleted',
  PlaidFlowTouched = 'plaidFlowTouched',
  PreApproved = 'preApproved',
  PreDocQc = 'preDocQC',
  PrePricingFlowCompleted = 'prePricingFlowCompleted',
  PrePricingFlowTouched = 'prePricingFlowTouched',
  PrePricingNoRatesDisplayed = 'prePricingNoRatesDisplayed',
  PrePricingRatesDisplayed = 'prePricingRatesDisplayed',
  PreProcessing = 'preProcessing',
  PreQual = 'preQual',
  PreUnderwriting = 'preUnderwriting',
  Processing = 'processing',
  ReApp = 'reApp',
  ReadyForSale = 'readyForSale',
  Recorded = 'recorded',
  Registered = 'registered',
  SageQbsmTakeoverNoRatesDisplayed = 'sageQBSMTakeoverNoRatesDisplayed',
  SageQbsmTakeoverRatesDisplayed = 'sageQBSMTakeoverRatesDisplayed',
  SageQNoRatesDisplayed = 'sageQNoRatesDisplayed',
  SageQRateSelected = 'sageQRateSelected',
  SageQRatesDisplayed = 'sageQRatesDisplayed',
  ServicerDataImported = 'servicerDataImported',
  SsnUploadCompleted = 'ssnUploadCompleted',
  SsnUploadTouched = 'ssnUploadTouched',
  Submitted = 'submitted',
}

export type StoryblokSchemaLink = {
  __typename?: 'StoryblokSchemaLink'
  cached_url?: Maybe<Scalars['String']['output']>
  fieldtype?: Maybe<Scalars['String']['output']>
  linktype?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type SuccessPage = {
  __typename?: 'SuccessPage'
  body?: Maybe<Scalars['String']['output']>
  component: Scalars['String']['output']
  name: Scalars['String']['output']
  primaryCtaLink?: Maybe<StoryblokSchemaLink>
  primaryCtaTitle?: Maybe<Scalars['String']['output']>
  secondaryCtaLink?: Maybe<StoryblokSchemaLink>
  secondaryCtaTitle?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type SyncStatuses = {
  __typename?: 'SyncStatuses'
  conditions?: Maybe<ApplicationExternalEventSchema>
  conversations?: Maybe<ApplicationExternalEventSchema>
  creation?: Maybe<ApplicationExternalEventSchema>
  credit?: Maybe<ApplicationExternalEventSchema>
  eConsent?: Maybe<ApplicationExternalEventSchema>
  import?: Maybe<ApplicationExternalEventSchema>
  license?: Maybe<ApplicationExternalEventSchema>
  pricingScenario?: Maybe<ApplicationExternalEventSchema>
  template?: Maybe<ApplicationExternalEventSchema>
  texas?: Maybe<ApplicationExternalEventSchema>
  title?: Maybe<ApplicationExternalEventSchema>
}

export type Task = {
  __typename?: 'Task'
  configuration?: Maybe<Scalars['JSON']['output']>
  id?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  type?: Maybe<TaskType>
}

export enum TaskStatus {
  Completed = 'completed',
  InProgress = 'inProgress',
  Requested = 'requested',
}

export enum TaskType {
  MiniFlow = 'miniFlow',
}

export type TimeZoneResult = {
  __typename?: 'TimeZoneResult'
  offSetTime?: Maybe<Scalars['Int']['output']>
  timeZoneName?: Maybe<Scalars['String']['output']>
}

/**
 * Unified payload for timeline events (condition and attachment events)
 * Check entityType to determine which fields are relevant
 */
export type TimelineEventPayload = {
  __typename?: 'TimelineEventPayload'
  attachmentId?: Maybe<Scalars['Int']['output']>
  attachmentIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  attachmentUuid?: Maybe<Scalars['String']['output']>
  attachmentUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  communicationType?: Maybe<Scalars['String']['output']>
  conditionId?: Maybe<Scalars['Int']['output']>
  conditionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  confidence?: Maybe<Scalars['Float']['output']>
  documentRequestIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  documentRequestUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  encompassConditionId?: Maybe<Scalars['String']['output']>
  encompassLoanId?: Maybe<Scalars['String']['output']>
  fileName?: Maybe<Scalars['String']['output']>
  fileType?: Maybe<Scalars['String']['output']>
  incomingStatus?: Maybe<Scalars['String']['output']>
  localStatus?: Maybe<Scalars['String']['output']>
  newStatus?: Maybe<Scalars['String']['output']>
  pendingTrackingId?: Maybe<Scalars['Int']['output']>
  previousStatus?: Maybe<Scalars['String']['output']>
  reasonCode?: Maybe<Scalars['String']['output']>
  skipReason?: Maybe<Scalars['String']['output']>
  syncOutcome?: Maybe<Scalars['String']['output']>
}

export type TridCountData = {
  __typename?: 'TridCountData'
  address?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  dateTriggered?: Maybe<Scalars['String']['output']>
  dueDate?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  iceboxId?: Maybe<Scalars['Int']['output']>
  iceboxNote?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  lenderName?: Maybe<Scalars['String']['output']>
  loanOfficerName?: Maybe<Scalars['String']['output']>
  mslName?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  tridDaysLeft?: Maybe<Scalars['Int']['output']>
}

export type TridCountRequest = {
  excludeIcebox?: InputMaybe<Scalars['Boolean']['input']>
  triggeredOnOrAfter: Scalars['String']['input']
}

export type TridMetadataSchema = {
  __typename?: 'TridMetadataSchema'
  applicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  dateTriggered?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  disclosedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  income?: Maybe<Scalars['Boolean']['output']>
  loanAmount?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['Boolean']['output']>
  propertyAddress?: Maybe<Scalars['Boolean']['output']>
  propertyValue?: Maybe<Scalars['Boolean']['output']>
  ssnAlias?: Maybe<Scalars['Boolean']['output']>
  tridCount?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type UpdateAttachmentInput = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>
  uuid?: InputMaybe<Scalars['String']['input']>
}

export type UpdateLenderLoanIdRequest = {
  applicationId: Scalars['Int']['input']
  lenderLoanId: Scalars['String']['input']
}

export type UpdateLoanSetupChecklistItemRequest = {
  checkedAt: Scalars['String']['input']
  checkedBy: Scalars['Int']['input']
  checklistItemId: Scalars['Int']['input']
}

export type UpdateLockFormRequest = {
  administrator?: InputMaybe<Scalars['String']['input']>
  applicationId: Scalars['Int']['input']
  besmarteeLoanId?: InputMaybe<Scalars['String']['input']>
  dateLocked?: InputMaybe<Scalars['String']['input']>
  disclosureSetupAdmin?: InputMaybe<Scalars['String']['input']>
  isManual?: InputMaybe<Scalars['Boolean']['input']>
  lenderLoanId?: InputMaybe<Scalars['String']['input']>
  loanSetupAdmin?: InputMaybe<Scalars['String']['input']>
  loanSetupAnalyst?: InputMaybe<Scalars['String']['input']>
  lockDeskNotes?: InputMaybe<Scalars['String']['input']>
  lockFormId: Scalars['Int']['input']
  lockProgress?: InputMaybe<Scalars['String']['input']>
  manualEsign?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  processingTeam?: InputMaybe<Scalars['String']['input']>
}

export type User = {
  __typename?: 'User'
  auth0Id?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  ipAddress?: Maybe<Scalars['String']['output']>
  lastLoginAt?: Maybe<Scalars['String']['output']>
  timeZone?: Maybe<Scalars['String']['output']>
  timeZoneOffset?: Maybe<Scalars['Float']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type UserApplicationSchema = {
  __typename?: 'UserApplicationSchema'
  address?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  applicationGuid?: Maybe<Scalars['String']['output']>
  applicationId?: Maybe<Scalars['Int']['output']>
  borrowerInfo?: Maybe<BorrowerInfoSchema>
  borrowerPortalStatus?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  coBorrowerInfo?: Maybe<BorrowerInfoSchema>
  createdAt?: Maybe<Scalars['String']['output']>
  elloStatus?: Maybe<Scalars['String']['output']>
  isIceBox?: Maybe<Scalars['Boolean']['output']>
  lenderLoanId?: Maybe<Scalars['String']['output']>
  loanPurpose?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type UserLocation = {
  __typename?: 'UserLocation'
  userLatitude?: Maybe<Scalars['Float']['output']>
  userLongitude?: Maybe<Scalars['Float']['output']>
}

export type ValidationCondition = {
  __typename?: 'ValidationCondition'
  is: Scalars['String']['output']
  reference: Scalars['String']['output']
}

export type ValidationRule = {
  __typename?: 'ValidationRule'
  component?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  params: Scalars['String']['output']
}

export type Validations = {
  __typename?: 'Validations'
  component?: Maybe<Scalars['String']['output']>
  condition?: Maybe<Array<Maybe<ValidationCondition>>>
  rules?: Maybe<Array<Maybe<ValidationRule>>>
  validatorType: Scalars['String']['output']
}

export type VerifyRateLockRequest = {
  discountOrCreditAmount?: InputMaybe<Scalars['Float']['input']>
  discountPoints?: InputMaybe<Scalars['Float']['input']>
  discountPointsAsDollarAmount?: InputMaybe<Scalars['Float']['input']>
  lockFormId: Scalars['Int']['input']
  lockId?: InputMaybe<Scalars['String']['input']>
  principleAndInterestPayment?: InputMaybe<Scalars['Float']['input']>
  rate?: InputMaybe<Scalars['Float']['input']>
}

export type VerifyWithLastFourPhoneResult = {
  __typename?: 'VerifyWithLastFourPhoneResult'
  applicationId?: Maybe<Scalars['Int']['output']>
  hasAccount?: Maybe<Scalars['Boolean']['output']>
  phoneVerified?: Maybe<Scalars['Boolean']['output']>
  zipCodeVerified?: Maybe<Scalars['Boolean']['output']>
}

export type Veteran = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  firstTimeUsingVaLoan?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<VeteranType>
}

export enum VeteranType {
  NationalGuard = 'NationalGuard',
  NotApplicable = 'NotApplicable',
  RegularMilitary = 'RegularMilitary',
  Reserves = 'Reserves',
  SpouseOfRegularMilitary = 'SpouseOfRegularMilitary',
  SpouseOfReserveMilitary = 'SpouseOfReserveMilitary',
}

export type VisibleIfCondition =
  | VisibleIfMultiCondition
  | VisibleIfPrebuiltCondition
  | VisibleIfSingleCondition

export type VisibleIfMultiCondition = {
  __typename?: 'VisibleIfMultiCondition'
  conditions: Array<VisibleIfCondition>
  operator: Scalars['String']['output']
}

export type VisibleIfPrebuiltCondition = {
  __typename?: 'VisibleIfPrebuiltCondition'
  name: Scalars['String']['output']
}

export type VisibleIfSingleCondition = {
  __typename?: 'VisibleIfSingleCondition'
  answer: Scalars['String']['output']
  conditional: Scalars['String']['output']
  question: Scalars['String']['output']
}

export type InitializeResponse = {
  __typename?: 'initializeResponse'
  applicationGuid: Scalars['String']['output']
  applicationId: Scalars['Int']['output']
  applicationLeadSource?: Maybe<Scalars['String']['output']>
}

export type LoanEstimateSections = {
  __typename?: 'loanEstimateSections'
  A: Section
  B: Section
  C: Section
  D: Section
  E: Section
  F: Section
  G: Section
  H: SectionFeesOptional
  I: Section
  J: Section
  Others: Section
}
